const langObj = {
    'format': 'Format',
    'addRemoveProductDialog.addProductIfExists': 'Add product even to orders where it already exists',
    'addRemoveProductDialog.addProducts': 'Add products (promo) to orders',
    'addRemoveProductDialog.removeProducts': 'Remove products (promo) from orders',
    'addRemoveProductDialog.removeOrders.info': 'After saving, the entered products will be removed from the marked orders. If the marked order does not contain the specified product, no action will be taken for the order.',
    'apiErrors.PRODUCT_SET_CONTAINS_PRODUCTS': 'SKU: {{sku}} product type cannot be changed, because it is currently defined as a Product set. Create a new SKU or contact customercare@skladon.cz',
    'apiErrors.PRODUCT_SET_USED_IN_ORDERS': 'Product set has been used in orders and cannot be changed from Products set type! You should create a new product!',
    'apiErrors.serverErrorTitle': 'Error calling API',
    'login.loginTitle': 'Log in',
    'login.yourEmail': 'Your e-mail',
    'login.password': 'Password',
    'login.forgetPassword': 'Forgot your password? Click ',
    'login.forgetPasswordClick': 'here',
    'login.logIn': 'Log in',
    'login.langTooltip': 'Select language',
    'language': 'Language',
    'login.wrongLoginPassword': 'Your login or password is wrong',
    'login.sessionExpired': 'Your session has expired. Please log in again.',
    'login.passwordReset': 'Password reset',
    'login.passwordReset.email': 'Your e-mail',
    'login.passwordChanged': 'Your password has been changed. Please log in with the new password.',
    'login.logInHere': 'Log in ',
    'login.logInHereClick': 'here',
    'login.resetPassword': 'Send e-mail',
    'login.resetPasswordSuccess': 'An email with password information has been sent to you',
    'login.resetPasswordError': 'User with given e-mail not found',
    'login.email': 'Email',
    'integration.statusesMappingTable.uid': 'E-shop UID',
    'integration.statusesMappingTable.name': 'E-shop order status',
    'integration.statusesMappingTable.value': 'MySkladon order status',
    'integration.statusesMappingTable.import': 'Import = E-shop -> MyS',
    'integration.statusesMappingTable.export': 'Export = MyS -> E-shop',
    'integration.statusesMappingTable.saved': 'Saved',
    'integration.shippingMethodsTable.uid': 'E-shop UID',
    'integration.shippingMethodsTable.name': 'E-shop shipping method',
    'integration.shippingMethodsTable.shipper': 'MySkladon shipper',
    'integration.shippingMethodsTable.import': 'Import = E-shop -> MyS',
    'integration.shippingMethodsTable.shipperServiceCode': 'MySkladon shipper service',
    'integration.shippingMethodsTable.branchId': 'Branch ID (B2Bc)',
    'integration.shippingMethodsTable.export': 'Export = MyS -> E-shop',
    'integration.shippingMethodsTable.saved': 'Saved',
    'integration.paymentMethodsTable.uid': 'E-shop UID',
    'integration.paymentMethodsTable.name': 'E-shop payment method',
    'integration.paymentMethodsTable.paymentMethod': 'MySkladon payment method',
    'integration.paymentMethodsTable.import': 'Import = E-shop -> MyS',
    'integration.paymentMethodsTable.paid': 'MySkladon paid',
    'integration.paymentMethodsTable.saved': 'Saved',
    'integration.mappingTable.saved.yes': 'Yes',
    'integration.mappingTable.saved.notSaved': 'Not saved',
    'integrationDetail.statuses': 'Mapping order status',
    'integrationDetail.shippingMethods': 'Mapping shipping methods',
    'integrationDetail.paymentMethods': 'Mapping payment methods',
    'integrationDetail.others': 'Others',
    'integrationDetail.productType': 'Currency and expedition method for newly created products',
    'integrationDetail.productTypeDescription': 'Setting currency and expedition method for newly created products',
    'integrationDetail.productTypeLabel': 'Select value',
    'integrationDetail.orderType': 'B2B orders',
    'integrationDetail.orderTypeDescription': 'Setting Company ID for B2B orders from Shoptet',
    'integrationDetail.addOrderType': 'Add Company ID for B2B orders',
    'integrationDetail.retino': 'Retino',
    'integrationDetail.retinoDescription': 'Setting mapping for Retino',
    'integrationDetail.addRetinoMapping': 'Add Retino mapping',
    'integrationDetail.historyTab': 'History',
    'integrationDetail.historySectionAll': 'All sections',
    'integrationDetail.historySectionFilter': 'Section',
    'integrationDetail.historyEmpty': 'No history entries yet.',
    'integrationDetail.saveSuccess': 'Mapping has been saved',

    'integrationMappingHistory.entry': 'Integration mapping save',

    'integrationMappingHistory.newOrderStatuses': 'New order statuses',
    'integrationMappingHistory.orderStatusesEdited': 'Order statuses edited',
    'integrationMappingHistory.newShippingMethods': 'New shipping methods',
    'integrationMappingHistory.shippingMethodsEdited': 'Shipping methods edited',
    'integrationMappingHistory.newPaymentMethods': 'New payment methods',
    'integrationMappingHistory.paymentMethodsEdited': 'Payment methods edited',
    'integrationMappingHistory.newB2bOrders': 'New B2B orders',
    'integrationMappingHistory.b2bOrdersEdited': 'B2B orders edited',
    'integrationMappingHistory.b2bOrdersDeleted': 'B2B orders deleted',
    'integrationMappingHistory.currencyExpeditionSet': 'Currency and expedition method set',
    'integrationMappingHistory.currencyExpeditionEdited': 'Currency and expedition method edited',
    'integrationMappingHistory.othersDeleted': 'Deleted',
    'integrationMappingHistory.newRetinoMappings': 'New Retino mappings',
    'integrationMappingHistory.retinoMappingsEdited': 'Retino mappings edited',

    'integrationMappingHistory.columns.eshopUid': 'E-shop UID',
    'integrationMappingHistory.columns.eshopName': 'E-shop name',
    'integrationMappingHistory.columns.mysStatus': 'MySkladon status',
    'integrationMappingHistory.columns.import': 'Import',
    'integrationMappingHistory.columns.export': 'Export',
    'integrationMappingHistory.columns.shipper': 'Shipper',
    'integrationMappingHistory.columns.serviceCode': 'Service',
    'integrationMappingHistory.columns.branchId': 'Branch ID (B2Bc)',
    'integrationMappingHistory.columns.paymentMethod': 'Payment method',
    'integrationMappingHistory.columns.paid': 'Paid',
    'integrationMappingHistory.columns.uid': 'UID / Company ID',
    'integrationMappingHistory.columns.name': 'Name',
    'integrationMappingHistory.columns.value': 'Value',
    'integrationMappingHistory.columns.summary': 'Summary',
    'integrationMappingHistory.columns.key': 'Key',
    'integration.othersTable.key': 'Key',
    'integration.othersTable.uid': 'Company ID',
    'integration.othersTable.name': 'Order type',
    'integration.othersTable.import': 'Import = E-shop -> MyS',
    'integration.othersTable.export': 'Export = MyS -> E-shop',
    'integration.othersTable.actions': 'Actions',
    'integration.othersTable.value': 'Value',
    'integration.retinoTable.key': 'Key',
    'integration.retinoTable.uid': 'UID',
    'integration.retinoTable.value': 'Value',
    'integration.retinoTable.name': 'Name',
    'integration.retinoTable.import': 'Import = E-shop -> MyS',
    'integration.retinoTable.export': 'Export = MyS -> E-shop',
    'integration.retinoTable.actions': 'Actions',
    'integration.action.mappingDetail': 'Mapping detail',
    'resetPassword.title': 'Change password',
    'resetPassword.newPassword': 'New password',
    'resetPassword.comparePassword': 'Compare password',
    'resetPassword.sumbit': 'Save password',
    'resetPassword.login': 'Log in',
    'resetPassword.successx': 'Password has been updated, you can now log in here:',
    'resetPassword.success': 'Password has been updated, you can now log in',
    'resetPassword.wrongData': 'Your session has been expired',
    'resetPassword.incorretPasswordText':
        'The new password needs lowerCase, uppercase characters, numbers and length bigger than 7',
    'resetPassword.incorretPasswordMatchText': 'Passwords do not match',

    'sidebar.overview': 'Dashboard',
    'sidebar.tasks': 'Task list',
    'sidebar.orders': 'Orders',
    'sidebar.claims': 'Claims',
    'sidebar.returns': 'Returns',
    'sidebar.receivings': 'Receivings',
    'sidebar.transports': 'Transports',
    'sidebar.products': 'Products',
    'sidebar.productTrash': 'Product / EAN errors',
    'productTrash.title': 'Errors for product and EAN synchronization',
    'productTrash.noPermission': 'You do not have permission to view this list.',
    'productTrash.loadError': 'Failed to load records.',
    'productTrash.resolveError': 'Failed to update the record resolved state.',
    'productTrash.resolve': 'Resolve',
    'productTrash.column.createdAt': 'Date',
    'productTrash.column.eventType': 'Event type',
    'productTrash.column.source': 'Source',
    'productTrash.column.sku': 'SKU',
    'productTrash.column.ean': 'EAN',
    'productTrash.column.message': 'Message',
    'productTrash.column.resolved': 'Resolved',
    'productTrash.source.DCIX_SYNC': 'WMS sync',
    'productTrash.source.UI': 'MyS UI',
    'productTrash.source.PIPES': 'PIPES',
    'productTrash.source.GWMS': 'GWMS',
    'productTrash.eventType.EAN_ALREADY_EXISTS': 'EAN already used for another product',
    'productTrash.eventType.SKU_CHANGE_REJECTED': 'SKU change not allowed',
    'productTrash.eventType.EAN_CONFLICT_DCIX_SYNC': 'EAN conflict for WMS sync',
    'productTrash.eventType.DUPLICATE_SKU_REJECTED': 'Duplicate SKU creation not allowed',
    'productTrash.eventType.EAN_WRITE_BLOCKED_BY_DCIX_LOCK': 'EAN write blocked by WMS lock',
    'productTrash.eventType.PER_ESHOP_PROPAGATION_SKIPPED': 'Per-eshop fields not propagated (identifier disabled)',
    'sidebar.documents': 'Documents',
    'sidebar.commands': 'Commands',
    'sidebar.users': 'User management',
    'sidebar.settings': 'Settings',
    'sidebar.admin': 'Admin',
    'sidebar.integration': 'Integration',
    'overview.title': 'Dashboard',
    'overview.ordersInStatuses.title': 'Current number of orders by status',
    'overview.ordersInStatuses.titleInfo': 'The number of orders according to their current status.',
    'overview.ordersInStatuses.titleDelivered': 'Delivered orders',
    'overview.ordersInStatuses.titleDeliveredInfo': 'The number of delivered orders for the selected time period',
    'overview.ordersInStatuses': 'Last 24 hours',
    'overview.ordersTimeOption.last24Hours': '24 hours',
    'overview.ordersTimeOption.last7Days': '7 days',
    'overview.ordersTimeOption.last30Days': '30 days',
    'overview.ordersTimeOption.last90Days': '90 days',
    'overview.today': 'Today',
    'overview.totalNotifications': '{{count}} notifications',
    'overview.totalTasks': '{{count}} tasks',
    'overview.ordersAttention': 'Orders requiring attention',
    'overview.ordersReason.productsNotAvailable': 'Products not available',
    'overview.ordersReason.incorrect': 'Incorrect',
    'overview.tasks': 'Task list',
    'overview.timeRange': 'Time range',
    'overview.type': 'Type',
    'overview.timePreview': 'Dashboard',
    'overview.timeOption.actualMonth': 'Current month',
    'overview.timeOption.lastMonth': 'Last month',
    'overview.timeOption.last30Days': 'Last 30 days',
    'overview.timeOption.last90Days': 'Last 90 days',
    'overview.timeOption.actualQuarter': 'Current quarter',
    'overview.timeOption.lastQuarter': 'Last quarter',
    'overview.timeOption.actualYear': 'Current year',
    'overview.orders': 'Orders',
    'overview.returns': 'Returns',
    'overview.receivings': 'Receivings',
    'overview.claims': 'Claims',
    'productsSelect.label': 'SKU | Name | EAN',
    'userProfil.title': 'Profile',
    'orders.title': 'Orders',
    'orders.allOrders': 'All orders',
    'orders.b2cOordes': 'B2C orders',
    'orders.transferOrders': 'Transfer orders',
    'orders.b2bOordes': 'B2B orders',
    'orders.codOrders': 'COD orders',
    'orders.expeditionPackages': 'Shipping packages',
    'orders.messagesOnExpeditionBox': 'Messages on a box',
    'orders.allProviders': 'All providers',
    'archive.toggle': 'Archive',
    'archive.tooltip': 'Show archive',
    'archive.banner': 'Archived record – read only',
    'orders.action.createNew': 'New',
    'orders.action.orderDetail': 'Order detail',
    'orders.action.createReturn': 'Create return',
    'orders.action.importOrders': 'Import orders',
    'orders.action.createClaim': 'Create claim',
    'orders.action.exportFile': 'Export orders',
    'orders.action.exportFileCOD': 'Export cash on delivery orders',
    'orders.action.exportWithProducts': 'Export orders with products',
    'orders.action.exportWithProductsFileName': 'Export orders with products',
    'orders.action.exportWithSummarizedProductsFileName': 'Export orders with products summarized',
    'orders.action.exportFileName': 'Export orders',
    'orders.action.exportFileNameCOD': 'Export cash on delivery orders',
    'orders.action.reorderShipping': 'Reorder shipping',
    'orders.action.reorderShippingText': 'Do you really want to reorder shipping for {{count}} orders?',
    'orders.action.dowlonadCn22': 'Download files to CN22',
    'orders.action.synchronizeDcix': 'Synchronize orders to DCIx',
    'orders.action.synchronizeDcixText': 'Do you really want to synchronize {{count}} orders?',
    'orders.action.synchronizeTable': 'Synchronize table',
    'orders.action.changeStatuses': 'Change order status',
    'orders.action.changeStatusesText': 'Do you really want to change status for {{count}} selected orders to:',
    'orders.action.pickCancelReason': 'Please select cancel reason:',
    'orders.action.allowExpeditions': 'Change Allow expedition',
    'orders.action.allowExpeditionsText': 'Do you really want to change Allow expedition for {{count}} selected orders to:',
    'orders.action.printFiles': 'Change print the files',
    'orders.action.printFilesText': 'Do you really want to change print the files on {{count}} orders to:',
    'orders.action.addRemoveProducts': 'Edit products in order',
    'orders.action.addRemoveProductsText': 'Do you really want to edit products (promos) {{count}} seletected orders to:',
    'orders.table.providerName': 'E-shop',
    'orders.table.orderId': 'Order ID',
    'orders.table.eshopId': 'E-shop ID',
    'orders.table.recipientName': 'Recipient name',
    'orders.table.invoiceNumber': 'Invoice number',
    'orders.table.date': 'Created at',
    'orders.table.trackingNumber': 'Tracking number',
    'orders.table.returnTrackingNumber': 'Return tracking number',
    'orders.table.exchangeTrackingNumber': 'Exchange service TN',
    'orders.table.shipper': 'Shipper',
    'orders.table.status': 'Status',
    'orders.table.allowExpedition': 'Allow expedition',
    'orders.table.actions': 'Actions',
    'orders.table.partnerOrderId': 'Partner order ID',
    'orders.table.recipientAttentionName': 'Recipient attention name',
    'orders.table.recipientEmail': 'Recipient e-mail',
    'orders.table.recipientPhone': 'Recipient phone',
    'orders.table.recipientCompanyName': 'Recipient company name',
    'orders.table.recipientCompanyId': 'Recipient company ID',
    'orders.table.recipientTaxId': 'Recipient Tax ID',
    'orders.table.recipientStreet': 'Recipient street',
    'orders.table.recipientAddressAdditionalInfo': 'Recipient additional address info',
    'orders.table.recipientAdditionalInformationForAddress2': 'Recipient additional address info 2',
    'orders.table.recipientCity': 'Recipient city',
    'orders.table.recipientState': 'Recipient country',
    'orders.table.recipientProvinceCode': 'Recipient province code',
    'orders.table.recipientPostCode': 'Recipient post code',
    'orders.table.billingName': 'Billing full name',
    'orders.table.billingAttentionName': 'Billing attention name',
    'orders.table.billingEmail': 'Billing e-mail',
    'orders.table.billingPhone': 'Billing phone',
    'orders.table.billingCompanyName': 'Billing company name',
    'orders.table.billingCompanyId': 'Billing company ID',
    'orders.table.billingTaxId': 'Billing Tax ID',
    'orders.table.billingStreet': 'Billing street',
    'orders.table.billingAddressAdditionalInfo': 'Billing additional address info',
    'orders.table.billingAdditionalInformationForAddress2': 'Billing additional address info 2',
    'orders.table.billingCity': 'Billing city',
    'orders.table.billingState': 'Billing country',
    'orders.table.billingProvinceCode': 'Billing province code',
    'orders.table.billingPostCode': 'Billing post code',
    'orders.table.weight': 'Weight/kg',
    'orders.table.price': 'Price',
    'orders.table.shippingPrice': 'Shipping price',
    'orders.table.currency': 'Currency',
    'orders.table.shippingCurrency': 'Shipping currency',
    'orders.table.paid': 'Paid',
    'orders.table.method': 'Payment method',
    'orders.table.shipperServiceCode': 'Shipper service code',
    'orders.table.boxId': 'Box ID',
    'orders.table.branchId': 'Branch ID (B2Bc)',
    'orders.table.codPrice': 'Cash on delivery price',
    'orders.table.codCurrency': 'Cash on deliver currency',
    'orders.table.codRefNumber': 'COD VS',
    'orders.table.message': 'Note for courier',
    'orders.table.shippedAt': 'Shipped at',
    'orders.table.atPickupPointAt': 'At pickup point at',
    'orders.table.inProcessAt': 'In process at',
    'orders.table.addressId': 'Pickup p. ID',
    'orders.table.scannedAt': 'Scanned at',
    'orders.table.deliveredAt': 'Delivered at',
    'orders.table.returningBackAt': 'Returning back at',
    'orders.table.returnedBackAt': 'Returned back at',
    'orders.table.canceledAt': 'Canceled at',

    'orders.table.packedAt': 'Packed at',
    'orders.table.waitingForCarrierAt': 'Waiting for carrier at',
    'orders.table.invoiceDate': 'Invoice date',
    'orders.table.incorrectOrderMessage': 'Error message',
    'orders.table.transportPaidBySkladon': 'Transport paid by Skladon',
    'orders.table.holdByQuality': 'Pick from quality',
    'orders.table.pickFromCustomsWarehouse': 'Pick from customs warehouse',
    'orders.table.underSanction': 'Under sanction',
    'orders.table.orderBoxCount': 'Box count',
    'orders.table.paymentMethod': 'Payment method',
    'orders.table.sourceSys': 'Source system',
    'orders.table.note': 'Note',
    'orders.table.eshopNote': 'E-shop note',
    'orders.table.printFiles': 'Print the files',
    'orders.table.lastStatusCheckAt': 'Last status check at',
    'orders.table.updatedAt': 'Last update at',
    'orders.table.releaseFromSuspendedAt': 'Release from suspended at',
    'orders.table.preorderReleaseAt': 'Release for processing at',
    'orders.table.marketplace': 'Marketplace',
    'orders.table.waitingForShipmentAt': 'Waiting for shipment at',
    'orders.table.shipmentOrderAt': 'Shipment ordered',
    'orders.table.orderType': 'Order type',
    'orders.table.productSKU': 'Product SKU',
    'orders.table.productPrice': 'Product price',
    'orders.table.productLOT': 'Product Lot',
    'orders.table.productCurrency': 'Product currency',
    'orders.table.productCount': 'Required pcs',
    'orders.table.productConfirmed': 'Confirmed pcs',
    'orders.table.productMissingCount': 'Missing pcs',
    'orders.table.productSerialNumber': 'Serial numbers',
    'orders.table.productName': 'Product name',
    'orders.table.productEAN': 'EAN',
    'orders.table.overviewReason': 'Reason',
    'orders.table.waitingDays': 'Waiting days',
    'orders.table.requiredExpeditionDate': 'Required exp. date',
    'orders.table.disableShippingReorder': 'External TN (Marketplace) - do not order shipping',
    'orders.table.parentOrderId': 'Parent order ID',
    'orders.table.parentEshopId': 'Parent e-shop order ID',
    'orders.table.slaDate': 'SLA date',
    'orders.table.returnLabel': 'Return label',
    'orders.table.recipientGln': 'Recipient GLN',
    'orders.table.billingGln': 'Billing GLN',

    'orders.message.orderCreated': 'Order created',
    'orders.message.orderUpdate': 'Order update',
    'orders.message.productsAddedToOrders': 'Products added to selected orders',
    'orders.message.productsRemovedFromOrders': 'Products removed from selected orders',
    'orders.message.orderPrint': 'Order print',
    'orders.message.orderIvoiceCreated': 'Order invoice created',
    'orders.message.orderImported': 'Order imported',
    'orders.message.synchronizeSuccessfull': 'Synchronization was successful',
    'orders.message.requiredExpeditionDateRecalculated': 'The value of the required expedition date has been automatically shifted to the earliest possible expedition date according to the SLA.',
    'orderDetail.title': 'Detail {{orderType}} order #{{idOrder}}',
    'orderDetail.titleNew': 'Create new order',
    'orderDetail.action.create': 'Create order',
    'orderDetail.action.save': 'Save',
    'orderDetail.cancelReason': 'Cancelation reason',
    'orderDetail.action.createReturn': 'Create return',
    'orderDetail.action.createClaim': 'Create claim',
    'orderDetail.action.cloneOrder': 'Clone order',
    'orderDetail.action.splitOrder': 'Split order',
    'orderDetail.action.printOrder': 'Print order',
    'orderDetail.action.reorderShipping': 'Reorder shipping',
    'orderDetail.action.createInvoice': 'Create invoice',
    'orderDetail.action.dowloadRecipientInfo': 'Download Recipient info with TN',
    'orderDetail.action.nextStep': 'Next step',
    'orderDetail.action.prevStep': 'Previous step',
    'orderDetail.action.claimDetail': 'Claim detail',
    'orderDetail.action.removeUnavailableProducts': 'Remove unavailable pcs of products',
    'orderDetail.action.removeUnavailableProductsText': 'Do you really want to remove all pieces of unavailable products from the order?',
    'orderDetail.action.returnDetail': 'Return detail',
    'orderDetail.action.createTransport': 'Create transport',
    'orderDetail.transportsTable.id': 'ID',
    'orderDetail.transportsTable.role': 'Role',
    'orderDetail.transportsTable.status': 'Status',
    'orderDetail.transportsTable.trackingNumber': 'Tracking number',
    'orderDetail.transportsTable.shipper': 'Shipper',
    'orderDetail.transportsTable.roleSystem': 'System',
    'orderDetail.transportsTable.roleManual': 'Manual',
    'orderDetail.tab.invoiceTransport': 'Invoice and transport',
    'orderDetail.tab.transport': 'Transport',
    'orderDetail.tab.history': 'History',
    'orderDetail.tab.transportHistory': 'Transport history',
    'orderDetail.tab.transports': 'Transports',
    'orderDetail.tab.expeditionPackages': 'Shipping packages',
    'orderDetail.tab.summary': 'Summary',
    'orderDetail.tab.products': 'Products',
    'orderDetail.tab.claimsReturns': 'Claims and returns',
    'orderDetail.tab.address': 'Address',
    'orderDetail.tab.pallets': 'Pallets',
    'orderDetail.emptyData': 'Empty data',
    'orderDetail.addToRemove': 'Add to remove',
    'orderDetail.removeProduct': 'Remove product',
    'orderDetail.actions': 'Actions',
    'orderDetail.paidOrder': 'Paid order',
    'orderDetail.paidOrderOptions': 'Order payment options',
    'orderDetail.addProduct': 'Add product',
    'orderDetail.productTable.action.add': 'Add',
    'orderDetail.productTable.action.addProduct': 'Add product',
    'orderDetail.productTable.action.removeProduct': 'Remove product',
    'orderDetail.productTable.action.orderProductDetail': 'Order product detail',
    'orderDetail.titleOrderProductDetail': 'Order product detail',
    'orderDetail.mainInfo': 'Main info',
    'orderDetail.invoice': 'Invoice',
    'orderDetail.detail': 'Order detail',
    'orderDetail.disableShippingReorder': 'External TN (Marketplace) - do not order shipping',
    'orderDetail.cashOnDelivery': 'Cash on delivery',
    'orderDetail.orderDocuments': 'Order documents',
    'orderDetail.recipientInfo': 'Recipient info',
    'orderDetail.deliveryInfo': 'Delivery info',
    'orderDetail.billingInfo': 'Billing info',
    'orderDetail.contact': 'Contact',
    'orderDetail.placeOfDelivery': 'Delivery address',
    'orderDetail.billingAddress': 'Billing address',
    'orderDetail.detailInfo': 'Detail informations',
    'orderDetail.documentInfo': 'Documents informations',
    'orderDetail.printGroup': 'Printer',
    'orderDetail.billingInfoSame': 'Same billing info',
    'orderDetail.selectProviderBilling': 'Show contacts',
    'orderDetail.selectProviderRecipient': 'Show contacts',
    'orderDetail.selectProviderCompanybilling': 'Select billing contact (Full name / Attention name / Company name)',
    'orderDetail.selectProviderCompanyrecipient': 'Select recipient contact (Full name / Attention name / Company name)',
    'orderDetail.eshopID': 'E-shop ID',
    'orderDetail.parentIdEshopId': 'Parent order ID / Parent e-shop order ID',
    'orderDetail.orderType': 'Order type',
    'orderDetail.orderStatus': 'Order status',
    'orderDetail.incorrectMessage': 'Error message',
    'orderDetail.paymentMethod': 'Payment method',
    'orderDetail.paid': 'Paid',
    'orderDetail.printFiles': 'Print files',
    'orderDetail.allowExpedition': 'Allow expedition',
    'orderDetail.receivedDate': 'Order creation date',
    'orderDetail.requiredExpeditionDate': 'Required expedition date',
    'orderDetail.requiredExpeditionDate.tooltip': 'You can enter Required expedition date D+2 = the earliest date the day after tomorrow or later. The value in the field can be automatically adjusted according to the size of the order.',
    'orderDetail.note': 'Note',
    'orderDetail.eshopNote': 'E-shop note',
    'orderDetail.underSanction': 'Under sanction',
    'orderDetail.underSanction.tooltip': 'The Under sanction designation is used to identify orders that may be penalized for incorrect delivery.',
    'orderDetail.invoiceNumber': 'Invoice number',
    'orderDetail.invoicePrice': 'Invoice price',
    'orderDetail.invoicePriceCurrency': 'Invoice price currency',
    'orderDetail.invoiceDate': 'Invoice date',
    'orderDetail.documentType': 'Document type',
    'orderDetail.transport': 'Shipping',
    'orderDetail.shipper': 'Shipper',
    'orderDetail.shipperService': 'Shipper service',
    'orderDetail.dispensingPoint': 'Pick-up point',
    'orderDetail.dispensingCountry': 'Delivery country',
    'orderDetail.countryOfDelivery': 'Country of delivery',
    'orderDetail.pickupPoint': 'Pick-up point',
    'orderDetail.dhlSelectOnMapHint':
        'Select a pick-up point on the map, according to the specified parameters. If only the Country of delivery is specified, pick-up points in the capital are displayed. Scrolling the map will load additional pick-up points.',
    'orderDetail.dhlSearchServicePointsHint':
        'Search pick-up points according to the specified parameters: Country of delivery / Post code / City. If only the Country of delivery is entered, pick-up points in the capital are searched. 50 pick-up points are searched.',
    'orderDetail.dhlNoPointsLoadedHint': 'Search by postal code or city, or pick on the map.',
    'orderDetail.dhlSelectFromListHint': 'Select a Pick-up point from the list',
    'orderDetail.dhlSearchServicePoints': 'Search',
    'orderDetail.dhlSelectOnMap': 'Select on map',
    'orderDetail.dhlSelectPoint': 'Select this pick-up point',
    'orderDetail.dhlMapPanHint': 'Pan the map to load service points nearby.',
    'orderDetail.dhlMapClickMarkerHint': 'Click a marker on the map to see the service point details.',
    'orderDetail.dhlServicePointId': 'Service point ID',
    'orderDetail.dhlOpeningHours': 'Opening hours',
    'orderDetail.trackingNumber': 'Tracking number',
    'orderDetail.returnTrackingNumber': 'Return tracking number',
    'orderDetail.exchangeTrackingNumber': 'Exchange service TN',
    'orderDetail.shipperLabel': 'Show shipping label',
    'orderDetail.shipperReturnLabel': 'Show return shipping label',
    'orderDetail.shipperExchangeLabel': 'Exchange service TN',
    'orderDetail.shipperLabelDownload': 'Download shipping label file',
    'orderDetail.shipperReturnLabelDownload': 'Download return shipping label file',
    'orderDetail.shippingPrice': 'Shipping price',
    'orderDetail.shippingPriceCurrency': 'Shipping price currency',
    'orderDetail.currency': 'Currency',
    'orderDetail.shippedAt': 'Shipped at',
    'orderDetail.shipperResponse': 'Shipper response',
    'orderDetail.transportPaidBySkladon': 'Transport paid by Skladon',
    'orderDetail.printReturnLabel': 'Return label',
    'orderDetail.holdByQuality': 'Pick from quality',
    'orderDetail.pickFromCustomsWarehouse': 'Pick from customs warehouse',
    'orderDetail.boxCount': 'Box count',
    'orderDetail.branchId': 'Branch ID (B2Bc)',
    'orderDetail.confirmBranchIdTitle': 'Branch ID (B2Bc) entered: {{id}}',
    'orderDetail.confirmBranchIdText':
        'This order will be combined with other orders for the same branch ID and shipped together in a single shipment. For shipping, we will use the address and carrier specified for this branch ID, not the information provided in this order.',
    'orderDetail.removeBranchId': 'Remove Branch ID (B2Bc): {{id}}',
    'orderDetail.shipmentPending': 'Shipment pending',
    'orderDetail.marketplace': 'Marketplace',
    'orderDetail.cashOnDeliveryReferentionNumber': 'Reference number',
    'orderDetail.cashOnDeliveryPrice': 'Cash on delivery price',
    'orderDetail.cashOnDeliveryCurrency': 'Cash on delivery currency',
    'orderDetail.cashOnDeliveryRefNumber': 'Cash on delivery variable symbol',
    'orderDetail.paymentMethodPaid': 'Payment method and paid',
    'orderDetail.fullName': 'Full name',
    'orderDetail.attentionName': 'Attention name',
    'orderDetail.address': 'Address (street, number)',
    'orderDetail.recipientStreet': 'Delivery address (street, number)',
    'orderDetail.billingStreet': 'Billing address (street, number)',
    'orderDetail.addressAdditionalInfo': 'Additional address info',
    'orderDetail.addressAdditionalInfo2': 'Additional address info 2',
    'orderDetail.city': 'City',
    'orderDetail.country': 'Country',
    'orderDetail.provinceCode': 'Province code',
    'orderDetail.postCode': 'Post code',
    'orderDetail.email': 'E-mail',
    'orderDetail.phone': 'Phone',
    'orderDetail.companyName': 'Company name',
    'orderDetail.GLN': 'GLN',
    'orderDetail.companyId': 'Company ID',
    'orderDetail.taxId': 'Tax ID',
    'orderDetail.recipientCompanyId': 'Recipient company ID',
    'orderDetail.documents': 'Documents',
    'orderDetail.message': 'Note for courier',
    'orderDetail.message.tooltip': 'Note for courier is proposed on the shipping label to the following carriers: DHL, DPD, GLS, PPL CZ and UPS. Other shippers (PBH, PPL EU, Zásilkovna / Packeta) are unable to display the Note for courier / cannot receive this information in the system.',
    'orderDetail.messageOnExpeditionBox': 'Message on a box',
    'orderDetail.filterTrackingNumber': 'Filter tracking number',
    'orderDetail.delivery': 'Delivery',
    'orderDetail.status.received': 'Shipment ordered',
    'orderDetail.status.processing': 'In process',
    'orderDetail.status.waitingForCarrier': 'Waiting for carrier',
    'orderDetail.status.onTheWay': 'On the way',
    'orderDetail.status.atPickupPoint': 'At pickup point',
    'orderDetail.status.delivered': 'Delivered',
    'orderDetail.productTable.name': 'Name',
    'orderDetail.productTable.SKU': 'SKU',
    'orderDetail.productTable.id': 'ID',
    'orderDetail.productTable.EAN': 'EAN',
    'orderDetail.productTable.productType': 'Product type',
    'orderDetail.productTable.lot': 'Lot',
    'orderDetail.productTable.customsProductType': 'Customs product type',
    'orderDetail.productTable.customizationType': 'Customization type',
    'orderDetail.productTable.customizationText': 'Customization text',
    'orderDetail.productTable.count': 'Required pcs',
    'orderDetail.productTable.LOT': 'Lot',
    'orderDetail.productTable.missingCount': 'Missing pcs',
    'orderDetail.productTable.price': 'Unit price',
    'orderDetail.productTable.totalPrice': 'Total price',
    'orderDetail.productTable.currency': 'Currency',
    'orderDetail.productTable.confirmed': 'Confirmed pcs',
    'orderDetail.productTable.serialNumber': 'Serial numbers',
    'orderDetail.productTable.avaiable': 'Available',
    'orderDetail.productTable.bcxCode': 'BCX',
    'orderDetail.productTable.lineState': 'State',
    'orderDetail.productTable.orderProducts': 'Products',
    'orderDetail.productTable.available': 'Available quantity',
    'orderDetail.productTable.available.tooltip': 'Displays the current available quantity of the given product in stock. For product sets, 0 is displayed, as the set SKUs are not in stock.',
    'orderDetail.productTable.hsCode': 'HS code',
    'orderDetail.productTable.weight': 'Weight/kg',
    'orderDetail.productTable.agecheck': 'Age check (18+)',
    'orderDetail.productTable.description': 'Description',
    'orderDetail.productTable.expeditionMethod': 'Expedition method',
    'orderDetail.productTable.insertType': 'Insert type',
    'orderDetail.productTable.ROP': 'Reorder point',
    'orderDetail.productTable.EXPIRATION_DAYS': 'Expiration alert',
    'orderDetail.productTable.scanSerialNumber': 'Scan IMEI / serial numbers',
    'orderDetail.productTable.snRegex': 'Regular expression for IMEI / SN matching',
    'orderDetail.productTable.width': 'Width/cm',
    'orderDetail.productTable.height': 'Height/cm',
    'orderDetail.productTable.length': 'Depth/cm',
    'orderDetail.productTable.catalogPrice': 'Price',
    'orderDetail.productTable.unitPrice': 'Currency',
    'orderDetail.productTable.batteryType': 'Battery in device / packaging',
    'orderDetail.productTable.customField1': 'Custom field 1',
    'orderDetail.productTable.customField2': 'Custom field 2',
    'orderDetail.productTable.customField3': 'Custom field 3',
    'orderDetail.productTable.active': 'Active',
    'orderDetail.productTable.createdAt': 'Created at',
    'orderDetail.productTable.updatedAt': 'Updated at',
    'orderDetail.productTable.isDeleted': 'Deleted',
    'orderDetail.productTable.deletedAt': 'Deleted at',
    'orderDetail.addPallet': 'Add pallet',
    'orderDetail.palletTable.palletType': 'Pallet type',
    'orderDetail.palletTable.count': 'Count',
    'orderDetail.palletTable.width': 'Width/cm',
    'orderDetail.palletTable.length': 'Length/cm',
    'orderDetail.palletTable.height': 'Height/cm',
    'orderDetail.palletTable.weight': 'Weight/kg',
    'orderDetail.palletTable.action.add': 'Add',

    'orderDetail.slaCalculation.result': 'SLA date',
    'orderDetail.slaCalculation.previousSlaDate': 'Previous SLA',
    'orderDetail.slaCalculation.calculated': 'SLA calculated',
    'orderDetail.slaCalculation.cleared': 'SLA cleared',
    'orderDetail.slaCalculation.reason': 'Calculation Reason',
    'orderDetail.slaCalculation.reason.shipment_ordered': 'Shipment Ordered',
    'orderDetail.slaCalculation.reason.status_change_to_received': 'Status Change to Received',
    'orderDetail.slaCalculation.reason.products_available': 'Products Available',
    'orderDetail.slaCalculation.reason.required_expedition_change': 'Required Expedition Date Change',
    'orderDetail.slaCalculation.reason.status_change_to_suspended': 'Status Change to Suspended',
    'orderDetail.slaCalculation.reason.status_change_to_preorder': 'Status Change to PreOrder',
    'orderDetail.slaCalculation.reason.shipper_change': 'Shipper Change',
    'orderDetail.slaCalculation.reason.manual_postpone': 'Manual SLA Postpone',
    'orderDetail.slaCalculation.reason.customs_delay': 'Customs Delay',
    'orderDetail.slaCalculation.reason.order_created': 'Order Created',
    'orderDetail.slaCalculation.input.orderType': 'Order type',
    'orderDetail.slaCalculation.input.orderTimestamp': 'Order created at',
    'orderDetail.slaCalculation.input.currentStatus': 'Current Status',
    'orderDetail.slaCalculation.input.previousStatus': 'Previous Status',
    'orderDetail.slaCalculation.input.providerCot': 'E-shop COT',
    'orderDetail.slaCalculation.input.carrierCot': 'Shipper COT',
    'orderDetail.slaCalculation.input.productsCount': 'Products Count',
    'orderDetail.slaCalculation.input.requiredExpeditionDate': 'Required expedition date',
    'orderDetail.slaCalculation.input.shipper': 'Shipper',
    'orderDetail.slaCalculation.input.postponeDays': 'Postpone Days',
    'orderDetail.slaCalculation.input.b2bD0': 'B2B threshold D+0 (pcs)',
    'orderDetail.slaCalculation.input.b2bD1': 'B2B threshold D+1 (pcs)',
    'orderDetail.slaCalculation.input.b2bD2': 'B2B threshold D+2 (pcs)',
    'orderDetail.slaCalculation.input.b2bD3': 'B2B threshold D+3 (pcs)',
    'orderDetail.slaCalculation.input.waitingForPaymentAt': 'Waiting for payment at',
    'orderDetail.slaCalculation.input.suspendedAt': 'Suspended at',
    'orderDetail.slaCalculation.input.productsNotAvailableAt': 'Products not available at',
    'orderDetail.slaCalculation.input.incorrectAt': 'Incorrect at',
    'orderDetail.slaCalculation.calculation.baseDate': 'Base date for SLA calculation',
    'orderDetail.slaCalculation.calculation.pragueTime': 'Prague Time',
    'orderDetail.slaCalculation.calculation.isBeforeCutTime': 'Before COT',
    'orderDetail.slaCalculation.calculation.isHolidayOrWeekend': 'Holiday/Weekend',
    'orderDetail.slaCalculation.calculation.nextWorkingDate': 'Next working date',
    'orderDetail.palletTable.action.removePallet': 'Remove pallet',
    'orderDetail.expeditionPackagesTable.id': 'ID',
    'orderDetail.expeditionPackagesTable.expeditionPackage': 'Package number',
    'orderDetail.expeditionPackagesTable.width': 'Width/m',
    'orderDetail.expeditionPackagesTable.height': 'Height/m',
    'orderDetail.expeditionPackagesTable.length': 'Length/m',
    'orderDetail.expeditionPackagesTable.weight': 'Weight/kg',
    'orderDetail.expeditionPackagesTable.trackingNumber': 'Tracking number',
    'orderDetail.expeditionPackagesTable.packageSku': 'Packaging material SKU',
    'orderDetail.expeditionPackagesTable.palletSku': 'Pallet SKU',
    'orderDetail.expeditionPackagesTable.sscc': 'SSCC',
    'orderDetail.expeditionPackagesTable.productSKU': 'Product SKU',
    'orderDetail.expeditionPackagesTable.serialNumber': 'IMEI / Serial numbers',
    'orderDetail.expeditionPackagesTable.productCount': 'Product pcs',
    'orderDetail.expeditionPackagesTable.productLot': 'LOT',
    'orderDetail.expeditionPackagesTable.productExpDate': 'Expiration date',
    'orderDetail.expeditionPackagesTable.exportFileName': 'Export shipping package order #{{idOrder}}',
    'orderDetail.expeditionPackagesTable.productName': 'Product name',
    'orderDetail.expeditionPackagesTable.productEan': 'EAN',
    'orderDetail.expeditionPackagesTable.expPal': 'Pallet number',
    'orderDetail.claimsReturnsTable.type': 'Type',
    'orderDetail.claimsReturnsTable.id': 'ID',
    'orderDetail.claimsReturnsTable.eshopId': 'E-shop ID',
    'orderDetail.claimsReturnsTable.typeKey': 'Entry number',
    'orderDetail.claimsReturnsTable.createdAt': 'Created at',
    'orderDetail.claimsReturnsTable.status': 'Status',
    'orderDetail.claimsReturnsTable.shipper': 'Shipper',
    'orderDetail.claimsReturnsTable.trackingNumber': 'Tracking number',
    'orderDetail.confirmNotAviableCount': 'Attention, these products are not available!',
    'orderDetail.confirmPaidAction': 'Change payment method',
    'orderDetail.confirmPaidActionText':
        'Changing the payment method will update the order without saving the other changes entered.',
    'orderDetail.confirmPaidActionText2': 'Are you sure you want to change your payment method now?',
    'orderDetail.confirmPaidActionTextCOD':
        'Are you sure you want to change to cash on delivery? Please fill in the information below',
    'orderDetail.confirmGetNewDataStorage': 'Continue with the draft order',
    'orderDetail.confirmGetNewDataStorageText': 'You have a draft order saved - do you want to continue with it?',
    'orderDetail.confirmSaveNewDataStorage': 'Save draft order',
    'orderDetail.confirmSaveNewDataStorageText': 'You have not saved your changes. Do you want to save the draft?',
    'orderDetail.confirmSaveNewDataStorageTextComment': '(The draft order will be lost after the page is refreshed)',
    'orderDetail.confirmReleaseFromSuspendedAt': 'Release date from Suspended',
    'orderDetail.confirmReleaseFromSuspendedAtText':
        'Please set the release date and time. On this date, the status of the order will automatically be changed from Suspended to Pre received.',
    'orderDetail.releaseFromSuspendedAt': 'Release from Suspended at',
    'orderDetail.preorderReleaseAt': 'Release for processing at',
    'orderDetail.lateBecouseIncorrect': 'Late processing due to error',
    'orderDetail.lateBecousePNA': 'Late processing due to unavailable products',
    'orderDetail.history.createOrder': 'Order created',
    'orderDetail.history.orderWasCloned': 'New order created - clone, ID: {{ID}}',
    'orderDetail.history.createFromClone': 'Order created as clone from order ID: {{PARENT_ORDER_ID}} ',
    'orderDetail.history.createFromSplit': 'Order created by splitting from order ID: {{PARENT_ORDER_ID}}',
    'orderDetail.history.orderWasSplitted': 'New order created - split, ID: {{ID}}',
    'orderDetail.history.updateOrder': 'Order updated',
    'orderDetail.history.createReturn': 'Return {{RMA}} created',
    'orderDetail.history.createReturnWithoutRma': 'Return created',
    'orderDetail.history.updateOrderToStatus': 'Updated order status {{STATUS.old}} -> {{STATUS.new}}',
    'orderDetail.history.updateOrderStatusSucces': 'Shipment order successful: {{STATUS.old}} -> {{STATUS.new}}',
    'orderDetail.history.updateOrderStatusFailure': 'Shipment order unsuccessful: {{STATUS.old}} -> {{STATUS.new}}',
    'orderDetail.history.importShippingSuccess': 'Import shipping success',
    'orderDetail.history.waitingForShipmentBecauseOfDelay': 'Order shipment postponed',
    'orderDetail.history.shipmentCancelledSuccess': 'Shipment cancelled',
    'orderDetail.history.orderShipmentCancelledFailed': 'Order shipment cancelled failed',
    'orderDetail.history.errorWhileWrittingToDB': 'Error while writing data to the database: {{errorData}}',
    'orderDetail.history.recipient': 'Recipient',
    'orderDetail.history.billing': 'Billing',
    'orderDetail.history.ORDER_PRODUCTS.new': 'New product',
    'orderDetail.history.ORDER_PRODUCTS.edit': 'Product update',
    'orderDetail.history.ORDER_PRODUCT_SETS.new': 'New product set',
    'orderDetail.history.ORDER_PRODUCT_SETS.edit': 'Product set update',
    'orderDetail.history.ORDER_FILES.new': 'New order file',
    'orderDetail.history.ORDER_FILES.edit': 'Order file update',
    'orderDetail.history.ORDER_FILES.delete': 'Order file delete',
    'orderDetail.history.ORDER_PRODUCT_FILES.new': 'New order product file',
    'orderDetail.history.ORDER_PRODUCT_FILES.edit': 'Order product file update',
    'orderDetail.history.ORDER_PRODUCT_FILES.delete': 'Order product file delete',
    'orderDetail.history.fileName': 'File name',
    'orderDetail.history.fileType': 'File type',
    'orderDetail.history.fileCategory': 'File category',
    'orderDetail.history.ORDER_PALLETS.new': 'New pallet',
    'orderDetail.history.ORDER_PALLETS.edit': 'Pallet update',
    'orderDetail.history.ORDER_PALLETS.delete': 'Pallet delete',
    'orderDetail.history.SLA_CALCULATION.new': 'SLA Calculation',
    'orderDetail.history.SLA_CALCULATION.edit': 'SLA Recalculation',
    'orderDetail.history.slaCalculation': 'SLA Calculation',
    'orderDetail.history.slaCalculation.shipment_ordered': 'SLA: Shipment Ordered → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_received': 'SLA: Status Changed to Received → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.products_available': 'SLA: Products Available → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.required_expedition_change': 'SLA: Required Expedition Date Change → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_suspended': 'SLA: Order Suspended → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_preorder': 'SLA: Changed to Preorder → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.status_change_to_canceled': 'SLA: Order canceled → SLA deleted',
    'orderDetail.history.slaCalculation.shipper_change': 'SLA: Shipper Change → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.manual_postpone': 'SLA: Manual Postpone → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.customs_delay': 'SLA: Customs Delay → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.order_created': 'SLA: Order Created → {{SLA_CALCULATION.resultMessage}}',
    'orderDetail.history.slaCalculation.expedition_disabled': 'SLA: Expedition disabled → SLA deleted',
    'orderDetail.history.slaCalculation.expedition_enabled': 'SLA: Expedition enabled → SLA calculated',
    'orderDetail.history.SET_SKU': 'Set SKU',
    'orderDetail.history.SKU': 'SKU',
    'orderDetail.history.PRODUCT.SKU': 'SKU',
    'orderDetail.history.PRODUCT_NAME': 'Name',
    'orderDetail.history.PRODUCT.NAME': 'Name',
    'orderDetail.history.orderAnonymization': 'Anonymization',
    'orderDetail.history.PALLET_TYPE': 'Pallet type',
    'orderDetail.paidAction.transferPaymentPaid': 'Bank transfer - paid',
    'orderDetail.paidAction.transferPaymentNotPaid': 'Bank transfer - not paid',
    'orderDetail.paidAction.cashOnDelivery': 'Cash on delivery',
    'orderDetail.paidAction.cashOnDeliveryPaid': 'Cash on delivery - paid (claim/exchange)',
    'orderDetail.paidAction.cashOnDeliveryNotPaid': 'Cash on delivery - not paid',
    'orderDetail.paidAction.onlinePaymentPaid': 'Card online - paid',
    'orderDetail.paidAction.onlinePaymentNotPaid': 'Card online - not paid',
    'orderDetail.paidAction.transferPaymentSend': 'Transfer payment is ready to be sent',
    'orderDetail.history.FILE.ORIGINAL_FILE_NAME': 'Filename',
    'orderDetail.history.FILE.FILE_TYPE': 'Filetype',
    'orderDetail.history.FILE.TYPE': 'Type',
    'orderDetail.history.incorrectAt': 'Incorrect at',
    'orderDetail.history.processingAt': 'Processing at',
    'orderDetail.history.productsNotAvailableAt': 'Products not available at',
    'orderDetail.history.suspendedAt': 'Suspended at',
    'orderDetail.history.waitingForPaymentAt': 'Waiting for payment at',
    'orderDetail.history.unit': 'Unit',
    'orderDetail.history.orderDate': 'Order date',
    'orderDetail.history.subStatus': 'Sub-status',
    'orderDetail.history.shipperZone': 'Shipper zone',
    'orderDetail.history.shipperLabelPrinted': 'Shipper label printed',
    'orderDetail.history.dcixExport': 'DCIx export',
    'orderDetail.history.deliveredHook': 'Delivered hook',
    'ordersImport.title': 'Import orders',
    'ordersImport.error': 'Error',
    'ordersImport.incorrectFile': 'Incorrect file',
    'ordersImport.incorrectFileData': 'Incorrect file data',
    'ordersImport.excelFilePattern': 'Download template for importing orders',
    'ordersImport.action.showCarriers': 'Show carriers',
    'ordersImport.action.import': 'Import orders',
    'ordersImport.importConfirm': 'Do you really want to import orders?',
    'ordersImport.columnsOptions': 'Columns options',
    'ordersImport.detailOrder': 'Order detail',
    'ordersImport.confirmNotAviableCount': 'Attention, these products are not available!',
    'ordersImport.table.id': 'ID',
    'ordersImport.table.validity': 'Validation',
    'ordersImport.table.detail': 'Detail',
    'ordersImport.table.result': 'Result',
    'ordersImport.table.eshopOrderId': 'E-shop order ID',
    'ordersImport.table.recipientName': 'Recipient name',
    'ordersImport.table.recipientEmail': 'Recipient e-mail',
    'ordersImport.table.actions': 'Acitons',
    'ordersImport.notAlocatedtable.name': 'Name',
    'ordersImport.notAlocatedtable.sku': 'SKU',
    'ordersImport.notAlocatedtable.count': 'Required count',
    'ordersImport.notAlocatedtable.avaiable': 'Available',
    'ordersImport.notAlocatedtable.missingCount': 'Missing count',
    // 'ordersImport.notAlocatedtable.productType': 'Product type',
    // 'ordersImport.notAlocatedtable.ean': 'EAN',
    // 'ordersImport.notAlocatedtable.expeditionMethod': 'Expedition method',
    'ordersImport.action.create': 'Create',
    'ordersImport.action.update': 'Update',
    'ordersImport.action.showOrderDetail': 'Order detail',
    'ordersImport.totalCountToImport': 'Count of orders to import - Create: {{create}} Update: {{update}}',
    'ordersImport.totalCountImported': 'Count of orders imported - Created: {{created}} Updated: {{updated}}',
    'ordersImport.tab.general': 'General',
    'ordersImport.tab.created': 'Created',
    'ordersImport.tab.updated': 'Updated',
    'ordersImport.carriers.title': 'Carriers',
    'ordersImport.carriers.table.label': 'Name',
    'ordersImport.carriers.table.value': 'ID',
    'ordersImport.tooltip.status': 'Order status: preOrder, preReceived (default)',
    'ordersImport.tooltip.countProduct': 'Required pcs',
    'ordersImport.tooltip.addressId': 'Pickup point ID for selected shipper',
    'ordersImport.tooltip.branchId':
        'Branch ID (B2Bc) - for merging multiple small B2C orders into one larger B2B (necessary settings in Skladon)',
    'ordersImport.tooltip.price': 'Invoice price',
    'ordersImport.status.preOrder': 'Pre-order',
    'ordersImport.status.preReceived': 'Pre-received (default)',
    'ordersImport.paymentMethod.cardOnline': 'Card online',
    'ordersImport.paymentMethod.bankTransfer': 'Bank transfer',
    'ordersImport.paymentMethod.cashOnDelivery': 'Cash on delivery',
    'orderExpeditionPackages.title': 'Shipping packages',
    'orderExpeditionPackages.action.orderExpeditionPackageDetail': 'Shipping packages detail',
    'orderExpeditionPackages.action.orderDetail': 'Order detail',
    'orderExpeditionPackages.action.synchronizeTable': 'Synchronize table',
    'orderExpeditionPackages.action.exportFile': 'Export shipping packages',
    'orderExpeditionPackages.action.exportFileName': 'Export shipping packages',
    'orderExpeditionPackages.action.exportWithProducts': 'Export shipping packages with products',
    'orderExpeditionPackages.action.exportWithProductsFileName': 'Export shipping packages with products',
    'orderExpeditionPackages.table.id': 'ID',
    'orderExpeditionPackages.table.orderId': 'Order ID',
    'orderExpeditionPackages.table.eshopOrderId': 'E-shop order ID',
    'orderExpeditionPackages.table.expeditionPackage': 'Package number',
    'orderExpeditionPackages.table.width': 'Width/m',
    'orderExpeditionPackages.table.height': 'Height/m',
    'orderExpeditionPackages.table.length': 'Length/m',
    'orderExpeditionPackages.table.weight': 'Weight/kg',
    'orderExpeditionPackages.table.trackingNumber': 'Tracking number',
    'orderExpeditionPackages.table.packageSku': 'Packaging material SKU',
    'orderExpeditionPackages.table.expPal': 'Pallet number',
    'orderExpeditionPackages.table.palletSku': 'Pallet SKU',
    'orderExpeditionPackages.table.createdAt': 'Created at',
    'orderExpeditionPackages.table.updatedAt': 'Updated at',
    'orderExpeditionPackages.table.sscc': 'SSCC',
    'orderExpeditionPackages.table.productSKU': 'Product SKU',
    'orderExpeditionPackages.table.productName': 'Product name',
    'orderExpeditionPackages.table.productEAN': 'EAN',
    'orderExpeditionPackages.table.productCount': 'Product quantity',
    'orderExpeditionPackages.table.productSerialNumber': 'Serial numbers',
    'orderExpeditionPackages.table.actions': 'Actions',
    'orderExpeditionPackages.message.orderExpeditionPackageUpdated': 'Shipping package updated',
    'orderExpeditionPackages.message.orderExpeditionPackageDeleted': 'Shipping package deleted',
    'orderExpeditionPackageDetail.title': 'Shipping package detail #{{idOrderExpeditionPackage}}',
    'orderExpeditionPackageDetail.titleNew': 'Create new shipping package',
    'orderExpeditionPackageDetail.action.save': 'Save',
    'orderExpeditionPackageDetail.action.delete': 'Delete shipping package',
    'orderExpeditionPackageDetail.createOrderExpeditionPackage': 'Create shipping package',
    'orderExpeditionPackageDetail.editOrderExpeditionPackage': 'Edit shipping package',
    'orderExpeditionPackageDetail.order': 'Order ID',
    'orderExpeditionPackageDetail.expeditionPackage': 'Package number',
    'orderExpeditionPackageDetail.trackingNumber': 'Tracking number',
    'orderExpeditionPackageDetail.width': 'Width/m',
    'orderExpeditionPackageDetail.height': 'Height/m',
    'orderExpeditionPackageDetail.length': 'Length/m',
    'orderExpeditionPackageDetail.weight': 'Weight/kg',
    'orderExpeditionPackageDetail.package': 'Package',
    'orderExpeditionPackageDetail.pallet': 'Pallet',
    'orderExpeditionPackageDetail.deleteOrderExpeditionPackage': 'Delete shipping package',
    'orderExpeditionPackageDetail.deleteOrderExpeditionPackageConfirm':
        'Do you really want to delete this shipping package?',
    'orderExpeditionPackageDetail.productTable.title': 'Products',
    'orderExpeditionPackageDetail.productTable.id': 'ID',
    'orderExpeditionPackageDetail.productTable.SKU': 'SKU',
    'orderExpeditionPackageDetail.productTable.serialNumber': 'IMEI / Serial numbers',
    'orderExpeditionPackageDetail.productTable.count': 'Pcs',
    'orderExpeditionPackageDetail.productTable.lot': 'LOT',
    'orderExpeditionPackageDetail.productTable.expDate': 'Expiration date',
    'orderExpeditionPackageDetail.productTable.exportFileName':
        'Export shipping package product #{{idOrderExpeditionPackage}}',
    'orderMessagesOnExpeditionBox.title': 'Message on a box',
    'orderMessagesOnExpeditionBox.action.createNew': 'New',
    'orderMessagesOnExpeditionBox.action.exportFile': 'Export message on a box',
    'orderMessagesOnExpeditionBox.action.exportFileName': 'Export message on a box',
    'orderMessagesOnExpeditionBox.action.synchronizeTable': 'Synchronize table',
    'orderMessagesOnExpeditionBox.action.messageOnExpeditionBoxDetail': 'Detail of the message on the box',
    'orderMessagesOnExpeditionBox.table.id': 'ID',
    'orderMessagesOnExpeditionBox.table.message': 'Message on a box',
    'orderMessagesOnExpeditionBox.table.country': 'Recipient country',
    'orderMessagesOnExpeditionBox.table.actions': 'Actions',
    'orderMessagesOnExpeditionBoxDetail.title': 'Message detail on a box #{{idOrderMessagesOnExpeditionBox}}',
    'orderMessagesOnExpeditionBoxDetail.titleNew': 'Create new message on the box',
    'orderMessagesOnExpeditionBoxDetail.action.save': 'Save',
    'orderMessagesOnExpeditionBoxDetail.action.create': 'Create',
    'orderMessagesOnExpeditionBoxDetail.message': 'Message on a box',
    'orderMessagesOnExpeditionBoxDetail.country': 'Recipient country',
    'orderMessagesOnExpeditionBoxDetail.action.deleteMessageOnExpeditionBoxDetail': 'Delete the message on the box',
    'orderMessagesOnExpeditionBoxDetail.action.deleteMessageOnExpeditionBoxDetailConfirm':
        'Do you really want to delete this message on the box?',
    'orderMessagesOnExpeditionBox.message.created': 'Message on a box created',
    'orderMessagesOnExpeditionBox.message.updated': 'Message on a box updated',
    'orderMessagesOnExpeditionBox.message.deleted': 'Message on a box deleted',
    'claims.title': 'Claims',
    'claims.allProviders': 'All providers',
    'claims.action.exportFile': 'Export claims',
    'claims.action.exportFileName': 'Export claims',
    'claims.action.claimDetail': 'Claim detail',
    'claims.action.orderDetail': 'Order detail',
    'claims.action.synchronizeTable': 'Synchronize table',
    'claims.action.changeStatuses': 'Change claim status',
    'claims.action.changeStatusesText': 'Do you really want to change status for {{count}} selected claims to:',
    'claims.action.exportWithProducts': 'Export claims with products',
    'claims.action.importClaims': 'Import claims from Excel',
    'claims.message.claimsImported': 'Claims were imported',
    'claimsImport.title': 'Import claims',
    'claimsImport.excelFilePattern': 'Download template for claims import:',
    'claimsImport.columnsOptions': 'Column options',
    'claimsImport.requiredColumn': 'required column',
    'claimsImport.incorrectFileData': 'Incorrect file data',
    'claimsImport.previewTableTitle': 'Imported data preview',
    'claimsImport.importConfirm': 'Do you really want to import claims?',
    'claimsImport.action.import': 'Import claims',
    'claimsImport.table.validity': 'Validation',
    'claimsImport.table.fcn': 'FCN',
    'claimsImport.table.status': 'Status',
    'claimsImport.table.transportPrice': 'Transport price',
    'claimsImport.table.goodsPrice': 'Goods price',
    'claimsImport.table.totalServicePrice': 'Total service price',
    'claimsImport.table.compensationCurrency': 'Compensation currency',
    'claimsImport.table.carrierInvoiceReference': 'Carrier invoice reference',
    'claimsImport.table.issuesMonthOrigin': 'Client compensation date',
    'error.claimNotFound': 'Claim with this FCN does not exist',
    'error.duplicateFcn': 'Duplicate FCN in file',
    'error.noChanges': 'Row does not contain any data to update',
    'error.notPositiveNumber': 'Value must be a positive number',
    'claims.action.exportWithProductsFileName': 'Export claims with products',
    'claims.table.providerName': 'E-shop',
    'claims.table.id': 'ID',
    'claims.table.fcn': 'FCN',
    'claims.table.eshopClaimId': 'E-shop claim ID',
    'claims.table.orderId': 'Order ID',
    'claims.table.trackingNumber': 'Tracking number',
    'claims.table.shipper': 'Shipper',
    'claims.table.orderType': 'Order type',
    'claims.table.createdAt': 'Created at',
    'claims.table.updatedAt': 'Last update at',
    'claims.table.resolver': 'Resolver',
    'claims.table.statusOfClaim': 'Status of claim',
    'claims.table.closedAt': 'Closed at',
    'claims.table.informationAddedAt': 'Information added at',
    'claims.table.eshopOrderId': 'E-shop order ID',
    'claims.table.claimCause': 'Claim cause',
    'claims.table.otherClaimCause': 'Other claim cause',
    'claims.table.note': 'Skladon note',
    'claims.table.eshopNote': 'E-shop note',
    'claims.table.description': 'Description',
    'claims.table.cctv': 'CCTV',
    'claims.table.returnTrackingNumber': 'Return tracking number',
    'claims.table.transportPrice': ' Transport price',
    'claims.table.goodsPrice': 'Goods price',
    'claims.table.totalServicePrice': 'Service price',
    'claims.table.compensationCurrency': 'Currency',
    'claims.table.carrierInvoiceReference': 'Carrier invoice reference',
    'claims.table.issuesMonthOrigin': 'Compensation date to client',
    'claims.table.productSKU': 'SKU',
    'claims.table.productName': 'Product name',
    'claims.table.productClaimedQuantity': 'Claimed quantity',
    'claims.table.productResendQuantity': 'Resend quantity',
    'claims.table.inProcessAtFirst': 'In process at (first)',
    'claims.table.inProcessAtLast': 'In process at (last)',
    'claims.table.inProcessAt': 'In process at',
    'claims.table.moreInfoNeededAt': 'More info needed at',
    'claims.table.acceptedExpectCompensationAt': 'Accepted - expect compensation at',
    'claims.table.acceptedPendingClientCompensationAt': 'Accepted - pending compensation to client at',
    'claims.table.rejectedAt': 'Rejected at',
    'claims.table.canceledAt': 'Canceled at',
    'claims.table.packedAt': 'Packed at',
    'claims.table.packerName': "Packer's name",
    'claims.table.errorResponsible': 'Responsible for the error',
    'claims.table.errorDepartment': 'Department',
    'claims.table.errorCategory': 'Error category',
    'claims.table.errorDescription': 'Error description',
    'claims.table.errorSeverity': 'Error severity',
    'claims.table.videoLink': 'Video link',
    'claims.message.claimCreated': 'Claim created',
    'claims.message.claimUpdate': 'Claim updated',
    'claimDetail.title': 'Claim detail #{{idClaim}}',
    'claimDetail.compensations': 'Compensation',
    'claimDetail.products': 'Claimed products',
    'claimDetail.titleNew': 'Create new claim',
    'claimDetail.history': 'History',
    'claimDetail.history.PRODUCTS.new': 'New product',
    'claimDetail.history.PRODUCTS.edit': 'Product update',
    'claimDetail.history.SKU': 'SKU',
    'claimDetail.detail': 'Claim detail',
    'claimDetail.errorLogging': 'Error logging',
    'claimDetail.packedAt': 'Packed at',
    'claimDetail.packerName': "Packer's name",
    'claimDetail.errorResponsible': 'Responsible for the error',
    'claimDetail.errorDepartment': 'Department',
    'claimDetail.errorDepartment.b2c': 'B2C',
    'claimDetail.errorDepartment.b2b': 'B2B',
    'claimDetail.errorCategory': 'Error category',
    'claimDetail.errorCategory.packagingNonCompliance': 'Packaging non-compliance',
    'claimDetail.errorCategory.physicalHandlingError': 'Physical handling error',
    'claimDetail.errorCategory.scanningError': 'Scanning error',
    'claimDetail.errorCategory.insufficientPackaging': 'Insufficient packaging',
    'claimDetail.errorCategory.others': 'Others',
    'claimDetail.errorDescription': 'Error description',
    'claimDetail.errorSeverity': 'Error severity',
    'claimDetail.errorSeverity.1': '1 - Low',
    'claimDetail.errorSeverity.2': '2 - Medium',
    'claimDetail.errorSeverity.3': '3 - High',
    'claimDetail.errorSeverityTooltip':
        'This value indicates the error severity, where 3 is the most severe.',
    'claimDetail.videoLink': 'Video link',
    'claimDetail.action.create': 'Create',
    'claimDetail.action.save': 'Save',
    'claimDetail.action.createOrder': 'Create new order',
    'claimDetail.fcn': 'FCN',
    'claimDetail.cctv': 'CCTV',
    'claimDetail.eshopClaimId': 'E-shop claim ID',
    'claimDetail.orderId': 'Order ID',
    'claimDetail.trackingNumber': 'Tracking number',
    'claimDetail.createdAt': 'Created at',
    'claimDetail.status': 'Status',
    'claimDetail.closedAt': 'Closed at',
    'claimDetail.informationAddedAt': 'Information added at',
    'claimDetail.inProcessAt': 'In process at',
    'claimDetail.moreInfoNeededAt': 'More info needed at',
    'claimDetail.acceptedExpectCompensationAt': 'Accepted expect compensation at',
    'claimDetail.acceptedPendingClientCompensationAt': 'Accepted - pending compensation to client at',
    'claimDetail.rejectedAt': 'Rejected at',
    'claimDetail.canceledAt': 'Canceled at',
    'claimDetail.claimCause': 'Claim cause',
    'claimDetail.resolver': 'Resolver',
    'claimDetail.causeOtherTypes': 'Other claim cause',
    'claimDetail.description': 'Description',
    'claimDetail.resolution': 'Resolution',
    'claimDetail.note': 'Skladon note',
    'claimDetail.eshopNote': 'E-shop note',
    'claimDetail.invoiceDocument': 'Sales and purchase invoices',
    'claimDetail.invoiceDocumentText1': 'Please attach the sales invoice and the purchase invoice',
    'claimDetail.invoiceDocumentText2':
        ' - both of these invoices must be attached in order for the claim to be processed correctly (if you are the manufacturer of the product, attach the Affidavit on the purchase price of the goods)',
    'claimDetail.invoiceImageDocumentText1': 'Attach photo documentation',
    'claimDetail.invoiceImageDocumentText2':
        ' - in the case of damage to the shipment, it is necessary to attach photo documentation of the damaged goods and the box/packaging, including the address label, for the correct processing of the claim.',
    'claimDetail.image': 'Photos and other documents',
    'claimDetail.confirmGetNewDataStorage': 'Continue with the draft claim',
    'claimDetail.confirmGetNewDataStorageText': 'You have a draft claim saved - do you want to continue with it?',
    'claimDetail.claimExistsTitle': 'Claim already exists',
    'claimDetail.claimExistsBlocked':
        'A claim ({{claimLinks}}) already exists for this order (ID: {{orderId}} / E-shop order ID: {{eshopOrderId}}); therefore, it is not possible to create another one. If needed, please update the existing claim or contact Skladon support.',
    'claimDetail.claimExistsConfirm':
        'A claim ({{claimLinks}}) already exists for this order (ID: {{orderId}} / E-shop order ID: {{eshopOrderId}}). Do you really want to create another new claim?',
    'claimDetail.history.updateClaimToStatus': 'Claim status updated {{STATUS.old}} -> {{STATUS.new}}',
    'claimDetail.history.updateClaim': 'Claim updated',
    'claimDetail.history.createClaim': 'Claim created',
    'claimDetail.history.claimAnonymization': 'Anonymization',
    'claimDetail.eshopID': 'E-shop order ID',
    'claimDetail.attachmentsHistoryType': 'Attachment type',
    'claimDetail.attachmentsHistoryFileName': 'File',
    'claimDetail.attachmentsHistoryFileExtension': 'File type',
    'claimDetail.history.CLAIM_FILES.new': 'New claim attachment',
    'claimDetail.history.CLAIM_FILES.edit': 'Claim attachment updated',
    'claimDetail.history.CLAIM_FILES.delete': 'Claim attachment removed',
    'claimDetail.history.FILE.ORIGINAL_FILE_NAME': 'File',
    'claimDetail.returnTrackingNumber': 'Return tracking number',
    'claimDetail.transportPrice': 'Transport price',
    'claimDetail.goodsPrice': 'Goods price',
    'claimDetail.totalServicePrice': 'Service price',
    'claimDetail.compensationCurrency': 'Currency',
    'claimDetail.carrierInvoiceReference': 'Carrier invoice reference',
    'claimDetail.issuesMonthOrigin': 'Compensation date to client',
    'claimDetail.productTable.name': 'Name',
    'claimDetail.productTable.sku': 'SKU',
    'claimDetail.productTable.nameSku': 'SKU / Product name',
    'claimDetail.productTable.claimedQuantity': 'Claimed quantity',
    'claimDetail.productTable.resendQuantity': 'Resended quantity',
    'returns.title': 'Returns',
    'returns.allProviders': 'All providers',
    'returns.action.exportFile': 'Export returns',
    'returns.action.exportFileName': 'Export returns',
    'returns.action.exportWithProducts': 'Export returns with products',
    'returns.action.exportWithProductsFileName': 'Export returns with products',
    'returns.action.returnDetail': 'Return detail',
    'returns.action.orderDetail': 'Order detail',
    'returns.action.synchronizeTable': 'Synchronize table',
    'returns.action.synchronizeDcix': 'Synchronize returns to DCIx',
    'returns.action.synchronizeDcixText': 'Do you really want to synchronize {{count}} of returns?',
    'returns.action.changeStatuses': 'Change returns status',
    'returns.action.changeStatusesText': 'Do you really want to change status on {{count}} returns to:',

    'returns.table.providerName': 'E-shop',
    'returns.table.rma': 'RMA',
    'returns.table.orderId': 'Order ID',
    'returns.table.eshopId': 'E-shop ID',
    'returns.table.recipientFullName': 'Full name',
    'returns.table.invoiceNumber': 'Invoice number',
    'returns.table.createdAt': 'Created at',
    'returns.table.receivedAt': 'In process at',
    'returns.table.confirmedAt': 'Confirmed at',
    'returns.table.statusOfReturn': 'Status of return',
    'returns.table.resolution': 'Resolution',
    'returns.table.trackingNumber': 'Return tracking number',
    'returns.table.shipper': 'Return shipper',
    'returns.table.shipperServiceCode': 'Return shipper service',
    'returns.table.actions': 'Actions',
    'returns.table.resendOrder': 'Resend order',
    'returns.table.productQuantity': 'Returned pcs',
    'returns.table.productReceived': 'Received pcs',
    'returns.table.productResolution': 'Product resolution',
    'returns.table.productSerialNumber': 'Product IMEI / serial numbers',
    'returns.table.productSKU': 'Product SKU',
    'returns.table.productName': 'Product name',
    'returns.table.eshopReturnId': 'E-shop return ID',
    'returns.table.eshopOrderId': 'E-shop order ID',
    'returns.table.partnerOrderId': 'Partner order ID',
    'returns.table.id': 'ID',
    'returns.table.sourceSystem': 'Created in system',
    'returns.table.returnDescription': 'Return description',
    'returns.table.note': 'Note',
    'returns.table.eshopNote': 'E-shop note',
    'returns.table.dispatcherContact': 'Dispatcher contact',
    'returns.table.transportPaidBy': 'Return shipping paid by',
    'returns.table.recipientName': 'Recipient name',
    'returns.table.orderType': 'Order type',
    'returns.table.orderShipper': 'Order shipper',
    'returns.table.orderShipperService': 'Order shipper service',
    'returns.table.orderTrackingNumber': 'Order tracking number',
    'returns.table.canceledAt': 'Canceled at',

    'returns.message.returnCreated': 'Return created',
    'returns.message.returnUpdate': 'Return updated',
    'returns.message.returnDeleted': 'Return deleted',
    'returns.message.returnConfirmed': 'Return confirmed',
    'returns.message.synchronizeSuccessfull': 'Synchronize successfull',
    'returnDetail.title': 'Return detail #{{idReturn}}',
    'returnDetail.titleNew': 'Create new return',
    'returnDetail.detail': 'Detail',
    'returnDetail.history': 'History',
    'returnDetail.editReturn': 'Edit return',
    'returnDetail.createReturn': 'Create return',
    'returnDetail.action.create': 'Create',
    'returnDetail.action.save': 'Save',
    'returnDetail.action.confirm': 'Confirm',
    'returnDetail.action.showPdfForm': 'PDF form',
    'returnDetail.detailInfo': 'Detail info',
    'returnDetail.transport': 'Transport',
    'returnDetail.products': 'Products',
    'returnDetail.returnTitle': 'Return',
    'returnDetail.orderTitle': 'Order',
    'returnDetail.addProduct': 'Add product',
    'returnDetail.returnReason': 'Return reason',
    'returnDetail.eshopReturnId': 'E-shop return ID',
    'returnDetail.rma': 'RMA',
    'returnDetail.orderId': 'Order ID',
    'returnDetail.orderType': 'Order type',
    'returnDetail.order.eshopOrderId': 'E-shop order ID',
    'returnDetail.order.shipper': 'Order shipper ',
    'returnDetail.order.shipperService': 'Order shipper service',
    'returnDetail.order.trackingNumber': 'Order tracking number',
    'returnDetail.order.deliveredAt': 'Delivered at',
    'returnDetail.order.transportPaidBySkladon': 'Transport paid by Skladon',
    'returnDetail.confirmReturnExists': 'Return already exists',
    'returnDetail.confirmReturnExistsText': 'For order ID: {{orderId}} E-shop ID: {{eshopOrderId}} a return already exists:\n{{rmaList}}\nDo you really want to create another new return?',
    'returnDetail.eshopID': 'E-shop order ID',
    'returnDetail.partnerOrderId': 'Partner order ID',
    'returnDetail.statusOfReturn': 'Status of return',
    'returnDetail.createdAt': 'Created at',
    'returnDetail.sourceSystem': 'Created in system',
    'returnDetail.returnDescription': 'Return description',
    'returnDetail.order': 'Order',
    'returnDetail.shipper': 'Return shipper',
    'returnDetail.trackingNumber': 'Return tracking number',
    'returnDetail.shipperServiceCode': 'Return shipper service',
    'returnDetail.transportPaidBySkladon': 'Transport paid by Skladon',
    'returnDetail.shipperService': 'Shipper service',
    'returnDetail.shippingPrice': 'Shipper price',
    'returnDetail.currency': 'Currency',
    'returnDetail.deliveredAt': 'Delivered at',
    'returnDetail.note': 'Note',
    'returnDetail.eshopNote': 'E-shop note',
    'returnDetail.transportPaidBy': 'Return shipping paid by',
    'returnDetail.sourceSys': 'Created in system',
    'returnDetail.files': 'Files',
    'returnDetail.confirmGetNewDataStorage': 'Continue with the draft return',
    'returnDetail.confirmGetNewDataStorageText': 'You have a draft return saved - do you want to continue with it?',
    'returnDetail.productTable.action.add': 'Add',
    'returnDetail.productTable.action.addProduct': 'Add product',
    'returnDetail.productTable.action.removeProduct': 'Remove product',
    'returnDetail.productTable.name': 'Name',
    'returnDetail.productTable.sku': 'SKU',
    'returnDetail.productTable.id': 'ID',
    'returnDetail.productTable.EAN': 'EAN',
    'returnDetail.productTable.productType': 'Product type',
    'returnDetail.productTable.count': 'Original quantity',
    'returnDetail.productTable.quantity': 'Returned quantity',
    'returnDetail.productTable.received': 'Received quantity',
    'returnDetail.productTable.resolution': 'Resolution',
    'returnDetail.productTable.returnReason': 'Return reason',
    'returnDetail.productTable.actions': 'Actions',
    'returnDetail.productTable.serialNumber': 'Serial numbers',
    'returnDetail.productTable.hsCode': 'HS code',
    'returnDetail.productTable.weight': 'Weight/kg',
    'returnDetail.productTable.agecheck': 'Age check (18+)',
    'returnDetail.productTable.description': 'Description',
    'returnDetail.productTable.expeditionMethod': 'Expedition method',
    'returnDetail.productTable.insertType': 'Insert type',
    'returnDetail.productTable.ROP': 'Reorder point',
    'returnDetail.productTable.EXPIRATION_DAYS': 'Expiration alert',
    'returnDetail.productTable.scanSerialNumber': 'Scan IMEI / serial numbers',
    'returnDetail.productTable.snRegex': 'Regular expression for IMEI / SN matching',
    'returnDetail.productTable.width': 'Width/cm',
    'returnDetail.productTable.height': 'Height/cm',
    'returnDetail.productTable.length': 'Depth/cm',
    'returnDetail.productTable.catalogPrice': 'Price',
    'returnDetail.productTable.unitPrice': 'Currency',
    'returnDetail.productTable.batteryType': 'Battery in device / packaging',
    'returnDetail.productTable.customField1': 'Custom field 1',
    'returnDetail.productTable.customField2': 'Custom field 2',
    'returnDetail.productTable.customField3': 'Custom field 3',
    'returnDetail.productTable.active': 'Active',
    'returnDetail.productTable.createdAt': 'Created at',
    'returnDetail.productTable.updatedAt': 'Updated at',
    'returnDetail.productTable.isDeleted': 'Deleted',
    'returnDetail.productTable.deletedAt': 'Deleted at',
    'returnDetail.history.confirmReturn': 'Return confirm',
    'returnDetail.history.updateReturn': 'Return update',
    'returnDetail.history.createReturn': 'Return create',
    'returnDetail.history.updateReturnToStatus': 'Return status update',
    'returnDetail.history.RETURNED_ORDER_PRODUCTS.new': 'New product',
    'returnDetail.history.RETURNED_ORDER_PRODUCTS.edit': 'Edited product',
    'returnDetail.history.FILES.new': 'New return attachment',
    'returnDetail.history.FILES.edit': 'Return attachment updated',
    'returnDetail.history.FILES.delete': 'Return attachment removed',
    'returnDetail.history.fileName': 'File',
    'returnDetail.attachmentsHistoryType': 'File type',
    'returnDetail.attachmentsHistoryFileName': 'File',
    'returnDetail.attachmentsHistoryFileExtension': 'File type',
    'returnDetail.attachmentsHistoryFileSize': 'File size',
    'returnDetail.canceledAt': 'Canceled at',
    'returnDetail.confirmedAt': 'Confirmed at',
    'returnDetail.receivedAt': 'In process at',
    'returnDetail.stockPosition': 'Stock position',
    'returnDetail.dcixExport': 'DCIx export',
    'returnDetail.history.senderName': 'Sender name',
    'returnDetail.history.senderStreet': 'Sender street',
    'returnDetail.history.senderCity': 'Sender city',
    'returnDetail.history.senderState': 'Sender state',
    'returnDetail.history.senderPostCode': 'Sender postcode',
    'returnDetail.history.senderPhone': 'Sender phone',
    'returnDetail.history.recipientName': 'Recipient name',
    'returnDetail.history.returnAnonymization': 'Anonymization',
    'returnDetail.history.PRODUCT_ID': 'ID',
    'returnDetail.history.SKU': 'SKU',
    'receivings.title': 'Receivings',
    'receivings.allProviders': 'All providers',
    'receivings.action.exportFile': 'Export receivings',
    'receivings.action.exportFileName': 'Export receiving',
    'receivings.action.exportWithProducts': 'Export receiving with products',
    'receivings.action.exportWithProductsFileName': 'Export receiving with products',
    'receivings.action.receivingDetail': 'Receiving detail',
    'receivings.action.createNew': 'New',
    'receivings.action.synchronizeDcix': 'Synchronize receiving to DCIx',
    'receivings.action.synchronizeDcixText': 'Do you really want to synchronize {{count}} of receiving?',
    'receivings.action.synchronizeTable': 'Synchronize table',
    'receivings.action.importReceiving': 'Import receivings',
    'receivings.action.changeStatuses': 'Change receivings status',
    'receivings.action.changeStatusesText': 'Do you really want to change status on {{count}} receivings to:',
    'receivings.table.providerName': 'E-shop',
    'receivings.table.status': 'Status',
    'receivings.table.dateCreated': 'Created at',
    'receivings.table.asn': 'Command number',
    'receivings.table.supplier': 'Supplier name',
    'receivings.table.eshopReceivingId': 'E-shop ID',
    'receivings.table.estimatedDelivery': 'Scheduled delivery',
    'receivings.table.awaitingQuantity': 'Announced pcs',
    'receivings.table.receivedQuantity': 'Delivered pcs',
    'receivings.table.differentialQuantity': 'Deviation pcs',
    'receivings.table.unitsAmount': 'Announced cartons',
    'receivings.table.id': 'ID',
    'receivings.table.carrierInfo': 'Carrier info',
    'receivings.table.deliveryNoteNumber': 'Delivery note number',
    'receivings.table.deliveryType': 'Transport type',
    'receivings.table.duty': 'Customs duty',
    'receivings.table.urgent': 'ASN creation status',
    'receivings.table.typeOfHandlingUnits': 'Type of handlings units',
    'receivings.table.description': 'Note for ASN',
    'receivings.table.trackingNumber': 'Tracking number',
    'receivings.table.driverCompany': 'Transport company',
    'receivings.table.driverCompanyOtherName': 'Other transport company name',
    'receivings.table.driverTrailerLicensePlate': 'Driver trailer license plate',
    'receivings.table.eshopNote': 'E-shop note',
    'receivings.table.driverName': 'Driver name',
    'receivings.table.driverPhone': 'Driver phone',
    'receivings.table.dispatcherContact': 'Dispatcher contact',
    'receivings.table.priority': 'Priority',
    'receivings.table.containerNumber': 'Container number',
    'receivings.table.announcedPalletsCount': 'Announced pallets',
    'receivings.table.receivingType': 'Receiving type',
    'receivings.table.realDelivery': 'Real delivery',
    'receivings.table.slaDate': 'SLA date',
    'receivings.table.slaSuspended': 'SLA suspended',
    'receivings.table.photoDocumentationTaken': 'Photo documentation taken',
    'receivings.table.deliveredPalletsCount': 'Delivered EUR pallet',
    'receivings.table.returnedEurPalletsCount': 'Returned EUR pallet',
    'receivings.table.deliveredStandardPalletsCount': 'Delivered STANDARD pallet',
    'receivings.table.returnedStandardPalletsCount': 'Returned STANDARD pallet',
    'receivings.table.deliveredOtherPalletsCount': 'Delivered OTHER pallet',
    'receivings.table.deliveredBrokenPalletsCount': 'Delivered BROKEN pallet',
    'receivings.table.deliveredCartonsCount': 'Delivered cartons',
    'receivings.table.skladonNote': 'Skladon note',
    'receivings.table.incoterms': 'Delivery terms (Incoterms)',
    'receivings.table.actions': 'Actions',
    'receivings.table.productSKU': 'Product SKU',
    'receivings.table.productName': 'Product name',
    'receivings.table.productQuantity': 'Announced pcs',
    'receivings.table.productReceived': 'Delivered pcs',
    'receivings.table.productDiffQuantity': 'Deviation pcs',
    'receivings.table.unloadedAt': 'Unloaded at',
    'receivings.table.receivedAt': 'In process at',
    'receivings.table.confirmedAt': 'Confirmed at',
    'receivings.table.canceledAt': 'Canceled at',
    'receivings.message.receivingCreated': 'Receiving created',
    'receivings.message.receivingUpdate': 'Receiving updated',
    'receivings.message.receivingDeleted': 'Receiving deleted',
    'receivings.message.synchronizeSuccessfull': 'Synchronize successfull',
    'receivingDetail.infoSection': 'ASN detail',
    'receivingDetail.title': 'Receiving detail #{{idReceiving}}',
    'receivingDetail.titleNew': 'Create new receiving',
    'receivingDetail.filesTitle': 'Receiving documents',
    'receivingDetail.filesColFile': 'File',
    'receivingDetail.filesColDescription': 'Description',
    'receivingDetail.filesColUploadedBy': 'Uploaded by',
    'receivingDetail.filesColActions': 'Actions',
    'receivingDetail.history': 'History',
    'receivingDetail.detail': 'Detail',
    'receivingDetail.action.create': 'Create',
    'receivingDetail.action.save': 'Save',
    'receivingDetail.action.confirm': 'Confirm receiving',
    'receivingDetail.action.showPdfForm': 'ASN label',
    'receivingDetail.asnLabel.selectFormat': 'Select format',
    'receivingDetail.asnLabel.format.a4': '210 x 297 mm (A4)',
    'receivingDetail.asnLabel.format.a6': '100 x 150 mm (A6 - Zebra printer)',
    'receivingDetail.createReceiving': 'Create receiving',
    'receivingDetail.editReceiving': 'Edit receiving',
    'receivingDetail.packaging': 'Packaking',
    'receivingDetail.products': 'Products',
    'receivingDetail.addProduct': 'Add product',
    'receivingDetail.addPacking': 'Add pallet',
    'receivingDetail.removePackaging': 'Remove pallet',
    'receivingDetail.supplier': 'Supplier',
    'receivingDetail.content': 'Content',
    'receivingDetail.createdAt': 'Created at',
    'receivingDetail.status': 'Status of receiving',
    'receivingDetail.asn': 'Command number',
    'receivingDetail.urgent': 'ASN creation status',
    'receivingDetail.trackingNumber': 'Tracking number',
    'receivingDetail.eshopReceivingId': 'E-shop receiving ID',
    'receivingDetail.estimatedDelivery': 'Scheduled delivery',
    'receivingDetail.suplplier': 'Supplier name',
    'receivingDetail.typeOfHandlingUnits': 'Type of handlings units',
    'receivingDetail.amountOfHandlingUnits': 'Number of announced cartons',
    'receivingDetail.description': 'Note for ASN',
    'receivingDetail.carrierInfo': 'Carrier info',
    'receivingDetail.deliveryType': 'Transport type',
    'receivingDetail.deliveryNoteNumber': 'Delivery note number',
    'receivingDetail.asnLabelEmail': 'Email for sending ASN label',
    'receivingDetail.duty': 'Customs duty',
    'receivingDetail.driver': 'Shipper',
    'receivingDetail.driverCompany': 'Transport company',
    'receivingDetail.driverCompanyOtherName': 'Other transport company name',
    'receivingDetail.driverName': 'Driver name',
    'receivingDetail.driverPhone': 'Driver phone',
    'receivingDetail.dispatcherContact': 'Dispatcher contact',
    'receivingDetail.driverTrailerLicensePlate': 'Vehicle license plate',
    'receivingDetail.eshopNote': 'E-shop note',
    'receivingDetail.priority': 'Priority',
    'receivingDetail.containerNumber': 'Container number',
    'receivingDetail.announcedPalletsCount': 'Number of announced pallets',
    'receivingDetail.receivingType': 'Receiving type',
    'receivingDetail.incoterms': 'Delivery terms (Incoterms)',
    'receivingDetail.dcixInfo': 'DCIx information',
    'receivingDetail.slaDate': 'SLA date',
    'receivingDetail.realDelivery': 'Real delivery',
    'receivingDetail.slaSuspended': 'SLA suspended',
    'receivingDetail.photoDocumentationTaken': 'Photo documentation taken',
    'receivingDetail.deliveredPalletsCount': 'Number of delivered EUR pallet',
    'receivingDetail.deliveredCartonsCount': 'Number of delivered cartons',
    'receivingDetail.skladonNote': 'Skladon note',
    'receivingDetail.returnedEurPalletsCount': 'Returned EUR pallet',
    'receivingDetail.deliveredStandardPalletsCount': 'Number of delivered STANDARD pallet',
    'receivingDetail.returnedStandardPalletsCount': 'Returned STANDARD pallet',
    'receivingDetail.deliveredOtherPalletsCount': 'Number of delivered OTHER pallets',
    'receivingDetail.deliveredBrokenPalletsCount': 'Number of delivered BROKEN pallets',
    'receivingDetail.unloadedAt': 'Unloaded at',
    'receivingDetail.receivedAt': 'In process at',
    'receivingDetail.confirmedAt': 'Confirmed at',
    'receivingDetail.note': 'Note',
    'receivingDetail.canceledAt': 'Canceled at',
    'receivingDetail.dcixExport': 'DCIx export',

    // Tooltips
    'receivingDetail.estimatedDeliveryTooltip': 'Enter the expected date and time of delivery to the warehouse.',
    'receivingDetail.deliveryTypeTooltip': 'Select the transport type by which the goods will be delivered to the warehouse - this affects the way the goods are handled at receiving.',
    'receivingDetail.dutyTooltip': 'Select YES if the shipment is a customs-cleared shipment.',
    'receivingDetail.receivingTypeTooltip': 'Select the way the goods will be received - this affects the form of checking and processing on receiving.',
    'receivingDetail.asnLabelEmailTooltip': 'Insert the email to which the shipping label (ASN label) is to be sent.',
    'receivingDetail.announcedPalletsCountTooltip': 'Insert zero (0) if the goods are not on pallets.',
    'receivingDetail.trackingNumberTooltip': 'If the receivings does not have a tracking number, fill in the value 0 or None.',

    'receivingDetail.confirmGetNewDataStorage': 'Continue with the draft receiving',
    'receivingDetail.confirmGetNewDataStorageText':
        'You have a draft receiving saved - do you want to continue with it?',
    'receivingDetail.productTable.name': 'Name',
    'receivingDetail.productTable.sku': 'SKU',
    'receivingDetail.productTable.id': 'ID',
    'receivingDetail.productTable.quantity': 'Announced pcs',
    'receivingDetail.productTable.receivedQuantity': 'Delivered pcs',
    'receivingDetail.productTable.differential': 'Deviation pcs',
    'receivingDetail.productTable.lot': 'LOT',
    'receivingDetail.productTable.expirationDate': 'Expiration date',
    'receivingDetail.productTable.ean': 'EAN',
    'receivingDetail.productTable.description': 'Description',
    'receivingDetail.productTable.productType': 'Product type',
    'receivingDetail.productTable.lineState': 'Status',
    'receivingDetail.productTable.serialNumber': 'Serial numbers',
    'receivingDetail.productTable.actions': 'Actions',
    'receivingDetail.productTable.action.add': 'Add',
    'receivingDetail.productTable.action.addProduct': 'Add product',
    'receivingDetail.productTable.action.removeProduct': 'Remove product',
    'receivingDetail.productTable.hsCode': 'HS code',
    'receivingDetail.productTable.weight': 'Weight/kg',
    'receivingDetail.productTable.agecheck': 'Age check (18+)',
    'receivingDetail.productTable.expeditionMethod': 'Expedition method',
    'receivingDetail.productTable.insertType': 'Insert type',
    'receivingDetail.productTable.ROP': 'Reorder point',
    'receivingDetail.productTable.EXPIRATION_DAYS': 'Expiration alert',
    'receivingDetail.productTable.scanSerialNumber': 'Scan IMEI / serial numbers',
    'receivingDetail.productTable.snRegex': 'Regular expression for IMEI / SN matching',
    'receivingDetail.productTable.width': 'Width/cm',
    'receivingDetail.productTable.height': 'Height/cm',
    'receivingDetail.productTable.length': 'Depth/cm',
    'receivingDetail.productTable.catalogPrice': 'Price',
    'receivingDetail.productTable.unitPrice': 'Currency',
    'receivingDetail.productTable.batteryType': 'Battery in device / packaging',
    'receivingDetail.productTable.customField1': 'Custom field 1',
    'receivingDetail.productTable.customField2': 'Custom field 2',
    'receivingDetail.productTable.customField3': 'Custom field 3',
    'receivingDetail.productTable.active': 'Active',
    'receivingDetail.productTable.createdAt': 'Created at',
    'receivingDetail.productTable.updatedAt': 'Updated at',
    'receivingDetail.productTable.isDeleted': 'Deleted',
    'receivingDetail.productTable.deletedAt': 'Deleted at',
    'receivingDetail.packagingTable.packagingType': 'Pallet type',
    'receivingDetail.packagingTable.pallet': 'Pallet - size and type',
    'receivingDetail.packagingTable.quantity': 'Quantity',
    'receivingDetail.packagingTable.action.add': 'Add',
    'receivingDetail.packagingTable.action.removePacking': 'Remove pallet',
    'receivingDetail.history.PRODUCTS.new': 'New product',
    'receivingDetail.history.PRODUCTS.edit': 'Edit product',
    'receivingDetail.history.PACKAGINGS.new': 'New pallet',
    'receivingDetail.history.PACKAGINGS.edit': 'Edit pallet',
    'receivingDetail.history.PACKAGINGS.delete': 'Delete pallet',
    'receivingDetail.history.RECEIVING_FILES.new': 'New receiving attachment',
    'receivingDetail.history.RECEIVING_FILES.edit': 'Receiving attachment updated',
    'receivingDetail.history.RECEIVING_FILES.delete': 'Receiving attachment removed',
    'receivingDetail.history.ORIGINAL_FILE_NAME': 'File',
    'receivingDetail.attachmentsHistoryType': 'File type',
    'receivingDetail.attachmentsHistoryFileName': 'File',
    'receivingDetail.history.updateReceivingToStatus': 'Status of receiving updated {{STATUS.old}} -> {{STATUS.new}}',
    'receivingDetail.history.updateReceiving': 'Update receiving',
    'receivingDetail.history.createReceiving': 'Create receiving',
    'receivingDetail.history.SKU': 'SKU',
    'receivingDetailConfirm.title': 'Confirm receiving #{{idReceiving}}',
    'receivingDetailConfirm.note': 'Note',
    'receivingDetailConfirm.addProduct': 'Add product',
    'receivingDetailConfirm.action.confirm': 'Confirm receiving',
    'receivingDetailConfirm.action.cancel': 'Cancel',
    'receivingDetailConfirm.productTable.action.add': 'Add',
    'receivingDetailConfirm.productTable.action.removeProduct': 'Remove product',
    'receivingDetailConfirm.productTable.name': 'Name',
    'receivingDetailConfirm.productTable.sku': 'SKU',
    'receivingDetailConfirm.productTable.quantity': 'Announced pcs',
    'receivingDetailConfirm.productTable.receivedQuantity': 'Delivered pcs',
    'receivingDetailConfirm.productTable.differential': 'Deviation pcs',
    'receivingDetailConfirm.productTable.lot': 'LOT',
    'receivingDetailConfirm.productTable.expirationDate': 'Expiration date',
    'receivingImport.title': 'Import receiving',
    'receivingImport.receivingFile': 'File',
    'receivingImport.columnsOptions': 'Columns options',
    'receivingImport.excelFilePattern': 'Download template for importing income',
    'receivingImport.eshopReceivingIdColumnDescription': 'Optional. If filled and a receiving with this e-shop ID exists, the import will open that receiving for edit; otherwise a new receiving is created.',
    'receivingImport.fields.estimatedDelivery': 'Planned delivery *',
    'receivingImport.fields.unitsAmount': 'Announced pcs *',
    'receivingImport.fields.supplier': 'Supplier name *',
    'receivingImport.fields.deliveryType': 'Transport type *',
    'receivingImport.fields.deliveryNoteNumber': 'Delivery note number *',
    'receivingImport.fields.containerNumber': 'Container number',
    'receivingImport.fields.announcedPalletsCount': 'Announced pallets count *',
    'receivingImport.fields.duty': 'Customs duty *',
    'receivingImport.fields.driverCompany': 'Shipping company *',
    'receivingImport.fields.trackingNumber': 'Tracking number *',
    'receivingImport.fields.receivingType': 'Receiving type *',
    'receivingImport.fields.description': 'Description',
    'receivingImport.fields.productSku': 'Product SKU *',
    'receivingImport.fields.productQuantity': 'Product quantity *',
    'receivingImport.fields.productLot': 'Product lot',
    'receivingImport.fields.productExpirationDate': 'Product expiration date',
    'receivingImport.productType.nonExistentSku': 'Non-existent SKU',
    'products.dcixSync.importedProviderProducts': 'Imported {{count}} products from provider ID: {{providerId}}.',
    'products.dcixSync.importedProviderProductEans': 'Imported {{count}} product\'s EANs from provider ID: {{providerId}}.',
    'products.title': 'Inventory',
    'products.all': 'All products',
    'products.active': 'Active products',
    'products.inactive': 'Inactive products',
    'products.deleted': 'Deleted products',
    'products.sets': 'Products sets',
    'products.packgingMaterials': 'Packagings materials',
    'products.promoMaterials': 'Promo materials',
    'products.billOfMaterials': 'Bills of materials',
    'products.createNew': 'New',
    'products.massUpdate': 'Bulk products parameters changes',
    'products.massUpdateConfirm': 'Mark which parameters you want to change for the {{count}} selected products and enter the new required values.',
    'products.action.importProducts': 'Import products',
    'products.action.withStock': 'View stock amount',
    'products.action.exportFileName': 'Export products',
    'products.action.dowloadProductsTable': 'Export products',
    'products.action.productDetail': 'Product detail',
    'products.action.stockTransfers': 'Stock transfers',
    'products.action.synchronizeTable': 'Synchronize products',
    'products.action.activateProducts': 'Activate products',
    'products.action.deactivateProducts': 'Deactivate products',
    'products.action.syncProductsToDcix': 'Synchronize products to DCIx',
    'products.action.syncEansToDcix': 'Synchronize EANs to DCIx',
    'products.action.massUpdate': 'Change products details',
    'products.activateProductsConfirm': 'Do you really want to activate {{count}} products?',
    'products.activateProducts': 'Activate products',
    'products.deactivateProducts': 'Deactivate products',
    'products.deactivateProductsConfirm': 'Do you really want to deactivate {{count}} products?',
    'products.stockRatio.label': 'Stock ratio',
    'products.stockRatio.tooltip': 'Display of available product stock - Available column. 100% = all available stock is displayed and possibly synchronized to the e-shop platform.',
    'products.table.SKU': 'SKU',
    'products.table.id': 'ID',
    'products.table.name': 'Name',
    'products.table.EAN': 'EAN',
    'products.table.eanLockedByWms': 'EAN managed by WMS',
    'products.table.insertType': 'Insert type',
    'products.table.insertByOrderType': 'Insert by order type',
    'products.table.lot': 'Lot',
    'products.table.expirationDate': 'Expiration date',
    'products.table.allocated': 'Reserved',
    'products.table.onExpedition': 'In process',
    'products.table.available': 'Available',
    'products.table.onHoldQuality': 'On hold quality',
    'products.table.awaiting': 'Awaiting',
    'products.table.customsWarehouse': 'Customs warehouse',
    'products.table.active': 'Active',
    'products.table.all': 'All',
    'products.table.all.tooltip': 'The complete number of pieces of the product that are in stock – including pieces that are currently in unavailable positions = not stored in available positions yet. For example, products in receipt or assembly. See Knowledge base – Inventory article, Stock inventory paragraph.',
    'products.table.allocated.tooltip': 'Number of products reserved in orders that have not yet been shipped. See Knowledge base - Inventory article, Stock inventory paragraph.',
    'products.table.available.tooltip': 'Number of products that are in stock and not reserved to orders. See Knowledge base - Inventory article, Stock inventory paragraph.',
    'products.table.hsCode': 'HS code',
    'products.table.batteryType': 'Battery in device / part of package',
    'products.table.productType': 'Product type',
    'products.table.expeditionMethod': 'Expedition method',
    'products.table.description': 'Description',
    'products.table.ROP': 'Reorder point',
    'products.table.EXPIRATION_DAYS': 'Expiration notice',
    'products.table.agecheck': 'Age check (18+)',
    'products.table.globalProduct': 'Global product',
    'products.table.quantityConversion': 'Quantity conversion',
    'products.table.scanSerialNumber': 'Scan IMEI / SN',
    'products.table.snRegex': 'Regular expression for IMEI / SN matching',
    'products.table.weight': 'Weight/kg',
    'products.table.width': 'Width/cm',
    'products.table.height': 'Height/cm',
    'products.table.length': 'Length/cm',
    'products.table.price': 'Price',
    'products.table.unitPrice': 'Unit price',
    'products.table.customField1': 'Custom field 1',
    'products.table.customField2': 'Custom field 2',
    'products.table.customField3': 'Custom field 3',
    'products.table.originCountry': 'Origin country',
    'products.table.isDeleted': 'Deleted',
    'products.table.sourceSys': 'Source system',
    'products.table.sourceSys.myskladon': 'MySkladon',
    'products.table.sourceSys.pipes': 'Pipes',
    'products.table.sourceSys.api': 'API',
    'products.table.createdAt': 'Created at',
    'products.table.updatedAt': 'Updated at',
    'products.table.dimensionsChangedAt': 'Dimensions changed',
    'products.table.deletedAt': 'Deleted at',
    'products.message.productCreated': 'Product created',
    'products.message.productUpdate': 'Product updated',
    'products.message.productDeleted': 'Product deleted',
    'products.message.productActivated': 'Product activated',
    'products.message.productDeactivated': 'Product deactivated',
    'products.message.productsActivated': 'Products activated',
    'products.message.productsDeactivated': 'Products deactivated',
    'products.message.productImported': 'Products imported',
    'productDetail.title': 'Product detail #{{idProduct}} SKU: {{SKU}}',
    'productDetail.titleNew': 'Create new product',
    'productDetail.history': 'History',
    'productDetail.detail': 'Detail',
    'productDetail.create': 'Create product',
    'productDetail.save': 'Save',
    'productDetail.saveChanges': 'Save product changes',
    'productDetail.deleteProduct': 'Delete product',
    'productDetail.deleteProductConfirm': 'Do you really want to delete this product?',
    'productDetail.billsOfMaterials': 'Bills of materials',
    'productDetail.productStock': 'Lot / Exp. Date',
    'productDetail.titleProductStock': 'Lot / Exp. Date',
    'productDetail.activateProduct': 'Activate product',
    'productDetail.deactivateProduct': 'Deactivate product',
    'productDetail.createConfirm': 'Do you really want to create a product?',
    'productDetail.saveConfirm': 'Do you really want to save changes to this product?',
    'productDetail.activateProductConfirm': 'Do you really want to activate this product?',
    'productDetail.deactivateProductConfirm': 'Do you really want to deactivate this product?',
    'productDetail.productOrders': 'Product in orders',
    'productDetail.titleProductOrders': 'Orders with product SKU: {{SKU}}',
    'productDetail.productOrdersTimeFrom': 'From',
    'productDetail.productSetChangeWarning.info': 'Unprocessed orders ({{count}}) contain the original set of products.',
    'productDetail.productSetChangeWarning.text':
        'Are you sure you want to change product set SKU: {{sku}}, even though there are pending orders with this product set? Changing the set will no longer allow you to edit the set / products in this set in these orders.',
    'productDetail.productSetChangeWarning.ordersPrefix': 'Orders with set:',
    'productDetail.productTypeChangeOrdersConfirm.line1':
        'Do you really want to save changes, including changing the product type from {{originalType}} to {{newType}}?',
    'productDetail.productTypeChangeOrdersConfirm.line2':
        'By saving this product type change, product SKU: {{sku}} will be updated in {{count}} unprocessed orders.',
    'productDetail.productType': 'Product type',
    'productDetail.SKU': 'Product SKU',
    'productDetail.SKU.tooltip': 'The SKU cannot be changed by the user - it is the primary product identifier and it is linked to warehouse management. Please do not change the SKU of the products in your system either - by changing the SKU you will create a new product in MyS, which will cause problems. If you need to change the SKU, please contact Skladon - customercare@skladon.cz',
    'productDetail.incorretSkuText': 'Diacritics are not allowed for Product SKU',
    'productDetail.name': 'Name',
    'productDetail.description': 'Description',
    'productDetail.hsCode': 'HS code',
    'productDetail.batteryType': 'Battery in device / part of package',
    'productDetail.inserType': 'Insert type',
    'productDetail.insertByOrderType': 'Insert by order type',
    'productDetail.insertByOrderType.all': 'B2B and B2C orders',
    'productDetail.insertByOrderType.b2c': 'Only B2C orders',
    'productDetail.insertByOrderType.b2b': 'Only B2B orders',
    'productDetail.insertPriceFrom': 'Insert price from',
    'productDetail.insertPriceTo': 'Insert price to',
    'productDetail.productInsertToCountries': 'Insert to countries',
    'productDetail.agecheck': 'Age check (18+)',
    'productDetail.quantityConversion': 'Quantity conversion',
    'productDetail.globalProduct': 'Global product',
    'productDetail.scanSerialNumber': 'Scan IMEI / SN',
    'productDetail.snRegex': 'Regular expression for IMEI / SN matching',
    'productDetail.snRegex.tooltip': 'Insert regular expression for SN (serial number) matching, for example: ^H[A-Z0-9]+$ or ^[A-Za-z0-9]{12}$ and so on. For IMEI comparison, the regular expression ^[0-9]{14,16}$ is automatically completed.',
    'productDetail.ROP': 'Reorder point',
    'productDetail.EXPIRATION_DAYS': 'Expiration notice - days in advance',
    'productDetail.EAN': 'EAN',
    'productDetail.EAN.tooltip': 'To change the EAN for a product with stock, please contact Skladon - customercare@skladon.cz, it is necessary to change/restick the label with the EAN for existing products in stock',
    'productDetail.eanLockedByDcix': 'EAN managed by WMS',
    'productDetail.eansTab.title': 'EANs',
    'productDetail.eansTab.addEan': 'Add EAN',
    'productDetail.eansTab.add': 'Add',
    'productDetail.eansTab.ean': 'EAN',
    'productDetail.eansTab.duplicateEan': 'This EAN is already assigned to the product',
    'productDetail.eansTab.deactivateEan': 'Deactivate EAN',
    'productDetail.eansTab.activateEan': 'Activate EAN',
    'productDetail.eansTab.removeEan': 'Remove EAN',
    'productDetail.eansTab.lockedInfo': 'EANs for this product are managed by WMS. Without PRODUCT.EAN.EDIT permission you can only add a new EAN.',
    'productDetail.eansTab.table.ean': 'EAN',
    'productDetail.eansTab.table.active': 'Active',
    'productDetail.eansTab.editOnEansTab': 'EANs are managed on the EANs tab',
    'productDetail.eansTab.goToEans': 'Go to the EANs tab',
    'productDetail.eansTab.goToEansButton': 'EANs',
    'productDetail.history.EANS.new': 'New product EAN',
    'productDetail.history.EANS.edit': 'Product EAN updated',
    'productDetail.history.EANS.delete': 'Product EAN removed',
    'productDetail.history.ean': 'EAN',
    'productDetail.history.eanActive': 'Active',
    'productDetail.expMethod': 'Expedition method',
    'productDetail.width': 'Width/cm',
    'productDetail.height': 'Height/cm',
    'productDetail.length': 'Length/cm',
    'productDetail.weight': 'Weight/kg',
    'productDetail.price': 'Price',
    'productDetail.unitPrice': 'Unit price',
    'productDetail.customField1': 'Custom field 1',
    'productDetail.customField2': 'Custom field 2',
    'productDetail.customField3': 'Custom field 3',
    'productDetail.originCountry': 'Origin country',
    'productDetail.active': 'Active',
    'productDetail.isDeleted': 'Deleted',
    'productDetail.sourceSys': 'Source system',
    'productDetail.stockMuCode': 'Stock unit of measure',
    'productDetail.packingType': 'Packing type',
    'productDetail.insertToProductId': 'Insert to product ID',
    'productDetail.UPC': 'UPC',
    'productDetail.MPN': 'MPN',
    'productDetail.ISBN': 'ISBN',
    'productDetail.note': 'Note',
    'productDetail.packagingMaterialSlots': 'Packaging material slots',
    'productDetail.eshopStock': 'E-shop stock',
    'productDetail.refId': 'Reference ID',
    'productDetail.guid': 'GUID',
    'productDetail.ownerEshopKey': 'Owner e-shop key',
    'productDetail.alias': 'Alias',
    'productDetail.dcixImport': 'DCIx import',
    'productDetail.dcixProviderId': 'DCIx provider ID',
    'productDetail.linkedEshop': 'Linked e-shop',
    'productDetail.attachedIdentifier': 'Attached identifier',
    'productDetail.confirmGetNewDataStorage': 'Continue with the draft product',
    'productDetail.confirmGetNewDataStorageText': 'You have a draft product saved - do you want to continue with it?',
    'productDetail.confirmSetAllProductRelation': 'Adding all products',
    'productDetail.confirmSetAllProductRelationText':
        'Adding all products deletes previous products and their insert types',
    'productDetail.productRelationstable.nameSKU': 'SKU | Name',
    'productDetail.productRelationstable.name': 'Name',
    'productDetail.productRelationstable.SKU': 'SKU',
    'productDetail.productRelationstable.EAN': 'EAN',
    'productDetail.productRelationstable.productType': 'Product type',
    'productDetail.productRelationstable.type': 'Type',
    'productDetail.productRelationstable.remove': 'Remove product relationship',
    'productDetail.productRelationstable.removeSelectedProducts': 'Remove selected product relationships',
    'productDetail.productRelationstable.confirmRemoveSelectedProducts': 'Remove selected product relationships',
    'productDetail.productRelationstable.confirmRemoveSelectedProductsText':
        'Do you really want to remove selected product relationships?',
    'productDetail.addProductRelation': 'Insert type: Specific product - add product relationship',
    'productDetail.productRelationstable.action.add': 'Add',
    'productDetail.allProductsOption': 'All products ({{length}})',
    'productDetail.productSetTab.title': 'Products in set',
    'productDetail.productSetTab.addProduct': 'Add product to set',
    'productDetail.productSetTab.productSku': 'SKU | Name | EAN',
    'productDetail.productSetTab.quantity': 'Quantity',
    'productDetail.productSetTab.add': 'Add',
    'productDetail.productSetTab.removeProduct': 'Remove product from set',
    'productDetail.productSetTab.noProductsError': 'There are no products defined in the set! Please specify what products this set consists of.',
    'productDetail.productSetTab.table.sku': 'SKU',
    'productDetail.productSetTab.table.name': 'Name',
    'productDetail.productSetTab.table.ean': 'EAN',
    'productDetail.productSetTab.table.quantity': 'Quantity',
    'productDetail.productReceivings': 'Product in receivings',
    'productDetail.exportProductReceivings': 'Export product in receivings',
    'productDetail.productReceivingsTable.asn': 'Command number',
    'productDetail.productReceivingsTable.eshopReceivingId': 'E-shop ID',
    'productDetail.productReceivingsTable.createdAt': 'Created at',
    'productDetail.productReceivingsTable.productQuantity': 'Announced pcs',
    'productDetail.productReceivingsTable.productReceived': 'Delivered pcs',
    'productDetail.productReceivingsTable.productDiffQuantity': 'Deviation pcs',
    'productDetail.productReceivingsTable.status': 'Status',
    'productDetail.productReceivingsTable.estimatedDelivery': 'Scheduled delivery',
    'productDetail.productReceivingsTable.unloadedAt': 'Unloaded at',
    'productDetail.productReceivingsTable.receivedAt': 'In process at',
    'productDetail.productReceivingsTable.confirmedAt': 'Confirmed at',
    'productDetail.productReturns': 'Product in returns',
    'productDetail.exportProductReturns': 'Export product returns',
    'productDetail.productReturnsTable.rma': 'RMA',
    'productDetail.productReturnsTable.eshopReturnId': 'E-shop return ID',
    'productDetail.productReturnsTable.createdAt': 'Created at',
    'productDetail.productReturnsTable.confirmedAt': 'Confirmed at',
    'productDetail.productReturnsTable.status': 'Status',
    'productDetail.productReturnsTable.quantity': 'Returned pcs',
    'productDetail.productReturnsTable.received': 'Received pcs',
    'productDetail.productReturnsTable.orderId': 'Order ID',
    'productDetail.productReturnsTable.eshopOrderId': 'E-shop order ID',
    'productDetail.productReturnsTable.recipientName': 'Recipient name',
    'productDetail.productReturnsTable.returnDescription': 'Return description',
    'productDetail.stockMovements': 'Stock movements',
    'productDetail.titleStockMovements': 'Stock movements SKU: {{SKU}}',
    'productDetail.exportStockMovements': 'Export stock movements',
    'productDetail.stockMovementsTable.id': 'ID',
    'productDetail.stockMovementsTable.createdAt': 'Movement date',
    'productDetail.stockMovementsTable.type': 'Movement type',
    'productDetail.stockMovementsTable.count': 'Quantity',
    'productDetail.stockMovementsTable.expirationDate': 'Expiration date',
    'productDetail.stockMovementsTable.lot': 'Lot',
    'productDetail.stockMovementType.stock_correction': 'Stock correction',
    'productDetail.stockMovementType.completition': 'Completion',
    'productDetail.stockMovementType.order': 'Order',
    'productDetail.stockMovementType.return': 'Return',
    'productDetail.stockMovementType.receiving': 'Receiving',
    'productDetail.stockMovementType.inventory': 'Inventory',
    'productDetail.stockMovementType.quality_hold': 'Quality hold',
    'productDetail.stockMovementType.quality_release': 'Quality release',

    // Stock movement type codes for filtering
    'utils.stockMovementTypeCodes.stock_correction': 'Stock correction',
    'utils.stockMovementTypeCodes.completition': 'Completion',
    'utils.stockMovementTypeCodes.order': 'Order',
    'utils.stockMovementTypeCodes.return': 'Return',
    'utils.stockMovementTypeCodes.receiving': 'Receiving',
    'utils.stockMovementTypeCodes.quality_hold': 'Quality hold',
    'utils.stockMovementTypeCodes.quality_release': 'Quality release',

    // Client type codes
    'utils.clientTypeCodes.custom': 'Custom',
    'utils.clientTypeCodes.standard': 'Standard',

    // Business field codes
    'utils.businessFieldCodes.electronics': 'Electronics',
    'utils.businessFieldCodes.footwear': 'Footwear',
    'utils.businessFieldCodes.fashion': 'Fashion',
    'utils.businessFieldCodes.cosmeticsAndPerfumes': 'Cosmetics & Parfumes',
    'utils.businessFieldCodes.foodSupplements': 'Food Supplements',
    'utils.businessFieldCodes.foodAndBeverages': 'Food & Beverages',
    'utils.businessFieldCodes.healthcare': 'Healthcare',
    'utils.businessFieldCodes.kids': 'Kids',
    'utils.businessFieldCodes.workEquipment': 'Work Equipment',
    'utils.businessFieldCodes.drugstore': 'Drugstore',
    'utils.businessFieldCodes.merch': 'Merch',
    'utils.businessFieldCodes.packagingAndAccessories': 'Packaging & Accessories',

    // Contract term codes
    'utils.contractTermCodes.indefinite': 'Indefinite',
    'utils.contractTermCodes.specificDate': 'Fixed term',
    'productDetail.exportProductOrders': 'Export product in orders',
    'productDetail.productOrdersTable.orderId': 'Order ID',
    'productDetail.productOrdersTable.eshopId': 'E-shop order ID',
    'productDetail.productOrdersTable.date': 'Created at',
    'productDetail.productOrdersTable.shipper': 'Shipper',
    'productDetail.productOrdersTable.trackingNumber': 'Tracking number',
    'productDetail.productOrdersTable.status': 'Status',
    'productDetail.productOrdersTable.recipientState': 'Recipient state',
    'productDetail.productOrdersTable.count': 'Required pcs',
    'productDetail.productOrdersTable.missingCount': 'Missing pcs',
    'productDetail.productOrdersTable.confirmed': 'Confirmed pcs',
    'productDetail.history.createProduct': 'Create product',
    'productDetail.history.updateProduct': 'Update product',
    'productDetail.history.deleteProduct': 'Delete product',
    'productDetail.history.PRODUCT_INSERT_COUNTRIES.new': 'New insert country',
    'productDetail.history.PRODUCT_INSERT_COUNTRIES.delete': 'Delete insert country',
    'productDetail.country': 'Country',
    'productDetail.history.PRODUCT_RELATIONS_2.new': 'New product relationship',
    'productDetail.history.PRODUCT_RELATIONS_2.delete': 'Delete product relationship',
    'productDetail.history.PRODUCT_SET.new': 'New product set',
    'productDetail.history.PRODUCT_SET.edit': 'Product set updated',
    'productDetail.history.PRODUCT_SET.delete': 'Product deleted from set',
    'productDetail.history.FILES.new': 'New product attachment',
    'productDetail.history.FILES.edit': 'Product attachment updated',
    'productDetail.history.FILES.delete': 'Product attachment removed',
    'productDetail.history.ORIGINAL_FILE_NAME': 'File',
    'productDetail.attachmentsHistoryType': 'Attachment type',
    'productDetail.attachmentsHistoryFileName': 'File',
    'productDetail.history.PRODUCT_SKU': 'SKU',
    'productDetail.productRelationstable.Count': 'Count',
    'productsImport.title': 'Import product',
    'productsImport.error': 'Error',
    'productsImport.excelFilePattern': 'Download import template',
    'productsImport.import': 'Import product',
    'productsImport.importConfirm': 'Do you really want to import products?',
    'productsImport.columnsOptions': 'Columns options',
    'productsImport.table.results': 'Results',
    'productsImport.table.id': 'ID',
    'productsImport.table.sku': 'SKU',
    'productsImport.table.name': 'Name',
    'productsImport.table.productType': 'Product type',
    'productsImport.table.ean': 'EAN',
    'productsImport.table.expeditionMethod': 'Expadition method',
    'productsImport.table.action': 'Actions',
    'productsImport.action.create': 'Update',
    'productsImport.action.update': 'Create',
    'productsImport.totalCountToImport': 'Count of products to import - Create: {{create}} Update: {{update}}',
    'productsImport.totalCountImported': 'Count of products imported - Created: {{created}} Updated: {{updated}}',
    'productsImport.tab.general': 'General',
    'productsImport.tab.created': 'Created',
    'productsImport.tab.updated': 'Updated',
    'productSets.table.setSku': 'Set SKU',
    'productSets.table.setName': 'Set name',
    'productSets.table.skuCount': 'SKU count',
    'productSets.table.productsCount': 'Products count',
    'productSets.title': 'Products sets',
    'productSets.action.productSetDetail': 'Products set detail',
    'productSets.action.dowloadProductSetsTable': 'Export products sets',
    'productSets.action.exportFileName': 'Export products sets',
    'productSets.action.synchronizeTable': 'Synchronize table',
    'productSets.action.createNew': 'New',
    'productSetDetail.title': 'Product set detail {{setSKU}}',
    'productSetDetail.titleNew': 'Create new product set',
    'productSetDetail.action.create': 'Create product set',
    'productSetDetail.action.addProduct': 'Add product',
    'productSetDetail.action.delete': 'Delete product set',
    'productSetDetail.action.save': 'Save',
    'productSetDetail.action.detail': 'Detail',
    'productSetDetail.create': 'Create product set',
    'productSetDetail.createConfirm': 'Do you really want to create a product set?',
    'productSetDetail.delete': 'Delete product set',
    'productSetDetail.deleteConfirm': 'Do you really want to delete this product set?',
    'productSetDetail.setSku': 'Product set SKU',
    'productSetDetail.confirmGetNewDataStorage': 'Continue with the draft products set',
    'productSetDetail.confirmGetNewDataStorageText':
        'You have a draft order products set - do you want to continue with it?',
    'productSetDetail.productsTable.productSku': 'Product SKU I Name',
    'productSetDetail.productsTable.productCount': 'Product pcs',
    'productSetDetail.action.removeProduct': 'Remove product',
    'productSetDetail.productsTable.action.add': 'Add',
    'productSetDetail.save': 'Save product set',
    'productSetDetail.saveConfirm': 'Do you really want to save this product set?',
    'productSets.message.productSetUpdate': 'Product set updated',
    'productSets.message.productSetCreated': 'Product set created',
    'productSets.message.productSetDeleted': 'Product set deleted',
    'productStockTransfersDetail.title': 'Product stock transfers #{{idProduct}}',
    'productStockTransfersDetail.productsTable.id': 'Id',
    'productStockTransfersDetail.productsTable.snapshotDate': 'Date',
    'productStockTransfersDetail.productsTable.stockQuantity': 'Stock quantity',
    'productStockTransfersDetail.productsTable.description': 'Description',
    'transports.title': 'Transports',
    'transports.allProviders': 'All providers',
    'transports.tab.transports': 'Transports',
    'transports.tab.packageTypes': 'Package types',
    'transports.tab.palletTypes': 'Pallet types',
    'transports.tab.geisPackingTypes': 'Geis packing types',
    'transports.action.transportDetail': 'Transport detail',
    'transports.action.createNew': 'New',
    'transports.action.synchronizeTable': 'Synchronize table',
    'transports.action.exportFileName': 'Export transports',
    'transports.action.exportFile': 'Export transports',
    'transports.table.id': 'ID',
    'transports.table.shipper': 'Shipper',
    'transports.table.shipperService': 'Shipper service',
    'transports.table.status': 'Status',
    'transports.table.type': 'Type',
    'transports.table.item': 'Item ID',
    'transports.table.createdAt': 'Created at',
    'transports.table.sender': 'Sender',
    'transports.table.recipient': 'Recipient',
    'transports.message.transportCreated': 'Transport created',
    'transports.message.transportUpdate': 'Transport updated',
    'transports.message.orderShipmentSuccess': 'Shipment ordered successfully',

    'transportPackageTypes.title': 'Package types',
    'transportPackageTypes.action.createNew': 'New',
    'transportPackageTypes.action.detail': 'Package type detail',
    'transportPackageTypes.action.reload': 'Reload',
    'transportPackageTypes.action.sync': 'Sync types from carrier',
    'transportPackageTypes.action.syncCatalogue': 'Sync catalogue',
    'transportPackageTypes.message.synced': 'Package types were synchronized',
    'transportPackageTypes.message.syncedCatalogue': 'Package type catalogue was synchronized',
    'transportPackageTypes.table.ssrcCode': 'Code',
    'transportPackageTypes.table.name': 'Name',
    'transportPackageTypes.table.geisCode': 'Geis code',
    'transportPackageTypes.table.type': 'Type',
    'transportPackageTypes.table.billingGroup': 'Billing group',
    'transportPackageTypes.table.active': 'Active',
    'transportPackageTypes.table.sortOrder': 'Sort order',
    'transportPackageTypes.table.syncedAt': 'Synced at',

    'transportPackageTypeDetail.title': 'Package type detail {{ssrcCode}}',
    'transportPackageTypeDetail.titleNew': 'New package type',
    'transportPackageTypeDetail.action.save': 'Save',
    'transportPackageTypeDetail.action.deactivate': 'Deactivate',
    'transportPackageTypeDetail.deactivateConfirm': 'Do you really want to deactivate this package type?',
    'transportPackageTypeDetail.ssrcCode': 'Code',
    'transportPackageTypeDetail.name': 'Name',
    'transportPackageTypeDetail.geisCode': 'Geis code',
    'transportPackageTypeDetail.type': 'Type',
    'transportPackageTypeDetail.sortOrder': 'Sort order',
    'transportPackageTypeDetail.active': 'Active',
    'transportPackageTypeDetail.nameCs': 'Name CS',
    'transportPackageTypeDetail.nameEn': 'Name EN',
    'transportPackageTypeDetail.billingGroup': 'Billing group',
    'transportPackageTypeDetail.typeCs': 'Type CS',
    'transportPackageTypeDetail.unitCs': 'Unit CS',
    'transportPackageTypeDetail.message.created': 'Package type was created',
    'transportPackageTypeDetail.message.updated': 'Package type was saved',
    'transportPackageTypeDetail.message.deactivated': 'Package type was deactivated',

    'palletTypes.title': 'Pallet types',
    'palletTypes.action.reload': 'Reload',
    'palletTypes.message.loadError': 'Failed to load pallet types',
    'palletTypes.message.saveError': 'Failed to save pallet type mapping',
    'palletTypes.table.name': 'Name',
    'palletTypes.table.packageType': 'Package type',

    'geisPackingTypes.title': 'Geis packing types',
    'geisPackingTypes.action.reload': 'Reload',
    'geisPackingTypes.action.sync': 'Sync from Geis',
    'geisPackingTypes.action.detail': 'Geis packing type detail',
    'geisPackingTypes.message.loadError': 'Failed to load Geis packing types',
    'geisPackingTypes.message.emptyHint': 'Sync Geis packing types first',
    'geisPackingTypes.message.mappingsSaved': 'Package type mappings were saved',
    'geisPackingTypes.message.mappingsError': 'Failed to save package type mappings',
    'geisPackingTypes.table.code': 'Code',
    'geisPackingTypes.table.name': 'Name',
    'geisPackingTypes.table.packageTypes': 'Package types',
    'geisPackingTypes.table.returnable': 'Returnable',
    'geisPackingTypes.table.active': 'Active',
    'geisPackingTypes.table.syncedAt': 'Synced at',

    'geisPackingTypeDetail.title': 'Geis packing type detail {{code}}',
    'geisPackingTypeDetail.action.save': 'Save',
    'geisPackingTypeDetail.code': 'Code',
    'geisPackingTypeDetail.name': 'Name',
    'geisPackingTypeDetail.returnable': 'Returnable',
    'geisPackingTypeDetail.active': 'Active',
    'geisPackingTypeDetail.packageTypes': 'Package types',
    'geisPackingTypeDetail.packageTypesHint': 'Select package types mapped to this Geis code',
    'geisPackingTypeDetail.message.loadError': 'Failed to load Geis packing type',
    'transportDetail.title': 'Transport detail #{{idTransport}}',
    'transportDetail.titleNew': 'Create new transport',
    'transportDetail.eshopTransportId': 'E-shop transport ID',
    'transportDetail.action.save': 'Save',
    'transportDetail.action.create': 'Create',
    'transportDetail.action.orderShipment': 'Order shipment',
    'transportDetail.action.orderShipmentPending': 'Ordering in progress',
    'transportDetail.shipperFromOrderHint': 'Taken from the order – edit it on the order detail',
    'transportDetail.action.cloneTransport': 'Clone transport',
    'transportDetail.action.showLabel': 'Show label',
    'transportDetail.createTransport': 'Create transport',
    'transportDetail.paidTransport': 'Transport paid',
    'transportDetail.paidTransportOptions': 'Transport payment options',
    'transportDetail.action.addPackage': 'Add package',
    'transportDetail.action.removePackage': 'Remove package',
    'transportDetail.action.nextStep': 'Next step',
    'transportDetail.action.prevStep': 'Previous step',
    'transportDetail.tab.transport': 'Transport',
    'transportDetail.tab.history': 'History',
    'transportDetail.tab.transportHistory': 'Transport history',
    'transportDetail.tab.packages': 'Packages',
    'transportDetail.tab.address': 'Address',
    'transportDetail.tab.summary': 'Summary',
    'transportDetail.tab.apiCalls': 'API calls',
    'transportDetail.tab.events': 'Events',
    'transportDetail.status.created': 'Created',
    'transportDetail.status.shippingCreated': 'Shipping ordered',
    'transportDetail.status.onTheWay': 'On the way',
    'transportDetail.status.atPickupPoint': 'At pickup point',
    'transportDetail.status.delivered': 'Delivered',
    'transportDetail.linkedOrders.title': 'Linked orders',
    'transportDetail.linkedOrders.id': 'ID',
    'transportDetail.linkedOrders.eshopOrderId': 'E-shop order ID',
    'transportDetail.linkedOrders.role': 'Role',
    'transportDetail.linkedOrders.roleSystem': 'System',
    'transportDetail.linkedOrders.roleManual': 'Manual',
    'transportDetail.linkedOrders.orderDetail': 'Order detail',
    'transportDetail.detail': 'Transport detail',
    'transportDetail.invoice': 'Invoice',
    'transportDetail.confirmGetNewDataStorage': 'Continue with the draft transport',
    'transportDetail.confirmGetNewDataStorageText':
        'You have a draft transport saved - do you want to continue with it?',
    'transportDetail.packagesCurrency': 'Packages currency',
    'transportDetail.transport': 'Transport',
    'transportDetail.cashOnDelivery': 'Cash on delivery',
    'transportDetail.recipientInfo': 'Recipient information',
    'transportDetail.senderInfo': 'Sender information',
    'transportDetail.detailInfo': 'Detail information',
    'transportDetail.contact': 'Contact',
    'transportDetail.placeOfDelivery': 'Delivery address',
    'transportDetail.senderAddress': "Sender's / Pickup address",
    'transportDetail.recipientFullName': 'Recipient full name',
    'transportDetail.senderFullName': "Sender's full name",
    'transportDetail.recipientStreet': 'Delivery address (street, number)',
    'transportDetail.senderStreet': "Sender's address (street, number)",
    'transportDetail.showContacts': 'Show contacts',
    'transportDetail.selectProviderCompanyrecipient': 'Select recipient contact (Full name / Attention name / Company name)',
    'transportDetail.selectProviderCompanysender': 'Select sender contact (Full name / Attention name / Company name)',
    'transportDetail.summary': 'Summary',
    'transportDetail.type': 'Type',
    'transportDetail.transportStatus': 'Transport status',
    'transportDetail.idItem': 'Item ID',
    'transportDetail.executeAt': 'Reminder date',
    'transportDetail.pickupDate': 'Pickup date',
    'transportDetail.pickUpAt': 'Pickup date',
    'transportDetail.billedWeight': 'Billed weight/kg',
    'transportDetail.trackingNumber': 'Tracking number',
    'transportDetail.shipperLabel': 'Show shipping label',
    'transportDetail.shipperLabelDownload': 'Download shipping label file',
    'transportDetail.agecheck': 'Age check (18+)',
    'transportDetail.incorrectMessage': 'Error message',
    'transportDetail.paymentMethod': 'Payment method',
    'transportDetail.paid': 'Paid',
    'transportDetail.created': 'Created at',
    'transportDetail.shippingCreatedAt': 'Shipping ordered at',
    'transportDetail.losted': 'Lost at',
    'transportDetail.delivered': 'Delivered at',
    'transportDetail.incorrected': 'Error date',
    'transportDetail.onTheWayAt': 'On the way at',
    'transportDetail.returnedBackAt': 'Returned back at',
    'transportDetail.returningBackAt': 'Returning back at',
    'transportDetail.invoiceNumber': 'Invoice number',
    'transportDetail.invoicePrice': 'Invoice price',
    'transportDetail.invoicePriceCurrency': 'Invoice currency',
    'transportDetail.invoiceDate': 'Invoice date',
    'transportDetail.shipper': 'Shipper',
    'transportDetail.shipperService': 'Shipper service',
    'transportDetail.dispensingPoint': 'Pick-up point',
    'transportDetail.shippingPrice': 'Shipping price',
    'transportDetail.shippingPriceCurrency': 'Shipping price currency',
    'transportDetail.currency': 'Currency',
    'transportDetail.transportPaidBySkladon': 'Transport paid by Skladon',
    'transportDetail.boxCount': 'Box count',
    'transportDetail.shipmentPending': 'Shipment pending?',
    'transportDetail.cashOnDeliveryReferentionNumber': 'Cash on delivery reference number',
    'transportDetail.cashOnDeliveryPrice': 'Cash on delivery price',
    'transportDetail.cashOnDeliveryCurrency': 'Cash on delivery currency',
    'transportDetail.cashOnDeliveryRefNumber': 'Cash on delivery reference number',
    'transportDetail.fullName': 'Full name',
    'transportDetail.attentionName': 'Attention name',
    'transportDetail.addressAdditionalInfo': 'Additional address info',
    'transportDetail.addressAdditionalInfo2': 'Additional address info 2',
    'transportDetail.address': 'Address',
    'transportDetail.additionalInformationForAddress2': 'Additional information for address',
    'transportDetail.city': 'City',
    'transportDetail.country': 'Country',
    'transportDetail.provinceCode': 'Province code',
    'transportDetail.postCode': 'Post code',
    'transportDetail.email': 'E-mail',
    'transportDetail.phone': 'Phone',
    'transportDetail.companyName': 'Company name',
    'transportDetail.message': 'Message',
    'transportDetail.filterTrackingNumber': 'Filter tracking number',
    'transportDetail.weight': 'Weight/kg',
    'transportDetail.unit': 'Unit',
    'transportDetail.canceledAt': 'Canceled at',
    'transportDetail.updatedAt': 'Updated at',
    'transportDetail.lastStatusCheckAt': 'Last status check at',
    'transportDetail.companyId': 'Company ID',
    'transportDetail.taxId': 'Tax ID',
    'transportDetail.addPackage': 'Add package',
    'transportDetail.packageTable.action.add': 'Add',
    'transportDetail.packageTable.action.addPackage': 'Add package',
    'transportDetail.packageTable.status': 'Status',
    'transportDetail.packageTable.currency': 'Currency',
    'transportDetail.packageTable.trackingNumber': 'Tracking number',
    'transportDetail.packageTable.warehouseTrackingNumber': 'Warehouse tracking number',
    'transportDetail.packageTable.openTracking': 'Open tracking',
    'transportDetail.packageTable.packageType': 'Package type',
    'transportDetail.packageTable.weight': 'Weight/kg',
    'transportDetail.packageTable.volume': 'Volume/m³',
    'transportDetail.packageTable.loadingMeters': 'Loading meters',
    'transportDetail.packageTable.width': 'Width/m',
    'transportDetail.packageTable.height': 'Height/m',
    'transportDetail.packageTable.length': 'Length/m',
    'transportDetail.packageTable.price': 'Price',
    'transportDetail.packageTable.boxNumber': 'Expedition box number',
    'transportDetail.packageTable.actions': 'Actions',
    'transportDetail.packageTable.lineState': 'Status',
    'transportDetail.apiCalls.empty': 'No API calls',
    'transportDetail.apiCalls.table.calledAt': 'Called at',
    'transportDetail.apiCalls.table.shipper': 'Shipper',
    'transportDetail.apiCalls.table.operation': 'Operation',
    'transportDetail.apiCalls.table.httpStatus': 'HTTP',
    'transportDetail.apiCalls.table.durationMs': 'ms',
    'transportDetail.apiCalls.table.errorMessage': 'Error',
    'transportDetail.apiCalls.action.showDetail': 'Detail',
    'transportDetail.apiCalls.detailTitle': 'API call #{{id}} · {{operation}}',
    'transportDetail.apiCalls.detail.request': 'Request',
    'transportDetail.apiCalls.detail.response': 'Response',
    'transportDetail.apiCalls.detail.jsonHint': 'JSON is formatted and can be copied.',
    'transportDetail.events.empty': 'No events',
    'transportDetail.events.table.occurredAt': 'Occurred at',
    'transportDetail.events.table.status': 'Status',
    'transportDetail.events.table.shipperStatusCode': 'Shipper status code',
    'transportDetail.events.table.shipperStatusText': 'Shipper status text',
    'transportDetail.events.table.source': 'Source',
    'transportDetail.events.table.location': 'Location',
    'transportDetail.events.table.packageId': 'Package ID',
    'transportDetail.history.PACKAGES.new': 'New package',
    'transportDetail.history.PACKAGES.edit': 'Edited package',
    'transportDetail.confirmPaidAction': 'Change payment method',
    'transportDetail.confirmPaidActionText':
        'Changing the payment method will update the order without saving the other changes entered.',
    'transportDetail.confirmPaidActionText2': 'Are you sure you want to change the payment method now?',
    'transportDetail.confirmPaidActionTextCOD':
        'Are you sure you want to change to cash on delivery? Please fill in the information below:',
    'transportDetail.releaseFromSuspendedAt': 'Set a release date',
    'transportDetail.history.createTransport': 'Transport created',
    'transportDetail.history.updateTransport': 'Transport updated',
    'transportDetail.history.updateTransportToStatus': 'Transport status updated {{STATUS.old}} -> {{STATUS.new}}',
    'transportDetail.history.updateTransportStatusSucces': 'Transport order success: {{STATUS.old}} -> {{STATUS.new}}',
    'transportDetail.history.updateTransportStatusFailure':
        'Transport order unsuccessful: {{STATUS.old}} -> {{STATUS.new}}',
    'transportDetail.history.errorWhileWrittingToDB': 'Error while writing data to the database: {{errorData}}',
    'transportDetail.history.recipient': 'Recipient',
    'transportDetail.history.sender': 'Sender',
    'transportDetail.history.newPackage': 'New package',
    'transportDetail.history.editPackage': 'Edited package',
    'transportDetail.paidAction.transferPaymentPaid': 'Bank transfer - paid',
    'transportDetail.paidAction.transferPaymentNotPaid': 'Bank transfer - not paid',
    'transportDetail.paidAction.cashOnDelivery': 'Cash on delivery',
    'transportDetail.paidAction.onlinePaymentPaid': 'Card online - paid',
    'transportDetail.paidAction.onlinePaymentNotPaid': 'Card online - not paid',
    'transportDetail.paidAction.transferPaymentSend': 'Transfer payment is ready to be sent',
    'transportDetail.emptyData': 'No data',
    'users.title': 'User management',
    'users.action.createNew': 'New',
    'users.exportFileName': 'Export users',
    'users.action.synchronizeTable': 'Synchronize table',
    'users.action.userDetail': 'User detail',
    'users.action.permissionsDetail': 'Permissions detail',
    'users.action.notificationsDetail': 'Notifications detail',
    'users.message.userCreated': 'User created',
    'users.message.userUpdate': 'User updated',
    'users.message.userDeleted': 'User deleted',
    'users.messages.userActive': 'User activeted',
    'users.messages.userDeactive': 'User deactivated',
    'users.message.userNotificationsUpdate': 'Notifications updated',
    'users.message.userPermissionsUpdate': 'Permissions updated',
    'users.table.id': 'ID',
    'users.table.name': 'Name',
    'users.table.surname': 'Surname',
    'users.table.emailAddress': 'E-mail',
    'users.table.role': 'Role',
    'users.table.dateCreated': 'Created at',
    'users.table.status': 'Status',
    'users.table.photo': 'Photo',
    'users.table.skladonUser': 'Skladon employee',
    'users.table.eshops': 'E-shops',
    'users.table.phone': 'Phone',
    'users.table.lastLogin': 'Last login',
    'users.table.lastChangedPassword': 'Password changed',
    'users.table.creatorId': 'Creator ID',
    'users.table.lang': 'Notification language',
    'users.table.actions': 'Actions',
    'userDetail.titleNew': 'Create new user',
    'userDetail.title': 'User detail #{{idUser}}',
    'userDetail.createUser': 'Create user',
    'userDetail.save': 'Save user',
    'userDetail.create': 'Create user',
    'userDetail.createConfirm': 'Do you really want to create a user?',
    'userDetail.saveConfirm': 'Do you really want to save this user?',
    'userDetail.action.save': 'Save',
    'userDetail.action.create': 'Create',
    'userDetail.name': 'Name',
    'userDetail.surname': 'Surname',
    'userDetail.email': 'E-mail',
    'userDetail.roles': 'Role',
    'userDetail.active': 'Active',
    'userDetail.street': 'Address (street, number)',
    'userDetail.city': 'City',
    'userDetail.state': 'State',
    'userDetail.postCode': 'Post code',
    'userDetail.phone': 'Phone',
    'userDetail.companyId': 'Company ID',
    'userDetail.taxId': 'Tax ID',
    'userDetail.skladonUser': 'Skladon employee',
    'userDetail.providers': 'E-shops',
    'userDetail.allProviders': 'All providers',
    'userDetail.providersNotificate': 'Notified e-shops',
    'userDetail.confirmGetNewDataStorage': 'Continue with the draft user',
    'userDetail.confirmGetNewDataStorageText': 'You have a draft user saved - do you want to continue with it?',
    'userNotificationsDetail.title': 'Edit user notifications #{{idUser}} - {{email}}',
    'userNotificationsDetail.titleTree': 'All notification',
    'userNotificationsDetail.save': 'Save',
    'userNotificationsDetail.saveConfirm': 'Are you sure you want to save notifications for this user?',

    'userNotificationsDetail.tree.email': 'E-mail',
    'userNotificationsDetail.tree.push': 'Push',
    'userNotificationsDetail.tree.CLAIM': 'Claim',
    'userNotificationsDetail.tree.CREATE': 'Created',
    'userNotificationsDetail.tree.REMINDER': 'Reminder',
    'userNotificationsDetail.tree.UPDATE': 'Updated',
    'userNotificationsDetail.tree.UPDATE_STATUS': 'Status updated',
    'userNotificationsDetail.tree.JOB': 'Job',
    'userNotificationsDetail.tree.ORDER': 'Order',
    'userNotificationsDetail.tree.SENT_TODAY_B2B': 'B2B - Sent today',
    'userNotificationsDetail.tree.SENT_TODAY_B2C': 'B2C - Sent today',
    'userNotificationsDetail.tree.PALLETS': 'Pallets',
    'userNotificationsDetail.tree.SHIPPING': 'Shipping',
    'userNotificationsDetail.tree.ZASILKOVNA': 'Zásilkovna',
    'userNotificationsDetail.tree.INVALID_DISPESING_POINT': 'Invalid pick-up point',
    'userNotificationsDetail.tree.PRODUCT': 'Products',
    'userNotificationsDetail.tree.TRASH_EVENT_RECORDED': 'Product / EAN errors',
    'userNotificationsDetail.tree.ROP': 'Reorder point',
    'userNotificationsDetail.tree.EXPIRATION_DAYS': 'Expiration',
    'userNotificationsDetail.tree.RECEIVING': 'Receivings',
    'userNotificationsDetail.tree.UPDATE_PRODUCTS_INCOMPLETE': 'Receiving incomplete',
    'userNotificationsDetail.tree.UPDATE_STATUS_CONFIRMED': 'Confirmed',
    'userNotificationsDetail.tree.RETURN': 'Returns',
    'userNotificationsDetail.tree.STOCK_TAKING': 'Stock taking',
    'userNotificationsDetail.tree.TRANSPORT': 'Transport',
    'userNotificationsDetail.tree.CANCELED': 'Canceled',
    'userNotificationsDetail.tree.CREATED': 'Created',
    'userNotificationsDetail.tree.DELIVERED': 'Delivered',
    'userNotificationsDetail.tree.INNCORRECT': 'Incorrect',
    'userNotificationsDetail.tree.INCORRECT': 'Incorrect',
    'userNotificationsDetail.tree.LOST': 'Lost',
    'userNotificationsDetail.tree.ONTHEWAY': 'On the way',
    'userNotificationsDetail.tree.ATPICKUPPOINT': 'At pickup point',
    'userNotificationsDetail.tree.RETURNEDBACK': 'Returned back',
    'userNotificationsDetail.tree.RETURNINGBACK': 'Returning back',
    'userNotificationsDetail.tree.SHIPPINGCREATED': 'Shipping created',
    'userNotificationsDetail.tree.WAITINGFORPAYMENT': 'Waiting for payment',
    'userNotificationsDetail.tree.SUSPENDED': 'Suspended',
    'userNotificationsDetail.tree.WAITINGFORSHIPMENT': 'Ordering transport',
    'userNotificationsDetail.tree.RECEIVED': 'Received',
    'userNotificationsDetail.tree.INPROCESS': 'Processing',
    'userNotificationsDetail.tree.PACKED': 'Packed',
    'userNotificationsDetail.tree.WAITINGFORCARRIER': 'Waiting for carrier',
    'userNotificationsDetail.tree.PRERECEIVED': 'Waiting for processing',
    'userNotificationsDetail.tree.PREORDER': 'Pre-order',

    'userNotificationsDetail.tree.UNLOADED': 'Unloaded',
    'userNotificationsDetail.tree.CONFIRMED': 'Confirmed',
    'userNotificationsDetail.tree.ACCEPTEDWAITINGFORCOMPENSATIONFROMSHIPPER': 'Accepted - awaiting compensation',
    'userNotificationsDetail.tree.ACCEPTEDPENDINGCLIENTCOMPENSATION': 'Accepted - pending compensation to client',
    'userNotificationsDetail.tree.STORNO': 'Canceled',
    'userNotificationsDetail.tree.PRODUCTSNOTAVAILABLE': 'Products not available',
    'userNotificationsDetail.tree.ACCEPTED': 'Accepted',
    'userNotificationsDetail.tree.MOREINFONEEDED': 'More info needed',
    'userNotificationsDetail.tree.REJECTED': 'Rejected',

    'userPermissionsDetail.title': 'Edit user permissions #{{idUser}}',
    'userPermissionsDetail.action.save': 'Save',
    'userPermissionsDetail.save': 'Save user permissions',
    'userPermissionsDetail.saveConfirm': 'Do you really want to save permissions for this user?',
    'userPermissionsDetail.titleTree': 'Permissions',
    'userPermissionsDetail.name': 'Name',
    'userPermissionsDetail.surname': 'Surname',
    'userPermissionsDetail.roles': 'Roles',
    'admin.roles': 'Roles',
    'admin.permissions': 'Permissions',
    'admin.providers': 'Providers',
    'admin.system': 'System',
    'admin.constants': 'Constants',
    'admin.applicationStatusMessages': 'Application messages',
    'admin.emailTemplates': 'E-mail templates',
    'admin.carriers': 'Carriers',
    'carriers.title': 'Shippers',
    'carriers.table.id': 'ID',
    'carriers.table.shipper': 'Shipper',
    'carriers.table.cot': 'Cut-off time (COT)',
    'carriers.table.createdAt': 'Created at',
    'carriers.table.updatedAt': 'Updated at',

    'carriers.action.createNew': 'Create carrier',
    'carriers.action.exportFile': 'Export file',
    'carriers.action.exportFileName': 'carriers',
    'carriers.action.synchronizeTable': 'Refresh table',
    'carriers.action.carrierDetail': 'Carrier detail',

    'carrierDetail.title': 'Carrier #{{idCarrier}}',
    'carrierDetail.titleNew': 'New carrier',
    'carrierDetail.shipper': 'Shipper',
    'carrierDetail.cot': 'Cut-off time (COT)',
    'carrierDetail.create': 'Create',
    'carrierDetail.save': 'Save',
    'carrierDetail.delete': 'Delete',
    'carrierDetail.deleteConfirm': 'Do you really want to delete this carrier?',
    'carrierDetail.message.carrierCreated': 'Carrier has been created',
    'carrierDetail.message.carrierUpdated': 'Carrier has been updated',
    'carrierDetail.message.carrierDeleted': 'Carrier has been deleted',


    'roles.title': 'Roles',
    'roles.action.synchronizeTable': 'Synchronize roles',
    'roles.action.createNew': 'New',
    'roles.table.id': 'ID',
    'roles.table.name': 'Name',
    'roles.table.info': 'Info',
    'roles.table.countPermissions': 'Permissions',
    'roles.table.actions': 'Actions',
    'roles.action.roleDetail': 'Role detail',
    'roles.action.roleApprovedDetail': 'Approved roles',
    'roles.message.roleCreated': 'Role created',
    'roles.message.roleUpdate': 'Role updated',
    'roleDetail.titleNew': 'Create new role',
    'roleDetail.title': 'Update role #{{idRole}}',
    'roleDetail.create': 'Create role',
    'roleDetail.save': 'Save',
    'roleDetail.createConfirm': 'Do you really want to create a role?',
    'roleDetail.saveConfirm': 'Do you really want to save this role?',
    'roleDetail.name': 'Name',
    'roleDetail.info': 'Info',
    'permissions.title': 'Permissions',
    'permissions.permissionDetail': 'Permission detail',
    'permissions.action.createNew': 'New',
    'permissions.action.synchronizeTable': 'Synchronize permissions',
    'permissions.message.permissionCreated': 'Permission created',
    'permissions.message.permissionUpdate': 'Permission updated',
    'permissions.message.permissionDeleted': 'Permission deleted',
    'permissions.PRODUCT.EXP_METHOD.EDIT': 'Edit product expedition method',
    'permissions.ORDER.EXPORT.TABLE': 'Export orders',
    'permissions.ORDER.EXPORT.PRODUCTS': 'Export orders with products',
    'permissions.ORDER.EXPORT.PRODUCTS_SUMMARIZED': 'Export orders with summarized products',
    'permissions.ORDER.EXPORT.EXPEDITION_PACKAGE': 'Export expedition packages',
    'permissions.ORDER.EXPORT.EXPEDITION_PACKAGE_PRODUCTS': 'Export expedition packages with products',
    'permissions.CLAIM.EXPORT.TABLE': 'Export claims',
    'permissions.CLAIM.EXPORT.PRODUCTS': 'Export claims with products',
    'permissions.CLAIM.CREATE_MULTIPLE': 'Create multiple claims for one order',
    'permissions.RETURN.EXPORT.TABLE': 'Export returns',
    'permissions.RETURN.EXPORT.PRODUCTS': 'Export returns with products',
    'permissions.RECEIVING.EXPORT.TABLE': 'Export receivings',
    'permissions.RECEIVING.EXPORT.PRODUCTS': 'Export receivings with products',
    'permissions.PRODUCT.EXPORT': 'Export products',
    'permissions.PROVIDER.EXPORT': 'Export providers',
    'permissionDetail.titleNew': 'Create new permission',
    'permissionDetail.title': 'Update permission #{{idPermission}}',
    'permissionDetail.pid': 'Permission detail',
    'permissionDetail.description': 'Description',
    'permissionDetail.create': 'Create permission',
    'permissionDetail.save': 'Save',
    'permissionDetail.createConfirm': 'Do you really want to create a permission?',
    'permissionDetail.saveConfirm': 'Do you really want to save this permission?',
    'permissionDetail.deletePermission': 'Delete permission',
    'permissionDetail.deletePermissionConfirm': 'Are you sure you want to delete this permission?',
    'providers.title': 'E-shops',
    'providers.providers': 'E-shops',
    'providers.providersWaiting': 'Shoptet e-shops waiting for registration',
    'providers.action.providerDetail': 'E-shop detail',
    'providers.action.createNew': 'New',
    'providers.action.synchronizeTable': 'Synchronize table',
    'providers.action.providerConfig': 'E-shop configuration',
    'providers.action.providerIntegrationConfig': 'Integration configuration',
    'providers.action.exportFile': 'Export e-shops',
    'providers.action.exportFileName': 'Export e-shop',
    'providers.message.providerCreated': 'E-shop created',
    'providers.message.providerUpdate': 'E-shop updated',
    'providers.table.id': 'ID',
    'providers.table.idDcix': 'DCIx ID',
    'providers.table.eshopName': 'E-shop name',
    'providers.table.businessName': 'Business name',
    'providers.table.website': 'Website',
    'providers.table.email': 'E-mail',
    'providers.table.system': 'Platform',
    'providers.table.actions': 'Actions',
    'providers.table.active': 'Active',
    'providers.table.enableReturnLabels': 'Enable return labels',
    'providers.table.returnLabelsForAllOrders': 'Return labels for all orders',

    // Provider detail table translations
    'providers.table.providerDetail.clientType': 'Client type',
    'providers.table.providerDetail.businessField': 'Business field',
    'providers.table.providerDetail.salesRepresentative': 'Sales representative',
    'providers.table.providerDetail.keyAccountManager': 'Key Account Manager',
    'providers.table.providerDetail.billingPostCode': 'Billing post code',
    'providers.table.providerDetail.contactNumber': 'Contact number',
    'providers.table.providerDetail.billingEmail': 'Billing e-mail',
    'providers.table.providerDetail.contractSigningDate': 'Date of contract signing',
    'providers.table.providerDetail.contractTerm': 'Contract term',
    'providers.table.providerDetail.contractEndDate': 'End of contract',
    'providers.table.providerDetail.invoiceDueDays': 'Invoice due date (in days)',
    'providers.table.providerDetail.noticePeriodMonths': 'Notice period (in months)',
    'providers.table.providerDetail.slaAlzaShipping': 'SLA Alza shipping',

    // Additional provider detail table translations
    'providers.table.providerDetail.virtualEshopParent': 'Parent provider e-shop',
    'providers.table.providerDetail.eshopKey': 'E-shop key',
    'providers.table.providerDetail.shoptetStockRatio': 'Quantity stock ratio',
    'providers.table.providerDetail.allowedOrderProductsEdit': 'Edit products in orders',
    'providers.table.providerDetail.enableReturnLabels': 'Enable return labels',
    'providers.table.providerDetail.printReturnLabel': 'Return labels for all orders',
    'providers.table.providerDetail.underSanctionEnabled': 'Order under sanction',
    'providers.table.providerDetail.allowDisableShippingReorder': 'External TN (Marketplace) - do not order shipping',
    'providers.table.providerDetail.customsWarehouseEnabled': 'Customs warehouse',
    'providers.table.providerDetail.dcixExportPersonalData': 'Export personal data to DCIx on order',
    'providers.table.providerDetail.orderProductDetail': 'Order product detail (customization)',
    'providers.table.providerDetail.printFiles': 'Print files',
    'providers.table.providerDetail.updateAllStock': 'Update all stock',
    'providers.table.providerDetail.receivingPostponeHours': 'Receiving SLA',
    'providers.table.providerDetail.b2cSla': 'B2C SLA',
    'providers.table.providerDetail.b2bSla': 'B2B SLA',
    'providers.table.providerDetail.b2bD0': 'B2B D0',
    'providers.table.providerDetail.b2bD1': 'B2B D1',
    'providers.table.providerDetail.b2bD2': 'B2B D2',
    'providers.table.providerDetail.b2bD3': 'B2B D3',
    'providers.table.providerDetail.contactPerson': 'Contact person',
    'providers.table.providerDetail.phone': 'Contact number',
    'providers.table.providerDetail.street': 'Address (street, number)',
    'providers.table.providerDetail.city': 'City',
    'providers.table.providerDetail.postCode': 'Post code',
    'providers.table.providerDetail.state': 'State',
    'providers.table.providerDetail.billingStreet': 'Billing address (street, number)',
    'providers.table.providerDetail.billingCity': 'Billing city',
    'providers.table.providerDetail.billingState': 'Billing state',
    'providers.table.providerDetail.companyId': 'Company ID',
    'providers.table.providerDetail.taxId': 'Tax ID/VAT',
    'providers.table.providerDetail.eori': 'EORI',
    'providers.table.providerDetail.GLN': 'GLN',
    'providers.table.providerDetail.status': 'Status',
    'providers.table.providerDetail.plannedLaunch': 'Planned launch',
    'providers.table.providerDetail.actualLaunch': 'Actual launch',
    'providers.table.providerDetail.plannedOffboarding': 'Planned OFFboarding',
    'providers.table.providerDetail.actualOffboarding': 'Actual OFFboarding',
    'providers.table.providerDetail.shownInMys': 'Shown in MyS',

    'providerDetail.title': 'Edit e-shop #{{idProvider}} - {{eshopName}}',
    'providerDetail.titleNew': 'Create new e-shop',
    'providerDetail.action.save': 'Save',
    'providerDetail.action.create': 'Create',
    'providerDetail.createProvider': 'Create e-shop',
    'providerDetail.editProvider': 'Edit e-shop',
    'providerDetail.provider': 'Provider',
    'providerDetail.shoptetOrderStatus': 'Shoptet order status',
    'providerDetail.shoptetPaymentMethods': 'Shoptet payment methods',
    'providerDetail.shoptetStock': 'Shoptet stock',
    'providerDetail.shoptetShippingMethods': 'Shoptet shipping methods',
    'providerDetail.updateDataFromShoptet': 'Update data from Shoptet',
    'providerDetail.businessName': 'Business name',
    'providerDetail.eshopName': 'E-shop name',
    'providerDetail.orderProductDetail': 'Order product detail (customization)',
    'providerDetail.underSanctionEnabled': 'Orders under sanction',
    'providerDetail.branchIdEnabled': 'Branch ID (B2Bc)',
    'providerDetail.email': 'E-mail',
    'providerDetail.providerWebsite': 'Website',
    'providerDetail.street': 'Address (street, number)',
    'providerDetail.city': 'City',
    'providerDetail.state': 'State',
    'providerDetail.postCode': 'Post code',
    'providerDetail.printFiles': 'Print files',
    'providerDetail.orderProductFiles': 'Order product detail',
    'providerDetail.GLN': 'GLN',
    'providerDetail.EORI': 'EORI',
    'providerDetail.contactPerson': 'Contact person',
    'providerDetail.allowExpedition': 'Allow expedition',
    'providerDetail.allowedOrderProductsEdit': 'Allowed order products edit',
    'providerDetail.enableReturnLabels': 'Enable return labels',
    'providerDetail.printReturnLabel': 'Return labels for all orders',
    'providerDetail.sendRecipientEmailB2BSend': 'Send an email to the recipient about the dispatch of a B2B order',
    'providerDetail.sendRecipientEmailB2CSend': 'Send an email to the recipient about sending the order B2C',
    'providerDetail.serviceCodes': 'Carrier services',
    'providerDetail.serviceCodesOther': 'Other',
    'providerDetail.companyId': 'Company ID',
    'providerDetail.taxId': 'Tax ID',
    'providerDetail.billingStreet': 'Billing street',
    'providerDetail.billingCity': 'Billing city',
    'providerDetail.billingState': 'Billing state',
    'providerDetail.phone': 'Phone',
    'providerDetail.system': 'System',
    'providerDetail.stockId': 'Stock ID',
    'providerDetail.users': 'Users',
    'providerDetail.usersNotificate': 'Notificate',

    'providerDetail.transport': 'Transport',
    'providerDetail.emails': 'E-mails',
    'providerDetail.stockName': 'Stock name',
    'providerDetail.serviceCode': 'Service code',
    'providerDetail.shippingMethod': 'Shipping method',
    'providerDetail.active': 'Active',
    'providerDetail.demoProvider': 'Demo e-shop',
    'providerDetail.userName': 'User name',
    'providerDetail.userSurname': 'User surname',
    'providerDetail.detail': 'Detail',
    'providerDetail.contract': 'Contract arrangement',
    'providerDetail.sla': 'SLA',
    'providerDetail.it': 'IT',
    'providerDetail.history': 'History',
    'providerDetail.eshopKey': 'E-shop key',
    'providerDetail.virtualEshopParent': 'Virtual e-shop parent',
    'providerDetail.updateAllStock': 'Update all stock',
    'providerDetail.receivingPostponeHours': 'Receiving postpone hours',
    'providerDetail.b2cSla': 'B2C SLA time',
    'providerDetail.b2bSla': 'B2B SLA time',
    'providerDetail.b2bD0': 'B2B D0',
    'providerDetail.b2bD1': 'B2B D1',
    'providerDetail.b2bD2': 'B2B D2',
    'providerDetail.b2bD3': 'B2B D3',
    'providerDetail.shoptetStockRatio': 'Quantity stock ratio',
    'providerDetail.dcixProviderId': 'DCIx provider ID',
    'providerDetail.allowDisableShippingReorder': 'External TN (Marketplace) - do not order shipping',
    'providerDetail.customsWarehouseEnabled': 'Customs warehouse',
    'providerDetail.dcixExportPersonalData': 'Export personal data to DCIx on order',
    'providerDetail.confirmGetNewDataStorage': 'Continue with the draft e-shop',

    // New fields
    'providerDetail.clientType': 'Client type',
    'providerDetail.businessField': 'Business field',
    'providerDetail.salesRepresentative': 'Sales representative',
    'providerDetail.keyAccountManager': 'Key Account Manager',
    'providerDetail.billingPostCode': 'Billing post code',
    'providerDetail.contactNumber': 'Contact number',
    'providerDetail.billingEmail': 'Billing e-mail',
    'providerDetail.contractSigningDate': 'Date of contract signing',
    'providerDetail.contractTerm': 'Contract term',
    'providerDetail.contractEndDate': 'End of contract',
    'providerDetail.invoiceDueDays': 'Invoice due date (in days)',
    'providerDetail.noticePeriodMonths': 'Notice period (in months)',
    'providerDetail.contractWithClient': 'Contract with client',
    'providerDetail.qualityLevelAndCompensation': 'Quality level and compensation',
    'providerDetail.documents': 'Documents',
    'providerDetail.receiptProductsDiscount': 'Receipt of products into the warehouse',
    'providerDetail.returnReceiptDiscount': 'Receipt of returned shipments to the warehouse',
    'providerDetail.b2cDispatchDiscount': 'Dispatch of B2C orders',
    'providerDetail.b2bDispatchDiscount': 'Dispatch of B2B orders',
    'providerDetail.hours12to24': '12-24 hrs',
    'providerDetail.hours24to48': '24-48 hrs',
    'providerDetail.hours48to72': '48-72 hrs',
    'providerDetail.hours72Plus': '72+ hrs',
    'providerDetail.percent9795': '97.99-95%',
    'providerDetail.percent9490': '94.99-90%',
    'providerDetail.percent89Less': '89.99% or less',
    'providerDetail.products0100': '0-100 products (D+1)',
    'providerDetail.products101999': '101-999 products (D+2)',
    'providerDetail.products10004000': '1000-4000 products (D+3)',
    'providerDetail.products4001Plus': '4001 products (D+X)',
    'providerDetail.lossAndErrorRate': 'Loss and Error Rate',
    'providerDetail.acceptableLossPercent': 'Acceptable loss in %',
    'providerDetail.errorRatePercent': 'Natural error rate in %',
    'providerDetail.slaAlzaShipping': 'SLA Alza shipping',
    'providerDetail.confirmGetNewDataStorageText': 'You have a draft e-shop saved - do you want to continue with it?',

    // Additional missing fields for history
    'providerDetail.publicId': 'Public ID',
    'providerDetail.logo': 'Logo',
    'providerDetail.bankAccountNo': 'Bank Account Number',
    'providerDetail.eori': 'EORI',

    'providerDetail.externalDcixImport': 'External DCIx Import',
    'providerDetail.importFromStatus': 'Import From Status',
    'providerDetail.secondary': 'Secondary',
    'providerDetail.defaultAllowExpedition': 'Default Allow Expedition',
    'providerDetail.sendRecipientEmailB2bOnTheWay': 'Send Recipient Email B2B On The Way',
    'providerDetail.sendRecipientEmailB2cOnTheWay': 'Send Recipient Email B2C On The Way',

    // Specific discount field translations
    'providerDetail.receiptDiscount12to24': 'Receipt Products 12-24h (discount %)',
    'providerDetail.receiptDiscount24to48': 'Receipt Products 24-48h (discount %)',
    'providerDetail.receiptDiscount48to72': 'Receipt Products 48-72h (discount %)',
    'providerDetail.receiptDiscount72Plus': 'Receipt Products 72h+ (discount %)',
    'providerDetail.returnReceiptDiscount12to24': 'Return Receipt 12-24h (discount %)',
    'providerDetail.returnReceiptDiscount24to48': 'Return Receipt 24-48h (discount %)',
    'providerDetail.returnReceiptDiscount48to72': 'Return Receipt 48-72h (discount %)',
    'providerDetail.returnReceiptDiscount72Plus': 'Return Receipt 72h+ (discount %)',
    'providerDetail.b2cDispatchDiscount9795': 'B2C Dispatch 97-95% (discount %)',
    'providerDetail.b2cDispatchDiscount9490': 'B2C Dispatch 94-90% (discount %)',
    'providerDetail.b2cDispatchDiscount89Less': 'B2C Dispatch 89% and less (discount %)',
    'providerDetail.b2bDispatchDiscount0100': 'B2B Dispatch 0-100 pcs (discount %)',
    'providerDetail.b2bDispatchDiscount101999': 'B2B Dispatch 101-999 pcs (discount %)',
    'providerDetail.b2bDispatchDiscount10004000': 'B2B Dispatch 1000-4000 pcs (discount %)',
    'providerDetail.b2bDispatchDiscount4001Plus': 'B2B Dispatch 4001+ pcs (discount %)',

    // Tooltip translations
    'providerDetail.receiptProductsDiscount.tooltip': 'The discount in % applies to delayed listing of products in the warehouse compared to the agreed SLA.',
    'providerDetail.returnReceiptDiscount.tooltip': 'The discount in % applies to delayed listing of returned products in the warehouse compared to the agreed SLA.',
    'providerDetail.b2cDispatchDiscount.tooltip': 'The discount in % applies to shipments that were not dispatched in accordance with the agreed SLA.',
    'providerDetail.b2bDispatchDiscount.tooltip': 'The discount in % applies to shipments that were not dispatched in accordance with the agreed SLA.',

    'providerDetail.emailTemplates': 'E-mail templates',
    'providerDetail.emailtemplates.type': 'Type',
    'providerDetail.emailtemplates.language': 'Language',
    'providerDetail.emailtemplates.templateId': 'Template ID',
    'providerDetail.emailtemplates.actions': 'Actions',
    'providerDetail.emailtemplates.addTemplate': 'Add template',
    'providerDetail.emailtemplates.removeTemplate': 'Remove template',
    'providerDetail.action.nextStep': 'Next step',
    'providerDetail.action.prevStep': 'Previous step',

    // Status and lifecycle fields
    'providerDetail.statusSection': 'Status',
    'providerDetail.status': 'Status',
    'providerDetail.plannedLaunch': 'Planned launch',
    'providerDetail.actualLaunch': 'Actual launch',
    'providerDetail.plannedOffboarding': 'Planned OFFboarding',
    'providerDetail.actualOffboarding': 'Actual OFFboarding',
    'providerDetail.shownInMys': 'Shown in MyS',
    'providerDetail.pipesInTest': 'Upload (MyS → platform)',
    'providerDetail.pipesActive': 'Download (platform → MyS)',
    'providerDetail.pipesUpload.yes': 'Yes',
    'providerDetail.pipesUpload.no': 'No',
    'providerDetail.pipesDownload.yes': 'Yes',
    'providerDetail.pipesDownload.no': 'No',

    // Provider status codes
    'utils.providerStatusCodes.created': 'Created',
    'utils.providerStatusCodes.onboarding': 'ONboarding in progress',
    'utils.providerStatusCodes.active': 'Active',
    'utils.providerStatusCodes.scheduledOffboarding': 'Scheduled OFFboarding',
    'utils.providerStatusCodes.inactiveDataExport': 'Inactive - data export only',
    'utils.providerStatusCodes.inactiveNoTransfers': 'Inactive - no data transfers',
    'utils.providerStatusCodes.storedGoodsOnly': 'Stored goods - without orders',

    'providerDetail.history.Provider created': 'E-shop created',
    'providerDetail.history.Provider updated': 'E-shop updated',

    'providerConfigDetail.title': 'E-shop configuration #{{idProvider}} - {{eshopName}}',
    'providerConfigDetail.action.save': 'Save e-shop configuration',
    'providerConfigDetail.action.newStructureItem': 'New configuration structure',
    'providerConfigDetail.message.update': 'Configuration updated',
    'providerConfigDetail.message.missingSystem': 'The e-shop has no integration system (SYSTEM) configured. Configuration cannot be loaded or saved.',
    'providerConfigDetail.confirm.deleteKeysTitle': 'Delete configuration keys?',
    'providerConfigDetail.confirm.deleteKeysText': 'Saving will delete the following keys that are not filled in the form:\n{{keys}}',
    'providerConfig.mappedShippingMethodsOnly': 'Mapped shipping methods only',
    'providerConfig.allowOrdersWithoutPaymentMethod': 'Allow orders without payment method',
    'system.title': 'System',
    'system.config': 'Configuration',
    'systemConfigDetail.titleTree': 'Configuration structure',
    'systemConfigDetail.editStructureItem': 'Edit configuration structure item',
    'systemConfigDetail.newStructureItem': 'New structure',
    'systemConfigDetail.title': 'System configuration',
    'systemConfigDetail.save': 'Save',
    'systemConfigDetail.enabledShippers.none': 'No shippers',
    'systemConfigDetail.enabledShippers.title': 'Shippers ordered via transport-ms',
    'systemConfigDetail.message.update': 'Configuration updated',
    'systemConfigDetail.message.applicationInstalled': 'E-shop installed in Pipes',
    'systemConfigDetail.message.applicationActivated': 'E-shop activated in Pipes',
    'systemConfigDetail.message.applicationDeactivated': 'E-shop deactivated in Pipes',
    'systemConfigDetail.action.installApplication': 'Install to Pipes',
    'systemConfigDetail.action.activateApplication': 'Activate in Pipes',
    'systemConfigDetail.action.deactivateApplication': 'Deactivate in Pipes',
    'systemConfigDetail.action.activateApplicationConfirm': 'Do you really want to ACTIVATE this e-shop in Pipes?\n\nCurrent values:\nActive: {{active}}\nInTest: {{inTest}}\n\nData download/upload platform <-> MyS will be activated.',
    'systemConfigDetail.action.deactivateApplicationConfirm': 'Do you really want to change the settings of this e-shop in Pipes?\n\nCurrent values:\nActive: {{active}}\nInTest: {{inTest}}\n\nData download/upload platform <-> MyS will be deactivated.',
    'systemConfigDetail.action.activateApplicationLabel': 'Set values for Pipes:',
    'systemConfigDetail.action.activeLabel': 'Active',
    'systemConfigDetail.action.inTestLabel': 'InTest',
    'systemConfigDetail.action.downloadLabel': 'Download (platform → MyS)',
    'systemConfigDetail.action.uploadLabel': 'Upload (MyS → platform)',
    'systemConfigDetail.action.statusActive': 'ACTIVE',
    'systemConfigDetail.action.statusInactive': 'INACTIVE',
    'systemConfig.newStructureItem': 'New configuration structure item',
    'systemConfig.action.saveStuctureItem': 'Save configuration structure item',
    'systemConfig.editStructureItem': 'Edit configuration structure item',
    'systemConfig.action.addStuctureItem': 'Add configuration structure item',
    'systemConfig.structure.key': 'Key',
    'systemConfig.structure.type': 'Type',
    'systemConfig.structure.description': 'Description',
    'systemConfig.messages.keyAlreadyUsed': 'Key already use in another item',
    'constants.title': 'Constants',
    'constants.action.constantDetail': 'Constant detail',
    'constantDetail.action.save': 'Save',
    'constants.table.name': 'Name',
    'constants.table.count': 'Count',
    'constants.message.constantUpdate': 'Constant updated',
    'constantDetail.addItem': 'Add item',
    'constantDetail.removeItem': 'Remove item',
    'constantDetail.title': 'Edit constant: {{constantKey}}',
    'constantDetail.table.label': 'Label',
    'constantDetail.table.value': 'Value',
    'constantDetail.table.shipperCode': 'Shipper code',
    'constantDetail.table.color': 'Color',
    'constantDetail.table.editOrder': 'Edit order',
    'constantDetail.table.ORDER_INT': 'Order',
    'constantDetail.table.awaiting': 'Awaiting',
    'constantDetail.table.shipper': 'Shipper',
    'constantDetail.table.lang': 'Lang',
    'constantDetail.table.countryCodesSelect': 'Countries',
    'constantDetail.table.isReturn': 'Return',
    'constantDetail.table.isExpedition': 'Expedition',
    'constantDetail.action.addItem': 'Add item',
    'constantDetail.action.removeItem': 'Remove item',
    'constantDetail.itemsTable.action.add': 'Add',
    'constantDetail.save': 'Save constant',
    'constantDetail.saveConfirm': 'Do you realy want to save a constant?',

    'error.enableEditOrderInStatus': 'This order cannot be edited',
    'error.empty': 'This value is empty',
    'error.wrongValue': 'Invalid value',
    'error.notNumber': 'Not a number',
    'error.isNegative': 'This value must not be negative',
    'error.wrongRequiredNumberValue': 'This value cannot be 0 or a decimal number',
    'error.exceededMaxLength': 'Exceeded max length {{length}} chars',

    'profil.title': 'User profile #{{userId}} - {{email}}',
    'profil.changePassword': 'Change password',
    'profil.save': 'Save',
    'profil.basicDataTitle': 'Personal information',
    'profil.profilePictureTitle': 'Profile picture',
    'profil.notificationsTitle': 'Notifications',
    'profil.addressTitle': 'Address (optional)',
    'profil.languageTitle': 'Notification language',
    'profil.name': 'Name',
    'profil.surname': 'Surname',
    'profil.phone': 'Phone',
    'profil.userEmail': 'E-mail',
    'profil.role': 'Role',
    'profil.street': 'Address (street, number)',
    'profil.city': 'City',
    'profil.state': 'State',
    'profil.postCode': 'Post code',
    'profil.language': 'Select notification language',
    'changePassword.title': 'Change password',
    'changePassword.oldPassword': 'Old password',
    'changePassword.newPassword': 'New password',
    'changePassword.comparePassword': 'Confirm new password',
    'changePassword.sumbit': 'Save password',
    'changePassword.changedDialogTitle': 'Password changed',
    'changePassword.changedDialogText':
        'Your password has been changed. For security reasons we will log you out, please log in with the new password.',
    'changePassword.logout': 'Logout',
    'changePassword.incorretPasswordText':
        'The password must be at least 8 characters long and contain an uppercase and lowercase letter and a number',
    'changePassword.incorretPasswordMatchText': 'Passwords don\'t match',
    'tasks.title': 'Task list',
    'tasks.action.synchronizeTable': 'Synchronize table',
    'tasks.action.confirm': 'Confirm task',
    'tasks.action.orderDetail': 'Order detail',
    'tasks.action.receivingDetail': 'Receiving detail',
    'tasks.action.claimDetail': 'Claim detail',
    'tasks.table.id': 'ID',
    'tasks.table.section': 'Section',
    'tasks.table.text': 'Task text',
    'tasks.table.createdAt': 'Created at',
    'tasks.table.waitingDays': 'Waiting days',
    'tasks.table.status': 'Status',
    'tasks.table.state': 'State',
    'tasks.sections.ORDER': 'Order',
    'tasks.sections.RECEIVING': 'Receiving',
    'tasks.sections.CLAIM': 'Claim',
    'tasks.sections.PRODUCT': 'Product',
    'tasks.text.PRODUCT.ROP': 'The stock quantity of products has fallen below the set limit of the reorder point',
    'tasks.text.CLAIM.UPDATE_STATUS.ACCEPTED': 'Claim {{ID}} accepted',
    'tasks.text.CLAIM.UPDATE_STATUS.INPROCESS': 'Claim {{ID}} in process',
    'tasks.text.CLAIM.UPDATE_STATUS.REJECTED': 'Claim {{ID}} rejected',
    'tasks.text.CLAIM.UPDATE_STATUS.MOREINFONEEDED': 'More info needed for claim {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.INCORRECT': 'Incorrect order data {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.PRODUCTSNOTAVAILABLE': 'Unavailable products in order {{ID}}',
    'tasks.text.CLAIM.UPDATE_STATUS.ACCEPTEDWAITINGFORCOMPENSATIONFROMSHIPPER': 'Claim {{ID}} accepted - awaiting compensation',
    'tasks.text.CLAIM.UPDATE_STATUS.ACCEPTEDPENDINGCLIENTCOMPENSATION': 'Claim {{ID}} accepted - pending compensation to client',
    'tasks.text.CLAIM.UPDATE_STATUS.STORNO': 'Claim {{ID}} canceled',
    'tasks.text.ORDER.UPDATE_STATUS.WAITINGFORPAYMENT': 'Order {{ID}} waiting for payment',
    'tasks.text.ORDER.UPDATE_STATUS.CANCELED': 'Order {{ID}} canceled',
    'tasks.text.ORDER.UPDATE_STATUS.SUSPENDED': 'Order {{ID}} suspended',
    'tasks.text.ORDER.UPDATE_STATUS.WAITINGFORSHIPMENT': 'Ordering transport for order {{ID}}',
    'tasks.text.ORDER.UPDATE_STATUS.RECEIVED': 'Order {{ID}} received',
    'tasks.text.ORDER.UPDATE_STATUS.INPROCESS': 'Order {{ID}} in process',
    'tasks.text.ORDER.UPDATE_STATUS.PACKED': 'Order {{ID}} packed',
    'tasks.text.ORDER.UPDATE_STATUS.WAITINGFORCARRIER': 'Order {{ID}} waiting for carrier',
    'tasks.text.ORDER.UPDATE_STATUS.ONTHEWAY': 'Order {{ID}} on the way',
    'tasks.text.ORDER.UPDATE_STATUS.ATPICKUPPOINT': 'Order {{ID}} at pickup point',
    'tasks.text.ORDER.UPDATE_STATUS.LOST': 'Order {{ID}} lost',
    'tasks.text.ORDER.UPDATE_STATUS.RETURNINGBACK': 'Order {{ID}} returning',
    'tasks.text.ORDER.UPDATE_STATUS.RETURNEDBACK': 'Order {{ID}} returned',
    'tasks.text.ORDER.UPDATE_STATUS.PREORDER': 'Order {{ID}} pre-order',

    'tasks.text.ORDER.UPDATE_STATUS.DELIVERED': 'Order {{ID}} delivered',
    'tasks.text.ORDER.UPDATE_STATUS.PRERECEIVED': 'Order {{ID}} waiting for processing',
    'tasks.text.RECEIVING.UPDATE_STATUS.UNLOADED': 'Receiving {{ID}} unloaded',
    'tasks.text.RECEIVING.UPDATE_STATUS.RECEIVED': 'Receiving {{ID}} in process',
    'tasks.text.RECEIVING.UPDATE_STATUS.CONFIRMED': 'Receiving {{ID}} confirmed',
    'tasks.text.RECEIVING.UPDATE_STATUS.CANCELED': 'Receiving {{ID}} canceled',
    'tasks.text.RETURN.UPDATE_STATUS.RECEIVED': 'Return {{ID}} in process',
    'tasks.text.RETURN.UPDATE_STATUS.CONFIRMED': 'Return {{ID}} confirmed',
    'tasks.text.RETURN.UPDATE_STATUS.CANCELED': 'Return {{ID}} canceled',
    'tasks.text.RECEIVING.NOTDELIVEREDATTIME':
        'Receipt of goods {{ID}} did not arrive at the estimated time of delivery',
    'tasks.text.RECEIVING.DIFFERENCE_PRODUCTS': 'Receipt {{ID}} contains different quantities of products',
    'tasks.text.PRODUCT.EXPIRATION_DAYS': 'Products with an approaching expiration date',
    'documents.title': 'Documents',
    'documents.dowload': 'Download',
    'documents.show': 'Show',
    'documents.instruction.title': 'MySkladon manual',
    'documents.instruction.text': 'User manual for the MySkladon application',
    'documents.instruction.file': 'user_manual_EN.pdf',
    'documents.customerCareComunication.title': 'Freshdesk manual',
    'documents.customerCareComunication.text': 'Customer care service - Help Desk',
    'documents.customerCareComunication.file': 'customer_care_EN.pdf',
    'documents.customerCareClaims.title': 'Complatints procedure',
    'documents.customerCareClaims.text': 'Complaints Department and procedures for resolving complaints',
    'documents.customerCareClaims.file': 'claims_manual_EN.pdf',
    'documents.feedback.title': 'Feedback / Report a problem',
    'documents.feedback.text': 'Form for sending feedback / problem report',
    'documents.feedback.file': 'zpetna_vazba.pdf',
    'documents.incorrectOrders.title': 'How to fix orders with an error',
    'documents.incorrectOrders.text': 'The most common order error messages and their solutions',
    'documents.incorrectOrders.file': 'incorrect_orders_EN.pdf',
    'documents.downloading': 'Exporting data...',

    'commands.productCompletionSheets': 'Completion sheets of products',

    'productCompletionSheets.title': 'Completion sheets of products',
    'productCompletionSheets.action.createNew': 'New',
    'productCompletionSheets.action.productCompletionSheetDetail': 'Completion sheet of products detail',
    'productCompletionSheets.action.synchronizeTable': 'Synchronize table',
    'productCompletionSheets.table.id': 'ID',
    'productCompletionSheets.table.status': 'Status',
    'productCompletionSheets.table.createdAt': 'Created at',
    'productCompletionSheets.table.completedUntil': 'Completed until',

    'productCompletionSheetDetail.title': 'Edit completion sheets of product #{{idProductCompletionSheet}}',
    'productCompletionSheetDetail.titleNew': 'Create new completion sheets of product',
    'productCompletionSheetDetail.create': 'Create completion sheets of product',
    'productCompletionSheetDetail.save': 'Save completion sheets of product',
    'productCompletionSheetDetail.createConfirm': 'Do you really want to create a completion sheets of product?',
    'productCompletionSheetDetail.saveConfirm': 'Do you realy want to save a completion sheets of product?',
    'productCompletionSheetDetail.status': 'Status',
    'productCompletionSheetDetail.completedUntil': 'Completed until',
    'productCompletionSheetDetail.confirmGetNewDataStorage': 'Continue with the draft completion sheets of product',
    'productCompletionSheetDetail.confirmGetNewDataStorageText':
        'You have a draft completion sheets of product saved - do you want to continue with it?',
    'productCompletionSheetDetail.action.create': 'Create',
    'productCompletionSheetDetail.action.save': 'Save',

    'productCompletionSheetDetail.finalProductsTable.finalProduct': 'Final product',
    'productCompletionSheetDetail.finalProductsTable.billOfMaterials': 'Bill of materials',
    'productCompletionSheetDetail.finalProductsTable.count': 'Count',
    'productCompletionSheetDetail.finalProductsTable.lot': 'Lot',
    'productCompletionSheetDetail.finalProductsTable.status': 'Status',
    'productCompletionSheetDetail.finalProductsTable.completedAt': 'Completed at',
    'productCompletionSheetDetail.finalProductsTable.action.removeProduct': 'Remove product',
    'productCompletionSheetDetail.finalProductsTable.action.addProduct': 'Add product',
    'productCompletionSheetDetail.action.addBillOfMaterials': 'Add final product',
    'productCompletionSheetDetail.finalProductsTable.action.add': 'Add',
    'productCompletionSheets.message.productCompletionSheetCreated': 'Completion sheets of product created',
    'productCompletionSheets.message.productCompletionSheetUpdate': 'Completion sheets of product updated',

    'settings.skladonMapping': 'Skladon mapping',
    'settings.widgets': 'Widgets',
    'settings.providerCompanies': 'Contacts',
    'settings.providerTransferCompanies': 'Provider transfer companies',
    'settings.webhooks': 'Webhooks',
    'settings.webhookRecords': 'Records',
    'settings.webhookHistory': 'History',

    'webhooks.title': 'Webhooks',
    'webhooks.action.createNew': 'New',
    'webhooks.action.synchronizeTable': 'Synchronize table',
    'webhooks.action.webhookDetail': 'Edit webhook',
    'webhooks.message.webhookActivated': 'Webhook has been activated',
    'webhooks.message.webhookDeactivated': 'Webhook has been deactivated',
    'webhooks.table.id': 'ID',
    'webhooks.table.webhookType': 'Webhook type',
    'webhooks.table.method': 'Method',
    'webhooks.table.payloadVersion': 'Payload version',
    'webhooks.payloadVersion.v2': 'v2',
    'webhooks.payloadVersion.v21': 'v21',
    'webhooks.table.registeredAt': 'Registered at',
    'webhooks.table.active': 'Active',
    'webhooks.table.url': 'URL',
    'webhooks.table.unregisteredAt': 'Unregistered at',
    'webhooks.table.deactivationEmailSentAt': 'Deactivation e-mail sent at',
    'webhooks.webhookType.CREATE_ORDER': 'Create order',
    'webhooks.webhookType.UPDATE_ORDER': 'Update order',
    'webhooks.webhookType.UPDATE_ORDER_STATUS': 'Update order status',
    'webhooks.webhookType.CREATE_PRODUCT': 'Create product',
    'webhooks.webhookType.UPDATE_PRODUCT': 'Update product',
    'webhooks.webhookType.CREATE_RECEIVING': 'Create receiving',
    'webhooks.webhookType.UPDATE_RECEIVING': 'Update receiving',
    'webhooks.webhookType.UPDATE_RECEIVING_STATUS': 'Update receiving status',
    'webhooks.webhookType.CREATE_RETURN': 'Create return',
    'webhooks.webhookType.UPDATE_RETURN': 'Update return',
    'webhooks.webhookType.UPDATE_RETURN_STATUS': 'Update return status',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_STOCK_CORRECTION': 'Stock correction',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_ORDER': 'Stock movement – order',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_RETURN': 'Stock movement – return',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_RECEIVING': 'Stock movement – receiving',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_COMPLETITION': 'Stock movement – completion',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_QUALITY_HOLD': 'Stock movement – quality hold',
    'webhooks.webhookType.CREATE_STOCK_MOVEMENT_QUALITY_RELEASE': 'Stock movement – quality release',

    'webhookDetail.titleNew': 'Create new webhook',
    'webhookDetail.title': 'Edit webhook #{{idWebhook}}',
    'webhookDetail.detail': 'Detail',
    'webhookDetail.history': 'History',
    'webhookDetail.history.Webhook created': 'Webhook created',
    'webhookDetail.history.Webhook updated': 'Webhook updated',
    'webhookDetail.history.Webhook activated': 'Webhook activated',
    'webhookDetail.history.Webhook deactivated': 'Webhook deactivated',
    'webhookDetail.history.Webhook secret regenerated': 'Webhook secret regenerated',
    'webhookDetail.history.Webhook deleted': 'Webhook deleted',
    'webhookDetail.create': 'Create',
    'webhookDetail.save': 'Save',
    'webhookDetail.createConfirm': 'Do you really want to create a new webhook?',
    'webhookDetail.saveConfirm': 'Do you really want to save webhook changes?',
    'webhookDetail.deleteWebhook': 'Delete webhook',
    'webhookDetail.deleteWebhookConfirm': 'Do you really want to delete this webhook?',
    'webhookDetail.webhookType': 'Webhook type',
    'webhookDetail.method': 'Method',
    'webhookDetail.payloadVersion': 'Payload version',
    'webhookDetail.active': 'Active',
    'webhookDetail.url': 'URL',
    'webhookDetail.parameters': 'Parameters',
    'webhookDetail.withPackingLists': 'Send packing lists',
    'webhookDetail.registeredAt': 'Registered at',
    'webhookDetail.unregisteredAt': 'Unregistered at',
    'webhookDetail.deactivationEmailSentAt': 'Deactivation e-mail sent at',
    'webhookDetail.secretRegenerated': 'Secret regenerated',
    'webhookDetail.message.webhookCreated': 'Webhook has been created',
    'webhookDetail.message.webhookUpdate': 'Webhook has been saved',
    'webhookDetail.message.webhookDeleted': 'Webhook has been deleted',

    'webhookRecords.title': 'Webhook records',
    'webhookRecords.mode.grouped': 'By event',
    'webhookRecords.mode.attempts': 'Individual attempts',
    'webhookRecords.action.synchronizeTable': 'Synchronize table',
    'webhookRecords.action.recordDetail': 'Record detail',
    'webhookRecords.action.retry': 'Retry',
    'webhookRecords.action.retryConfirm':
        'Do you really want to resend this webhook? The original payload will be used, but the current webhook URL and settings will apply.',
    'webhookRecords.action.toggleAttempts': 'Expand attempts',
    'webhookRecords.action.copyOnDoubleClick': 'Double-click to copy',
    'webhookRecords.message.retryQueued': 'Retry has been queued',
    'webhookRecords.nextRetryAt': 'Next attempt: {{time}}',
    'webhookRecords.table.sendingTime': 'Sending time',
    'webhookRecords.table.eventId': 'Event ID',
    'webhookRecords.table.eventIdTooltip': 'Value of the X-Skladon-Webhook-Id header for idempotency',
    'webhookRecords.table.webhookType': 'Webhook type',
    'webhookRecords.table.method': 'Method',
    'webhookRecords.table.url': 'URL',
    'webhookRecords.table.attemptCount': 'Attempt count',
    'webhookRecords.table.attempt': 'Attempt',
    'webhookRecords.table.statusCode': 'Code',
    'webhookRecords.table.retryRelation': 'Manual retry',
    'webhookRecords.table.retryOf': 'Retry of',
    'webhookRecords.table.retryCreated': 'Retry',
    'webhookRecords.table.retryRequested': 'Retry requested',
    'webhookRecords.table.responseMessage': 'Response',
    'webhookRecords.table.payload': 'Payload',
    'webhookRecords.table.webhookId': 'Webhook ID',
    'webhookRecords.retryBlocked.success': 'Successful delivery cannot be retried',
    'webhookRecords.retryBlocked.manualRetryRequested': 'Manual retry was already requested for this event',
    'webhookRecords.retryBlocked.autoRetryInProgress': 'Automatic retry is still in progress',

    'webhookRecordDetail.title': 'Delivery record {{eventId}}',
    'webhookRecordDetail.attempts': 'Attempt history',
    'webhookRecordDetail.attemptsHint': 'Click a row to view the full response for that attempt.',
    'webhookRecordDetail.attemptResponse': 'Response for attempt {{attempt}}',
    'webhookRecordDetail.payloadHint': 'The same payload is sent with every attempt.',
    'webhookRecordDetail.payload.show': 'Show payload',
    'webhookRecordDetail.payload.hide': 'Hide payload',
    'webhookRecordDetail.payload.format': 'Format JSON',
    'webhookRecordDetail.payload.showRaw': 'Show raw',
    'webhookRecordDetail.payload.formattedHint': 'JSON is automatically formatted and syntax highlighted.',
    'webhookRecordDetail.payload.notJson': 'Payload is not valid JSON, showing raw text.',
    'webhookRecordDetail.lastAttemptAt': 'Last attempt',
    'webhookRecordDetail.nextRetryAt': 'Next scheduled attempt',
    'webhookRecordDetail.retryOfEventId': 'Retry of original event',
    'webhookRecordDetail.manualRetryEventId': 'Created manual retry',
    'webhookRecordDetail.retryUnavailable': 'Manual retry is not available',
    'webhookRecordDetail.action.reload': 'Reload detail',
    'webhookRecordDetail.action.copy': 'Copy to clipboard',

    'webhookHistory.title': 'Webhook history',
    'webhookHistory.action.synchronize': 'Synchronize history',
    'webhookHistory.webhookId': 'Webhook ID',
    'webhookHistory.webhookDetailLink': 'Webhook detail #{{id}}',

    'messages.copiedToClipboard': 'Copied to clipboard',
    'messages.copyFailed': 'Copy failed',

    'skladonMapping.title': 'Skladon mappings',
    'skladonMapping.action.synchronizeTable': 'Synchronize table',
    'skladonMapping.action.createNew': 'New',
    'skladonMapping.action.exportFile': 'Export skladon mappings',
    'skladonMapping.action.exportFileName': 'Export skladon mappings',
    'skladonMapping.action.skladonMappingDetail': 'Skladon mapping detail',

    'skladonMapping.message.skladonMappingCreated': 'Skladon mapping has been created',
    'skladonMapping.message.skladonMappingUpdate': 'Skladon mapping has been updated',
    'skladonMapping.message.skladonMappingDeleted': 'Skladon mapping has been deleted',

    'skladonMapping.table.id': 'ID',
    'skladonMapping.table.system': 'System',
    'skladonMapping.table.key': 'Key',
    'skladonMapping.table.value': 'Value',
    'skladonMapping.table.name': 'Name',
    'skladonMapping.table.uid': 'Uid',

    'skladonMappingDetail.titleNew': 'Create new skladon mapping',
    'skladonMappingDetail.title': 'Edit skladon mapping #{{idSkladonMapping}}',
    'skladonMappingDetail.create': 'Create',
    'skladonMappingDetail.save': 'Save skladon mapping',
    'skladonMappingDetail.createConfirm': 'Do you really want to create a skladon mapping?',
    'skladonMappingDetail.saveConfirm': 'Do you realy want to save a skladon mapping?',
    'skladonMappingDetail.key': 'KEY',
    'skladonMappingDetail.sys': 'System',
    'skladonMappingDetail.value': 'Value',
    'skladonMappingDetail.uid': 'UID',
    'skladonMappingDetail.name': 'Name',
    'skladonMappingDetail.deleteSkladonMapping': 'Delete skladon mapping',
    'skladonMappingDetail.deleteSkladonMappingConfirm': 'Are you sure to the delete this skladon mapping?',

    'providerCompanies.action.providerCompanyDetail': 'Contact detail',
    'providerCompanies.action.synchronizeTable': 'Synchronize table',
    'providerCompanies.action.createNew': 'New',
    'providerCompanies.action.exportFile': 'Export contacts',
    'providerCompanies.action.exportFileName': 'Export contacts',
    'providerCompanies.title': 'Contacts',
    'providerCompanies.table.id': 'ID',
    'providerCompanies.table.recipientName': 'Full name',
    'providerCompanies.table.contactPerson': 'Attention name',
    'providerCompanies.table.companyName': 'Company name',
    'providerCompanies.table.GLN': 'GLN',
    'providerCompanies.table.email': 'E-mail',
    'providerCompanies.table.phone': 'Phone',
    'providerCompanies.table.companyId': 'Company ID',
    'providerCompanies.table.street': 'Address (street, number)',
    'providerCompanies.table.city': 'City',
    'providerCompanies.table.zipCode': 'Zip code',
    'providerCompanies.table.state': 'Country',
    'providerCompanies.table.addressAdditionalInfo': 'Additional address info',
    'providerCompanies.table.provinceCode': 'Province code',
    'providerCompanies.table.actions': 'Actions',

    'providerTransferCompanies.action.createNew': 'New',
    'providerTransferCompanies.action.providerTransferCompanyDetail': 'Provider transfer company detail',
    'providerTransferCompanies.action.synchronizeTable': 'Synchronize table',
    'providerTransferCompanies.action.exportFile': 'Export provider transfer companies',
    'providerTransferCompanies.action.exportFileName': 'Provider transfer companies',
    'providerTransferCompanies.table.id': 'ID',
    'providerTransferCompanies.table.providerName': 'Name',
    'providerTransferCompanies.title': 'Provider transfer companies',

    'providerTransferCompanyDetail.titleNew': 'Create new provider transfer company',
    'providerTransferCompanyDetail.title': 'Edit provider transfer company #{{idProviderTransferCompany}}',
    'providerTransferCompanyDetail.create': 'Create',
    'providerTransferCompanyDetail.createConfirm': 'Do you really want to create a provider transfer company?',
    'providerTransferCompanyDetail.save': 'Save',
    'providerTransferCompanyDetail.saveConfirm': 'Do you realy want to save a provider transfer company?',
    'providerTransferCompanyDetail.targetProviderEshopKey': 'Provider transfer company',
    'providerTransferCompanyDetail.message.providerTransferCompanyCreated': 'Provider transfer company has been created',
    'providerTransferCompanyDetail.message.providerTransferCompanyUpdate': 'Provider transfer company has been updated',
    'providerTransferCompanyDetail.message.providerTransferCompanyDeleted': 'Provider transfer company has been deleted',
    'providerTransferCompanyDetail.deleteProviderTransferCompany': 'Delete provider transfer company',
    'providerTransferCompanyDetail.deleteProviderTransferCompanyConfirm': 'Are you sure to the delete this provider transfer company?',
    'providerCompanyDetail.deleteProviderCompany': 'Delete contact',
    'providerCompanyDetail.deleteProviderCompanyConfirm': 'Are you sure to the delete this contact?',
    'providerCompanyDetail.contact': 'Contact',
    'providerCompanyDetail.address': 'Address',
    'providerCompanyDetail.recipientName': 'Full name',
    'providerCompanyDetail.contactPerson': 'Attention name',
    'providerCompanyDetail.companyName': 'Company name',
    'providerCompanyDetail.GLN': 'GLN',
    'providerCompanyDetail.email': 'E-mail',
    'providerCompanyDetail.phone': 'Phone',
    'providerCompanyDetail.companyId': 'Company ID',
    'providerCompanyDetail.street': 'Address (street, number)',
    'providerCompanyDetail.city': 'City',
    'providerCompanyDetail.zipCode': 'Zip code',
    'providerCompanyDetail.state': 'Country',
    'providerCompanyDetail.addressAdditionalInfo': 'Additional address info',
    'providerCompanyDetail.provinceCode': 'Province code',
    'providerCompanyDetail.VAT': 'VAT',
    'providerCompanyDetail.idNumber': 'ID number',
    'providerCompanyDetail.create': 'Create',
    'providerCompanyDetail.createConfirm': 'Do you really want to create a contact?',
    'providerCompanyDetail.save': 'Save',
    'providerCompanyDetail.saveConfirm': 'Do you realy want to save a contact?',
    'providerCompanyDetail.title': 'Edit contact #{{idProviderCompany}}',
    'providerCompanyDetail.titleNew': 'Create new contact',
    'providerCompanyDetail.message.providerCompanyCreated': 'Contact has been created',
    'providerCompanyDetail.message.providerCompanyUpdate': 'Contact has been updated',
    'providerCompanyDetail.message.providerCompanyDeleted': 'Contact has been deleted',

    'reminders.title': 'Reminders',
    'reminders.create': 'Create',
    'reminders.message.reminderCreated': 'Reminder has been created',
    'reminders.message.reminderUpdate': 'Reminder has been updated',
    'reminders.message.reminderCanceled': 'Reminder has been deleted',
    'reminders.message.removedFromReminderAttendees': 'You has been removed from reminder attendees',

    'reminderDetail.title.order': 'Reminder for order',
    'reminderDetail.title.return': 'Reminder for return',
    'reminderDetail.title.claim': 'Reminder for claim',
    'reminderDetail.title.receiving': 'Reminder for receiving',
    'reminderDetail.action.create': 'Create',
    'reminderDetail.action.save': 'Save',
    'reminderDetail.action.cancel': 'Delete',
    'reminderDetail.action.removeFromReminderAttendees': 'Remove from attendees',
    'reminderDetail.action.close': 'Close',
    'reminderDetail.title': 'Title',
    'reminderDetail.text': 'Reminder text',
    'reminderDetail.executionAt': 'Reminder date',
    'reminderDetail.pushNotification': 'Push notification',
    'reminderDetail.emailNotification': 'E-mail notification',
    'reminderDetail.attendeesUsers': 'Remind users',

    'widget.title': 'Widgets',
    'widget.action.widgetDetail': 'Widget detail',
    'widget.returnWidget': 'Return widget',
    'widget.table.id': 'ID',
    'widget.table.name': 'Name',

    'returnWidgetDetail.title': 'Return widget',
    'returnWidgetDetail.textScript': 'Add script for the widget to your page:',
    'returnWidgetDetail.textElement':
        'Add element with parameters id="skladon-returns-widget" and public-id contained your public ID:',
    'returnWidgetDetail.text': 'Place the element where you want the form to appear',

    'applicationStatusMessages.title': 'Application messages',
    'applicationStatusMessages.action.createNew': 'New',
    'applicationStatusMessages.action.synchronizeTable': 'Synchronize table',
    'applicationStatusMessages.action.exportFile': 'Export application messages',
    'applicationStatusMessages.action.exportFileName': 'Export application messages',
    'applicationStatusMessages.action.applicationStatusMessageDetail': 'Application message detail',
    'applicationStatusMessages.action.activate': 'Activate',
    'applicationStatusMessages.action.deactivate': 'Deactivate',
    'applicationStatusMessages.table.id': 'ID',
    'applicationStatusMessages.table.title': 'Title',
    'applicationStatusMessages.table.createdAt': 'Created at',
    'applicationStatusMessages.table.type': 'Information type',
    'applicationStatusMessages.table.notificationType': 'Notification type',
    'applicationStatusMessages.table.active': 'Active',
    'applicationStatusMessages.table.lang': 'Language',
    'applicationStatusMessages.message.applicationStatusMessageCreated': 'Application message has been created',
    'applicationStatusMessages.message.applicationStatusMessageUpdate': 'Application message has been updated',

    'applicationStatusMessageDetail.title': 'Edit application message: {{idApplicationStatusMessage}}',
    'applicationStatusMessageDetail.titleNew': 'Create new application message',
    'applicationStatusMessageDetail.create': 'Create application message',
    'applicationStatusMessageDetail.createConfirm': 'Do you realy want to create application message?',
    'applicationStatusMessageDetail.save': 'Save',
    'applicationStatusMessageDetail.saveConfirm': 'Do you realy want to save application message?',
    'applicationStatusMessageDetail.activate': 'Activate application message',
    'applicationStatusMessageDetail.activateConfirm': 'Do you realy want to activate application message?',
    'applicationStatusMessageDetail.deactivate': 'Deactivate application message',
    'applicationStatusMessageDetail.deactivateConfirm': 'Do you realy want to deactivate application message?',
    'applicationStatusMessageDetail.titleEdit': 'Title',
    'applicationStatusMessageDetail.text': 'Text',
    'applicationStatusMessageDetail.type': 'Information type',
    'applicationStatusMessageDetail.notificationType': 'Notification type',
    'applicationStatusMessageDetail.lang': 'Language',

    'appbar.search': 'Search',
    'appBar.notifications': 'Notifications',
    'appBar.allNotifications': 'All notifications',
    'appBar.deleteAllNotifications': 'Delete all',
    'appBar.deleteAllNotificationsTitle': 'Delete all notifications',
    'appBar.deleteAllNotificationsText': 'Are you sure you want to delete all notifications?',
    'appBar.deleteNotification': 'Delete the notification',
    'appBar.notificationsDays': 'Before {{days}} days',
    'appBar.notificationsHours': 'Before {{hours}} hours',
    'appBar.userSettings': 'User profil',
    'appBar.currentAccount': 'Current e-shop',
    'appBar.switchToAccount': 'Switch to e-shop',
    'appBar.logout': 'Log out',
    'appBar.language': 'Language',
    'appBar.infoMessages': 'Application message: Information',
    'appBar.warningMessages': 'Application message: Warning',
    'appBar.errorMessages': 'Application message: Error',
    'topBlock.actionItems': 'More actions',

    'table.rowsPerPage': 'Rows per page',
    'table.downloadFormat': 'Select format',
    'table.showColumns': 'Show columns',
    'table.defaultShowColumns': 'Reset to default',
    'table.editOrderColumns': 'Adjust columns order',
    'table.clearFilters': 'Delete filters',
    'table.noResults': 'No results found',
    'table.total': 'Total',

    'paymentEdit.paymentMethod': 'Payment method',
    'paymentEdit.paidOrderOptions': 'Payment options',
    'paymentEdit.paidAction.transferPaymentPaid': 'Bank transfer - paid',
    'paymentEdit.paidAction.transferPaymentNotPaid': 'Bank transfer - not paid',
    'paymentEdit.paidAction.cashOnDelivery': 'Cash on delivery',
    'paymentEdit.paidAction.cashOnDeliveryPaid': 'Cash on delivery - paid (claims/exchange)',
    'paymentEdit.paidAction.cashOnDeliveryNotPaid': 'Cash on delivery - not paid',
    'paymentEdit.paidAction.onlinePaymentPaid': 'Card online - paid',
    'paymentEdit.paidAction.onlinePaymentNotPaid': 'Card online - not paid',
    'paymentEdit.paidAction.transferPaymentSend': 'Transfer payment is ready to be sent',
    'paymentEdit.paidAction.noPaymentPaid': 'Paid - without payment method',
    'paymentEdit.paidAction.noPaymentNotPaid': 'Not paid - without payment method ',
    'utils.ordersType.B2COrders': 'B2C orders',
    'utils.ordersType.B2BOrders': 'B2B orders',
    'utils.orderStatusCodes.received': 'Received',
    'utils.orderStatusCodes.onTheWay': 'On the way',
    'utils.orderStatusCodes.atPickupPoint': 'At pickup point',
    'utils.orderStatusCodes.inProcess': 'In process',
    'utils.orderStatusCodes.delivered': 'Delivered',
    'utils.orderStatusCodes.canceled': 'Canceled',
    'utils.orderStatusCodes.refunded': 'Refunded',
    'utils.orderStatusCodes.lost': 'Lost',
    'utils.orderStatusCodes.returningBack': 'Returning back',
    'utils.orderStatusCodes.receivedBack': 'Received back',
    'utils.orderStatusCodes.returnedBack': 'Returned back',
    'utils.orderStatusCodes.suspended': 'Suspended',
    'utils.orderStatusCodes.incorrect': 'Incorrect',
    'utils.orderStatusCodes.processing': 'Pending processing',
    'utils.orderStatusCodes.processed': 'Processed',
    'utils.orderStatusCodes.onResend': 'Resend',
    'utils.orderStatusCodes.refundInProcess': 'Refund in process',
    'utils.orderStatusCodes.partlyReceivedBack': 'Partly received back',
    'utils.orderStatusCodes.preReceived': 'Pre received ',
    'utils.orderStatusCodes.waitingForPayment': 'Waiting for payment',
    'utils.orderStatusCodes.productsNotAvailable': 'Product not available',
    'utils.orderStatusCodes.packed': 'Packed',
    'utils.orderStatusCodes.waitingForCarrier': 'Waiting for carrier',
    'utils.orderStatusCodes.shoptetImport': 'Shoptet import',
    'utils.orderStatusCodes.forShipment': 'For shipment',
    'utils.orderStatusCodes.waitingForShipment': 'Waiting for shipment',
    'utils.orderStatusCodes.preOrder': 'Pre-order',

    'utils.paymentCodes.cashOnDelivery': 'Cash on delivery',
    'utils.paymentCodes.visaMasterCard': 'Card online',
    'utils.paymentCodes.paymentOnABill': 'Bank transfer',
    'utils.orderMarketplacesCodes.alza': 'Alza',
    'utils.orderMarketplacesCodes.allegro': 'Allegro',
    'utils.orderMarketplacesCodes.kaufland': 'Kaufland',
    'utils.orderMarketplacesCodes.mall': 'Mall',
    'utils.orderMarketplacesCodes.other': 'Other',
    'utils.returnStatusCodes.awaiting': 'Awaiting',
    'utils.returnStatusCodes.received': 'In process',
    'utils.returnStatusCodes.confirmed': 'Confirmed',
    'utils.returnStatusCodes.canceled': 'Canceled',

    'utils.paidMappingCodes.noMapping': 'No mapping',
    'utils.paidMappingCodes.yes': 'Yes',
    'utils.paidMappingCodes.no': 'No',

    'utils.returnResolutionCodes.returnToInventory': 'Return to inventory',
    'utils.returnResolutionCodes.receiveAsDamaged': 'Quality hold – Returned as damaged',
    'utils.returnResolutionCodes.onResend': 'Resend',
    'utils.returnResolutionCodes.unknown': 'Unknown',
    'utils.returnResolutionCodes.scrap': 'Scrap',
    'utils.returnResolutionCodes.cleanedReturnedToInventory': 'Restored to Original',
    'utils.returnResolutionCodes.cleanedHoldOnQuality': 'Cleaned, hold on quality',
    'utils.claimsResolverCodes.skladon': 'Skladon logistic',
    'utils.claimsResolverCodes.skladonIT': 'Skladon IT',
    'utils.claimsResolverCodes.carrier': 'Carrier',
    'utils.returnResolutionCodes.restoredToOriginal': '(legacy) Restored to Original – use Return to inventory',
    'utils.returnResolutionCodes.failedRestoredToOriginal': '(legacy) Failed to restore – use Signs of use',
    'utils.returnResolutionCodes.differentLook': 'Quality hold – Looks different / wrong size',
    'utils.returnResolutionCodes.disposal': 'Quality hold – Disposal',
    'utils.returnResolutionCodes.dryCleaning': 'Quality hold – Dry cleaning',
    'utils.returnResolutionCodes.signsOfUse': 'Quality hold – Signs of use',

    'utils.receivingDeliveryTypeCodes.courier': 'Courier transport',
    'utils.receivingDeliveryTypeCodes.transportCompany': 'Loose cartons',
    'utils.receivingDeliveryTypeCodes.truckingCompany': 'Paletised cartons',
    'utils.receivingDeliveryTypeCodes.container': 'Container transport',
    'utils.receivingUrgentCodes.OK': 'OK',
    'utils.receivingUrgentCodes.ok': 'OK',
    'utils.receivingUrgentCodes.Po Urgenci': 'After urging',
    'utils.receivingUrgentCodes.Vytvořeno Skladonem': 'Created by Skladon',
    'utils.receivingUrgentCodes.Nefakturovat': 'Not invoiced',
    'utils.receivingUrgentCodes.afterUrgent': 'After urging',
    'utils.receivingUrgentCodes.createdBySkladon': 'Created by Skladon',
    'utils.receivingUrgentCodes.notInvoiced': 'Not invoiced',
    'utils.receivingUrgentCodes.recievedWithoutAsn': 'Received without ASN',

    'utils.receivingTypeCodes.piece_mix': 'Piece (mix SKU) - conversion of goods by pieces',
    'utils.receivingTypeCodes.carton_single': 'Carton (single SKU) - receiving goods by whole cartons',
    'utils.receivingTypeCodes.carton_mix': 'Carton (mix SKU) - receiving goods by whole cartons',
    'utils.receivingTypeCodes.pallet_single': 'Pallet (single SKU) - receiving goods by whole pallets',
    'utils.receivingTypeCodes.pallet_mix': 'Pallet (mix SKU) - receiving goods by whole pallets',
    'utils.receivingPackingTypeCodes.non_returnable_pallet': 'Non retunable pallet',
    'utils.receivingPackingTypeCodes.returnable_pallet_wood': 'Returnable pallet - wood',
    'utils.receivingPackingTypeCodes.returnable_pallet_not_wood': 'Returnable pallet - other material',
    'utils.receivingPalletCodes.pallet_100x120_ippc': 'Pallet 100x120 - IPPC',
    'utils.receivingPalletCodes.pallet_100x120_standard': 'Pallet 100x120 - standard',
    'utils.receivingPalletCodes.pallet_80x120_eur_a': 'Pallet 80x120 - EUR - class A - IPPC',
    'utils.receivingPalletCodes.pallet_80x120_eur_b': 'Pallet 80x120 - EUR - Class B',
    'utils.receivingPalletCodes.pallet_80x120_standard': 'Pallet 80x120 - standard',
    'utils.receivingPalletCodes.pallet_60x80_ippc': 'Pallet 60x80 - IPPC',
    'utils.receivingPalletCodes.pallet_60x80_standard': 'Pallet 60x80 standard',
    'utils.receivingPalletCodes.unspecified': 'Unspecified',

    'utils.receivingStatusCode.awaiting': 'Awaiting',
    'utils.receivingStatusCode.unloaded': 'Unloaded',
    'utils.receivingStatusCode.received': 'In process',
    'utils.receivingStatusCode.confirmed': 'Confirmed',
    'utils.receivingStatusCode.canceled': 'Canceled',

    'utils.claimStatusCodes.received': 'Created',
    'utils.claimStatusCodes.informationAdded': 'Information added',
    'utils.claimStatusCodes.inProcess': 'In process',
    'utils.claimStatusCodes.inProcessAt': 'In process at',
    'utils.claimStatusCodes.rejected': 'Rejected',
    'utils.claimStatusCodes.rejectedAt': 'Rejected at',
    'utils.claimStatusCodes.storno': 'Canceled',
    'utils.claimStatusCodes.stornoAt': 'Canceled at',
    'utils.claimStatusCodes.notFound': 'Not found',
    'utils.claimStatusCodes.accepted': 'Accepted - closed',
    'utils.claimStatusCodes.partiallyAccepted': 'Partially accepted',
    'utils.claimStatusCodes.acceptedWaitingForCompensationFromShipper': 'Accepted - expect compensation',
    'utils.claimStatusCodes.acceptedWaitingForCompensationFromShipperAt': 'Accepted - expect compensation at',
    'utils.claimStatusCodes.moreInfoNeeded': 'More info needed',
    'utils.claimStatusCodes.moreInfoNeededAt': 'More info needed at',
    'utils.claimStatusCodes.acceptedPendingClientCompensation': 'Accepted - pending compensation to client',
    'utils.claimStatusCodes.acceptedPendingClientCompensationAt': 'Accepted - pending compensation to client at',

    'utils.claimReasonCodes.lost': 'Lost',
    'utils.claimReasonCodes.damaged': 'Damaged',
    'utils.claimReasonCodes.deliveryTimeExceeded': 'Shipment without movement',
    'utils.claimReasonCodes.trackingLabelsSwapped': 'Tracking labels swapped',
    'utils.claimReasonCodes.duplicatedLabels': 'Duplicated orders',
    'utils.claimReasonCodes.missingItems': 'Missing items',
    'utils.claimReasonCodes.exceedingItems': 'Exceeding items',
    'utils.claimReasonCodes.swappedItems': 'Swapped items',
    'utils.claimReasonCodes.others': 'Other',
    'utils.retunReasonCodes.exchange': 'Exchange',
    'utils.retunReasonCodes.changemind': 'Change mind',
    'utils.retunReasonCodes.undeliverable': 'Undeliverable',
    'utils.retunReasonCodes.damaged': 'Damaged',
    'utils.retunReasonCodes.unknown': 'Unknown',
    'utils.retunReasonCodes.nofit': 'Looks different/Size doesn\'t fit',
    'utils.retunReasonCodes.nolike': 'Don\'t like the item',
    'utils.retunReasonCodes.late': 'Late delivery',
    'utils.productTypeCodes.semiProduct': 'Semi product',
    'utils.productTypeCodes.finalProduct': 'Final product',
    'utils.productTypeCodes.packagingMaterial': 'Packaging material',
    'utils.productTypeCodes.promoMaterial': 'Promo material',
    'utils.productTypeCodes.pallet': 'Pallet',
    'utils.productTypeCodes.pack': 'Products set',
    'utils.productTypeCodes.virtual': 'Virtual product',
    'utils.productTypeCodes.serviceProduct': 'Service',
    'utils.productCompletionSheetStatusCodes.created': 'Created',
    'utils.productCompletionSheetStatusCodes.inProcess': 'In process',
    'utils.productCompletionSheetStatusCodes.completed': 'Completed',
    'utils.productCompletionSheetStatusCodes.canceled': 'Canceled',
    'utils.stockTakingStatusCodes.created': 'Created',
    'utils.stockTakingStatusCodes.inProcess': 'In process',
    'utils.stockTakingStatusCodes.completed': 'Completed',
    'utils.stockTakingStatusCodes.canceled': 'Canceled',
    'utils.stockTakingTypeCodes.complete': 'Complete',
    'utils.stockTakingTypeCodes.byProducts': 'Selected products',

    'utils.boolCodes.yes': 'Yes',
    'utils.boolCodes.no': 'No',

    'utils.scanImeiSnCodes.no': 'No',
    'utils.scanImeiSnCodes.snExpedition': 'SN – expedition only',
    'utils.scanImeiSnCodes.imeiExpedition': 'IMEI – expedition only',
    'utils.scanImeiSnCodes.snInbound': 'SN – inbound only',
    'utils.scanImeiSnCodes.imeiInbound': 'IMEI – inbound only',
    'utils.scanImeiSnCodes.snBoth': 'SN – expedition and inbound',
    'utils.scanImeiSnCodes.imeiBoth': 'IMEI – expedition and inbound',

    'utils.activeNumberCodes.yes': 'Yes',
    'utils.activeNumberCodes.no': 'No',
    'utils.configItemTypeCodes.string': 'Text',
    'utils.configItemTypeCodes.number': 'Number',
    'utils.configItemTypeCodes.boolean': 'Yes / No',
    'utils.configItemTypeCodes.multiline': 'Multiline text',
    'utils.activeNumberCodes.deleted': 'Deleted',

    'utils.documentTypesCodes.invoice': 'Invoice (A4 print)',
    'utils.documentTypesCodes.deliveryNote': 'Delivery note (not printing)',
    'utils.documentTypesCodes.certificate': 'Certificate (not printing)',
    'utils.documentTypesCodes.other': 'Other (not printing)',
    'utils.documentTypesCodes.customDeclaration': 'Custom declaration (not printing)',
    'utils.documentTypesCodes.shippingAddonLabel': 'Shipping label (A6 - Zebra printer)',
    'utils.activeCodes.nonActive': 'Non active',
    'utils.activeCodes.active': 'Active',
    'utils.expeditionMethodCodes.FIFO': 'FIFO',
    'utils.expeditionMethodCodes.FEFO': 'FEFO',
    'utils.handlingUnitsCodes.box_loose': 'Loose boxes',
    'utils.handlingUnitsCodes.box_on_pallete': 'Boxes on pallet',
    'utils.handlingUnitsCodes.product_loose': 'Loose product',
    'utils.handlingUnitsCodes.container': 'Container',

    'utils.driverCompanyCodes.PPL': 'PPL',
    'utils.driverCompanyCodes.DPD': 'DPD',
    'utils.driverCompanyCodes.GLS': 'GLS',
    'utils.driverCompanyCodes.zasilkovna': 'Packeta',
    'utils.driverCompanyCodes.CP': 'Czech Post',
    'utils.driverCompanyCodes.UPS': 'UPS',
    'utils.driverCompanyCodes.TNT': 'TNT',
    'utils.driverCompanyCodes.DHL': 'DHL',
    'utils.driverCompanyCodes.ALZA': 'ALZA',
    'utils.driverCompanyCodes.WEDO': 'WEDO',
    'utils.driverCompanyCodes.other': 'Other - not listed',

    'utils.receivingPriorityCodes.0': 'Normal',
    'utils.receivingPriorityCodes.1': 'High',
    'utils.receivingPriorityCodes.2': 'Urgent',

    'utils.lineState.e': 'Enabled',
    'utils.lineState.d': 'Disabled',
    'utils.applicationMessageCodes.info': 'Information',
    'utils.applicationMessageCodes.warning': 'Warning',
    'utils.applicationMessageCodes.error': 'Error',

    'utils.applicationMessageNotificationTypesCodes.banner': 'Banner',
    'utils.applicationMessageNotificationTypesCodes.popup': 'Pop up',
    'utils.applicationMessageNotificationTypesCodes.both': 'Banner & pop up',

    'utils.orderClaimReturnType.claim': 'Claim',
    'utils.orderClaimReturnType.return': 'Return',

    'utils.orderProductFileType.other': 'Other',
    'utils.orderProductFileType.engravingTemplate': 'Engraving template',

    'utils.orderProductCustomizationType.stamping': 'Stamping',
    'utils.orderProductCustomizationType.engraving': 'Engraving',
    'utils.orderProductCustomizationType.grinding': 'Grinding',

    'utils.productInsetTypeCodes.everyOrder': 'Every order',
    'utils.productInsetTypeCodes.specificProduct': 'Specific product',
    'utils.insertByOrderTypeCodes.all': 'B2B and B2C orders',
    'utils.insertByOrderTypeCodes.b2c': 'Only B2C orders',
    'utils.insertByOrderTypeCodes.b2b': 'Only B2B orders',
    'utils.orderPriorityCodes.normal': 'Normal',
    'utils.orderPriorityCodes.high': 'High',
    'utils.orderPriorityCodes.urgent': 'Urgent',
    'utils.transportStatusCodes.created': 'Created',
    'utils.transportStatusCodes.shippingCreated': 'Shipping created',
    'utils.transportStatusCodes.onTheWay': 'On the way',
    'utils.transportStatusCodes.atPickupPoint': 'At pickup point',
    'utils.transportStatusCodes.delivered': 'Delivered',
    'utils.transportStatusCodes.returningBack': 'Returning back',
    'utils.transportStatusCodes.returnedBack': 'Returned back',
    'utils.transportStatusCodes.canceled': 'Canceled',
    'utils.transportStatusCodes.incorrect': 'Incorrect',
    'utils.transportStatusCodes.lost': 'Lost',
    'utils.transportTypeCodes.expedition': 'Expedition',
    'utils.transportTypeCodes.return': 'Return',
    'utils.transportTypeCodes.order': 'Order',
    'utils.productRelationCodes.insertToOrder': 'Insert 1 pc to order',
    'utils.productRelationCodes.insertToOrderMultiple': 'Insert pcs according to pcs of product',
    'utils.orderProductCustomsTypeCodes.gift': 'Gift',
    'utils.orderProductCustomsTypeCodes.documents': 'Documents',
    'utils.orderProductCustomsTypeCodes.saleOfGoods': 'Sale of goods',
    'utils.orderProductCustomsTypeCodes.commercialSample': 'Commercial sample',
    'utils.orderProductCustomsTypeCodes.returnedGoods': 'Returned goods',
    'utils.orderProductCustomsTypeCodes.productSet': 'Products set',

    'utils.sourceSysCodes.myskladon': 'MySkladon',
    'utils.sourceSysCodes.wmsSkladon': 'WMS Skladon',
    'utils.sourceSysCodes.retino': 'Retino',

    'utils.transportPaidByCodes.skladon': 'Skladon',
    'utils.transportPaidByCodes.provider': 'Provider',
    'utils.transportPaidByCodes.customer': 'Customer',

    'utils.orderCancelReasonCodes.skladon': 'Skladon reason (not invoiced cancelation)',
    'utils.orderCancelReasonCodes.provider': 'Reason on the client\'s side (invoiced cancelation)',

    'utils.incotermsCodes.FOB': 'FOB - Free On Board',
    'utils.incotermsCodes.CPT': 'CPT - Carriage Paid to',
    'utils.incotermsCodes.CIP': 'CIP - Carriage and Insurance Paid to',
    'utils.incotermsCodes.DPU': 'DPU - Delivered At Place Unloaded',
    'utils.incotermsCodes.DAP': 'DAP - Deliver At Place',
    'utils.incotermsCodes.DDP': 'DDP - Delivery Duty Paid',

    'file.close': 'Close',
    'file.download': 'Download',
    'file.display': 'Display',
    'file.delete': 'Delete',
    'file.description': 'Description',
    'file.colFile': 'File',
    'file.colDescription': 'Description',
    'file.colType': 'File type',
    'file.colActions': 'Actions',
    'file.uploadedAt': 'Uploaded date',
    'file.creatorRole.skladon_employee': 'Skladon',
    'file.creatorRole.client': 'Client',
    'file.filterBy.creatorRole': 'Uploaded by',
    'file.filterBy.creatorRoleAll': 'Anyone',
    'file.type.instruction': 'Instruction',
    'file.type.label': 'Label',
    'file.type.other': 'Other',
    'productDetail.attachmentsTitle': 'Product attachments (instruction / label / other)',
    'textField.error': 'Invalid value',
    'textField.requiredError': 'Required value',
    'fileUpload.downloadFiles': 'Upload files',
    'fileUpload.dowloadImage': 'Upload photo',

    // Provider files
    'providerFiles.title': 'Provider Files',
    'providerFiles.upload': 'Upload File',
    'providerFiles.type': 'File Type',
    'providerFiles.fileName': 'File Name',
    'providerFiles.uploadedAt': 'Uploaded',
    'providerFiles.actions': 'Actions',
    'providerFiles.download': 'Download',
    'providerFiles.delete': 'Delete',
    'providerFiles.confirmDelete': 'Are you sure you want to delete this file?',
    'providerFiles.uploadSuccess': 'File uploaded successfully',
    'providerFiles.deleteSuccess': 'File deleted successfully',
    'providerFiles.uploadError': 'Error uploading file',
    'providerFiles.deleteError': 'Error deleting file',

    // Provider file types
    'utils.providerFileTypeCodes.providerContract': 'Provider Contract',
    'utils.providerFileTypeCodes.other': 'Other',

    // Provider history - file operations
    'providerDetail.history.FILES_ADDED': 'Files added',
    'providerDetail.history.FILES_DELETED': 'Files deleted',
    'providerDetail.history.FILES_UPDATED': 'Files updated',
    'providerDetail.history.FILES.new': 'File added',
    'providerDetail.history.FILES.edit': 'File updated',
    'providerDetail.history.FILES.delete': 'File deleted',
    'providerDetail.history.SERVICE_CODES.new': 'Carrier service added',
    'providerDetail.history.SERVICE_CODES.edit': 'Carrier service updated',
    'providerDetail.history.SERVICE_CODES.delete': 'Carrier service removed',
    'providerDetail.serviceCodeLabel': 'Service name',
    'providerDetail.files': 'Files',
    'providerDetail.fileName': 'File name',
    'providerDetail.fileType': 'File type',
    'providerDetail.fileExtension': 'Extension',

    'confirmProviderChange.title': 'Caution, there is a risk of data loss',
    'confirmProviderChange.text1': 'You work on several e-shops at the same time in one browser.',
    'confirmProviderChange.text2': 'Which e-shop do you want to continue?',

    'dialog.close': 'Close',
    'dialog.locationBack': 'Back',
    'dialog.reminders': 'Reminders',
    'dialog.addReminder': 'Add reminder',

    'actionItem.moreActions': 'More options',
    'confirmDialog.ok': 'Ok',
    'confirmDialog.cancel': 'Cancel',
    'messages.uploaded': 'Uploaded',
    'messages.passwordBeenChanged': 'Password has been changed',
    'messages.billOfMaterialsActive': 'Bill of materials activated',
    'messages.billOfMaterialsDeactive': 'Bill of materials deactivated',
    'messages.branchUnavailable': 'The delivery point does not accept shipments',
    'messages.formWarningTitle': 'Incorrect or incomplete form',
    'messages.formWarningText': 'Form has incorrect or incomplete values',
    'messages.formErrorTitle': 'Form error',
    'billOfMaterialsDetail.action.addBillOfMaterials': 'Add',
    'billOfMaterialsDetail.action.create': 'Create',
    'billOfMaterialsDetail.action.save': 'Save',
    'billOfMaterialsDetail.create': 'Create bill of materials',
    'billOfMaterialsDetail.createConfirm': 'Do you realy want to create a bill of materials?',
    'billOfMaterialsDetail.finalProduct': 'Final product',
    'billOfMaterialsDetail.name': 'Name',
    'billOfMaterialsDetail.confirmGetNewDataStorage': 'Continue with the draft bill of materials',
    'billOfMaterialsDetail.confirmGetNewDataStorageText':
        'You have a draft bill of materials saved - do you want to continue with it?',
    'billOfMaterialsDetail.productsTable.action.add': 'Add',
    'billOfMaterialsDetail.productsTable.action.addProduct': 'Add product',
    'billOfMaterialsDetail.productsTable.action.removeProduct': 'Remove product',
    'billOfMaterialsDetail.productsTable.count': 'Quantity',
    'billOfMaterialsDetail.productsTable.product': 'Product',
    'billOfMaterialsDetail.save': 'Save bill of materials',
    'billOfMaterialsDetail.saveConfirm': 'Do you realy want to save a bill of materials?',
    'billOfMaterialsDetail.title': 'Detail bill of materials {{idBillOfMaterials}}',
    'billOfMaterialsDetail.titleNew': 'Create new bill of materials',
    'billsOfMaterial.action.billOfMaterialsDetail': 'Detail of bill of materials',
    'billsOfMaterial.action.createNew': 'New',
    'billsOfMaterial.action.dowloadBillsOfMaterialsTable': 'Export bill of materials',
    'billsOfMaterial.action.exportFileName': 'Export bill of materials',
    'billsOfMaterial.action.synchronizeTable': 'Synchronize table',
    'billsOfMaterial.table.active': 'Active',
    'billsOfMaterial.table.createdAt': 'Created',
    'billsOfMaterial.table.finalProductSku': 'Final product SKU',
    'billsOfMaterial.table.id': 'ID',
    'billsOfMaterial.table.name': 'Name',
    'billsOfMaterial.title': 'Bill of materials',
    'billsOfMaterial.titlePrduct': 'Bill of materials for product {{idProduct}}',
    'billsOfMaterials.message.billOfMaterialsCreated': 'Bill of materials was created',
    'billsOfMaterials.message.billOfMaterialsUpdated': 'Bill of materialswas saved',
    'messages.BillOfMaterialsActive': 'Bill of materials activated',
    'messages.BillOfMaterialsDeactive': 'Bill of materials deactivated',
    'orders.table.incorrectMessage': 'Error message',
    'products.action.allProviders': 'All providers',
    'products.action.allStock': 'Lot / Exp. Date',
    'products.table.providerName': 'E-shop',
    'tasks.action.productsList': 'Product list',
    'tasks.table.check': ' ',

    'emailTemplates.title': 'E-mail templates',
    'emailTemplates.emailTemplateDetail': 'E-mail template detail',
    'emailTemplates.createNewEmailTemplate': 'Create new e-mail template',
    'emailTemplates.synchronizeTable': 'Synchronize table',
    'emailTemplates.table.id': 'ID',
    'emailTemplates.table.name': 'Name',
    'emailTemplates.table.type': 'Type',
    'emailTemplates.table.lang': 'Language',
    'emailTemplates.table.actions': 'Actions',

    'emailTemplateDetail.title': 'Detail template #{{idEmailTemplate}}',
    'emailTemplateDetail.titleNew': 'Create new template',
    'emailTemplateDetail.sendTestEmail': 'Send test e-mail',
    'emailTemplateDetail.email': 'E-mail',
    'emailTemplateDetail.template': 'Template',
    'emailTemplateDetail.version': 'Version',
    'emailTemplateDetail.templateEditor': 'Template ediotr',
    'emailTemplateDetail.selectedVersion': 'Selected version',
    'emailTemplateDetail.name': 'Name',
    'emailTemplateDetail.lang': 'Language',
    'emailTemplateDetail.type': 'Type',
    'emailTemplateDetail.testExample': 'Test example structure',
    'emailTemplateDetail.subject': 'Subject',
    'emailTemplateDetail.test_data': 'Test data',
    'emailTemplateDetail.deleteEmailTemplate': 'Delete template',
    'emailTemplateDetail.duplicateEmailTemplate': 'Duplicate template',
    'emailTemplateDetail.testEmailTemplateVersion': 'Test version',
    'emailTemplateDetail.createEmailTemplateVersion': 'Add version',
    'emailTemplateDetail.saveEmailTemplateVersion': 'Save version',
    'emailTemplateDetail.activateEmailTemplateVersion': 'Activate version',
    'emailTemplateDetail.deleteEmailTemplateVersion': 'Delete version',
    'emailTemplateDetail.createEmailTemplate': 'Create template',
    'emailTemplateDetail.editEmailTemplate': 'Save template',
    'emailTemplateDetail.confirmSaveVersionTitle': 'Unsaved template changes will be lost',
    'emailTemplateDetail.confirmSaveVersionContent': 'Do you want to continue ?',
    'emailTemplateDetail.confirmSaveTemplateTitle': 'Unsaved version changes will be lost',
    'emailTemplateDetail.confirmSaveTemplateContent': 'Do you want to continue ?',
    'emailTemplateDetail.message.emailTemplateCreated': 'Template created',
    'emailTemplateDetail.message.emailTemplateUpdate': 'Template updated',
    'emailTemplateDetail.message.emailTemplateDeleted': 'Template deleted',
    'emailTemplateDetail.message.emailTemplateVersionCreated': 'Template version created',
    'emailTemplateDetail.message.emailTemplateVersionUpdate': 'Template version updated',
    'emailTemplateDetail.message.emailTemplateVersionDeleted': 'Template version deleted',
    'emailTemplateDetail.message.emailTemplateVersionActivated': 'Template version activated',
    'emailTemplateDetail.message.emailTemplateSendTestEmail': 'Test email send',

    'massEditProductDialog.ok': 'Save',

    'utils.batteryTypeCodes.no': 'No',
    'utils.batteryTypeCodes.device': 'Yes, in the device (PI967)',
    'utils.batteryTypeCodes.device_lr41': 'Yes, 1.5V LR41 Button cell in the device',
    'utils.batteryTypeCodes.package': 'Yes, part of the package (PI966)',

    issueReport: 'Issue report',

    'countries.at': 'Austria',
    'countries.be': 'Belgium',
    'countries.bg': 'Bulgaria',
    'countries.cz': 'Czech Republic',
    'countries.de': 'Germany',
    'countries.dk': 'Denmark',
    'countries.es': 'Spain',
    'countries.fi': 'Finland',
    'countries.fr': 'France',
    'countries.gr': 'Greece',
    'countries.hr': 'Croatia',
    'countries.hu': 'Hungary',
    'countries.it': 'Italy',
    'countries.lu': 'Luxembourg',
    'countries.nl': 'Netherlands',
    'countries.pl': 'Poland',
    'countries.pt': 'Portugal',
    'countries.ro': 'Romania',
    'countries.si': 'Slovenia',
    'countries.sk': 'Slovakia',

    'admin.egonRoutes': 'EGON services',
    'egonRoutes.title': 'EGON services',
    'egonRoutes.table.id': 'ID',
    'egonRoutes.table.shipper': 'Shipper',
    'egonRoutes.table.service': 'Service',
    'egonRoutes.table.country': 'Country',
    'egonRoutes.table.egonDelivery': 'EGON delivery',
    'egonRoutes.table.transferType': 'Transfer type',
    'egonRoutes.table.enabled': 'Enabled',
    'egonRoutes.table.note': 'Note',
    'egonRoutes.table.updatedAt': 'Updated',
    'egonRoutes.table.updatedBy': 'Updated by',
    'egonRoutes.action.createNew': 'Create EGON service',
    'egonRoutes.action.exportFile': 'Export file',
    'egonRoutes.action.exportFileName': 'egon-routes',
    'egonRoutes.action.synchronizeTable': 'Reload table',
    'egonRoutes.action.detail': 'EGON service detail',
    'egonRouteDetail.title': 'EGON service #{{idEgonRoute}}',
    'egonRouteDetail.titleNew': 'New EGON service',
    'egonRouteDetail.shipper': 'Shipper',
    'egonRouteDetail.service': 'Shipper service',
    'egonRouteDetail.countries': 'Countries',
    'egonRouteDetail.country': 'Country',
    'egonRouteDetail.delivery': 'EGON delivery',
    'egonRouteDetail.deliveryId': 'EGON delivery ID',
    'egonRouteDetail.deliveriesFailed': 'The list of EGON deliveries could not be loaded. Enter the EGON delivery ID manually.',
    'egonRouteDetail.transferType': 'Transfer type',
    'egonRouteDetail.enabled': 'Enabled',
    'egonRouteDetail.note': 'Note',
    'egonRouteDetail.create': 'Create',
    'egonRouteDetail.save': 'Save',
    'egonRouteDetail.delete': 'Delete',
    'egonRouteDetail.deleteConfirm': 'Do you really want to delete this EGON service?',
    'egonRouteDetail.message.created': 'EGON services have been created',
    'egonRouteDetail.message.updated': 'EGON service has been updated',
    'egonRouteDetail.message.deleted': 'EGON service has been deleted',
    'egonRouteDetail.message.conflictTitle': 'EGON service already exists',
    'egonRouteDetail.message.conflict': 'An EGON service already exists for the given service and country.',
    'egonRouteDetail.message.conflictCountries': 'An EGON service already exists for this service in countries: {{countries}}',
    'orders.table.shippingBackend': 'Shipped via',
    'orders.shippingBackend.egon': 'EGON',
    'orders.shippingBackend.skladon': 'Skladon',
    'orderDetail.egonBadge': 'Via EGON',
    'orderDetail.egonBadgeOrderId': 'EGON order: {{id}}',
    'orderDetail.egonBadgeStatus': 'Status: {{status}}',
    'orderDetail.egonBadgeStatusAt': 'Status time: {{date}}',
};

export default langObj;
